import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ISO8601Date: any;
  ISO8601DateTime: any;
  JSON: any;
};

/** Enum with ad systems */
export enum AdSystemT {
  GoogleAdsT = 'GOOGLE_ADS',
  MetaAdsT = 'META_ADS'
}

/** State of Ad system */
export enum AdSystemStateT {
  AccountSuspendedT = 'ACCOUNT_SUSPENDED',
  ActiveT = 'ACTIVE',
  NoCreditT = 'NO_CREDIT',
  NoProductsT = 'NO_PRODUCTS',
  PausedT = 'PAUSED',
  WizardT = 'WIZARD'
}

/** Autogenerated input type of AdminCancelMetaPageClaimRequest */
export type AdminCancelMetaPageClaimRequestInputT = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of AdminCancelMetaPageClaimRequest. */
export type AdminCancelMetaPageClaimRequestPayloadT = {
  __typename?: 'AdminCancelMetaPageClaimRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Whether the claim request was cleared */
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of AdminIncreaseCredit */
export type AdminIncreaseCreditInputT = {
  /** Payment amount */
  amount: Scalars['Float'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Payment currency */
  currency: CurrencyT;
};

/** Autogenerated return type of AdminIncreaseCredit. */
export type AdminIncreaseCreditPayloadT = {
  __typename?: 'AdminIncreaseCreditPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Organization */
  organization?: Maybe<OrganizationT>;
};

/** Autogenerated input type of AdminResendMetaPageClaimRequest */
export type AdminResendMetaPageClaimRequestInputT = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of AdminResendMetaPageClaimRequest. */
export type AdminResendMetaPageClaimRequestPayloadT = {
  __typename?: 'AdminResendMetaPageClaimRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Whether the request was re-enqueued */
  success?: Maybe<Scalars['Boolean']>;
};

/** Admin summary */
export type AdminSummaryT = {
  __typename?: 'AdminSummary';
  /** credit */
  credit: MoneyT;
  /** Organizations count */
  organizationsCount?: Maybe<Scalars['Int']>;
  /** spend */
  spend: MoneyT;
  /** spend by tarif */
  statsByMonth: Array<StatsByMonthT>;
  /** spend by tarif */
  statsByTarif: Array<StatsByTarifT>;
};


/** Admin summary */
export type AdminSummaryCreditArgsT = {
  dateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  dateTo: Scalars['ISO8601Date'];
};


/** Admin summary */
export type AdminSummaryOrganizationsCountArgsT = {
  state?: InputMaybe<OrganizationStateT>;
  wizardStep?: InputMaybe<WizardStepT>;
};


/** Admin summary */
export type AdminSummarySpendArgsT = {
  dateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  dateTo: Scalars['ISO8601Date'];
};


/** Admin summary */
export type AdminSummaryStatsByMonthArgsT = {
  dateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  dateTo: Scalars['ISO8601Date'];
};


/** Admin summary */
export type AdminSummaryStatsByTarifArgsT = {
  dateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  dateTo: Scalars['ISO8601Date'];
};

/** Asset Line */
export type AssetLineT = {
  __typename?: 'AssetLine';
  /** Ad System */
  adSystem: AdSystemT;
  /** Content */
  content: Scalars['String'];
  /** Draft State */
  draftState?: Maybe<AssetLineDraftStateT>;
  /** Is google disapproved */
  googleDisapproved: Scalars['Boolean'];
  /** Google Performance Label */
  googlePerformanceLabel?: Maybe<GooglePerformanceLabelT>;
  id: Scalars['ID'];
  /** Image Suggestion */
  imageSuggestion?: Maybe<ImageSuggestionT>;
  /** List of invalid symbols */
  invalidSymbols?: Maybe<Array<Scalars['String']>>;
  /** Asset line Kind */
  kind: AssetLineKindT;
  /** Suggestion */
  suggestion?: Maybe<SuggestionT>;
  /** Uploaded Image */
  uploadedImage?: Maybe<UploadedImageT>;
};

export enum AssetLineDraftStateT {
  CreateT = 'CREATE',
  DeleteT = 'DELETE'
}

/** AssetLine Kind */
export enum AssetLineKindT {
  BusinessNameT = 'BUSINESS_NAME',
  LandscapeLogoImageT = 'LANDSCAPE_LOGO_IMAGE',
  LogoImageT = 'LOGO_IMAGE',
  LongDescriptionT = 'LONG_DESCRIPTION',
  LongHeadlineT = 'LONG_HEADLINE',
  MarketingImageT = 'MARKETING_IMAGE',
  PortraitMarketingImageT = 'PORTRAIT_MARKETING_IMAGE',
  PrimaryTextT = 'PRIMARY_TEXT',
  ShortDescriptionT = 'SHORT_DESCRIPTION',
  ShortHeadlineT = 'SHORT_HEADLINE',
  SquareMarketingImageT = 'SQUARE_MARKETING_IMAGE',
  VideoT = 'VIDEO'
}

/** Audit Log */
export type AuditLogT = {
  __typename?: 'AuditLog';
  /** Ad system */
  adSystem?: Maybe<AdSystemT>;
  /** Change on Asset Line */
  assetLine?: Maybe<AssetLineT>;
  /** When change happened */
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  /** Audit log change message */
  message: Scalars['String'];
  /** Type of action */
  type: AuditLogsT;
  /** Email of user who made change */
  userEmail?: Maybe<Scalars['String']>;
};

/** Type of audit log */
export enum AuditLogsT {
  CampaignOptimizationT = 'CampaignOptimization',
  ChangeAudienceSignalsT = 'ChangeAudienceSignals',
  ChangeBiddingSchemeT = 'ChangeBiddingScheme',
  ChangeCampaignStateT = 'ChangeCampaignState',
  ChangeExtendedConversionsT = 'ChangeExtendedConversions',
  ChangeMonthlyBudgetT = 'ChangeMonthlyBudget',
  ChangeOrganizationDesignColorT = 'ChangeOrganizationDesignColor',
  CreditTransactionT = 'CreditTransaction',
  ExcludeCategoriesT = 'ExcludeCategories',
  PublishAssetLineT = 'PublishAssetLine',
  SelectCategoriesT = 'SelectCategories',
  SelectExcludedProductFlagsT = 'SelectExcludedProductFlags',
  TarifChangeT = 'TarifChange'
}

/** Bidding scheme of campaigns */
export enum BiddingSchemeT {
  MaximizeConversionsT = 'MaximizeConversions',
  MaximizeConversionsValueT = 'MaximizeConversionsValue'
}

/** Campaign Optimization */
export type CampaignOptimizationT = {
  __typename?: 'CampaignOptimization';
  /** Ad System */
  adSystem: AdSystemT;
  /** When change happened */
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  /** Applied optimization rule */
  rule: CampaignOptimizationRuleT;
  /** Type of action */
  type: CampaignOptimizationsT;
};

/** Campaign optimization rule applied */
export enum CampaignOptimizationRuleT {
  Aug17CatchupT = 'AUG17_CATCHUP',
  BudgetLimitedHighRoasT = 'BUDGET_LIMITED_HIGH_ROAS',
  BudgetLimitedLowRoasT = 'BUDGET_LIMITED_LOW_ROAS',
  EmergencyResetT = 'EMERGENCY_RESET',
  InitialOptimizationT = 'INITIAL_OPTIMIZATION',
  LowSpendHighRoasT = 'LOW_SPEND_HIGH_ROAS',
  LowSpendInZoneT = 'LOW_SPEND_IN_ZONE',
  LowSpendLowRoasT = 'LOW_SPEND_LOW_ROAS',
  LowSpendModerateRoasT = 'LOW_SPEND_MODERATE_ROAS',
  ManualT = 'MANUAL',
  OkSpendHighRoasT = 'OK_SPEND_HIGH_ROAS',
  OkSpendLowRoasT = 'OK_SPEND_LOW_ROAS',
  RollbackT = 'ROLLBACK',
  SwitchToMaximizeConversionsT = 'SWITCH_TO_MAXIMIZE_CONVERSIONS',
  UnknownT = 'UNKNOWN'
}

/** Type of campaign optimization */
export enum CampaignOptimizationsT {
  UpdateTargetRoasT = 'UpdateTargetRoas'
}

/** Category */
export type CategoryT = {
  __typename?: 'Category';
  /**
   * Is category excluded
   * @deprecated Use specific ad system field like `excluded_google_ads` instead
   */
  excluded: Scalars['Boolean'];
  /** Is category excluded for Google Ads */
  excludedGoogleAds: Scalars['Boolean'];
  /** Is category excluded for Meta Ads */
  excludedMetaAds: Scalars['Boolean'];
  /** Shoptet GUID */
  guid?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Name */
  name?: Maybe<Scalars['String']>;
  /** Shoptet Parent GUID */
  parentGuid?: Maybe<Scalars['String']>;
  /** Category Path */
  path?: Maybe<Scalars['String']>;
  /** Is category selected */
  selected?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of ChangeMonthlyBudget */
export type ChangeMonthlyBudgetInputT = {
  /** Ad system */
  adSystem?: AdSystemT;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Currency */
  currency: Scalars['String'];
  /** Monthly budget */
  monthlyBudget: Scalars['Float'];
};

/** Autogenerated return type of ChangeMonthlyBudget. */
export type ChangeMonthlyBudgetPayloadT = {
  __typename?: 'ChangeMonthlyBudgetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Organization */
  organization?: Maybe<OrganizationT>;
};

/** Autogenerated input type of ChangeOrganizationDesign */
export type ChangeOrganizationDesignInputT = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Override color 1 */
  overrideColor1?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ChangeOrganizationDesign. */
export type ChangeOrganizationDesignPayloadT = {
  __typename?: 'ChangeOrganizationDesignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Organization Design */
  organizationDesign?: Maybe<OrganizationDesignT>;
};

/** Autogenerated input type of CheckClaimPageApproval */
export type CheckClaimPageApprovalInputT = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CheckClaimPageApproval. */
export type CheckClaimPageApprovalPayloadT = {
  __typename?: 'CheckClaimPageApprovalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** ID of the enqueued job */
  jobId?: Maybe<Scalars['String']>;
  /** Whether the page claim has been approved */
  pageClaimApproved?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of CreateAssetLine */
export type CreateAssetLineInputT = {
  /** Ad System */
  adSystem?: InputMaybe<AdSystemT>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Content */
  content?: InputMaybe<Scalars['String']>;
  /** Is operation draft change */
  draft?: InputMaybe<Scalars['Boolean']>;
  /** Image Suggestion */
  imageSuggestionId?: InputMaybe<Scalars['String']>;
  /** Asset line Kind */
  kind: AssetLineKindT;
  /** Suggestion */
  suggestionId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateAssetLine. */
export type CreateAssetLinePayloadT = {
  __typename?: 'CreateAssetLinePayload';
  /** Asset Line */
  assetLine?: Maybe<AssetLineT>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Organization */
  organization?: Maybe<OrganizationT>;
};

/** Autogenerated input type of CreateImageAssetLine */
export type CreateImageAssetLineInputT = {
  /** Ad System */
  adSystem?: InputMaybe<AdSystemT>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Height of cropped area */
  cropHeight: Scalars['Int'];
  /** Width of cropped area */
  cropWidth: Scalars['Int'];
  /** X where to start crop */
  cropX: Scalars['Int'];
  /** Y where to start crop */
  cropY: Scalars['Int'];
  /** Is operation draft change */
  draft?: InputMaybe<Scalars['Boolean']>;
  /** Uploaded image id */
  uploadedImageId: Scalars['String'];
};

/** Autogenerated return type of CreateImageAssetLine. */
export type CreateImageAssetLinePayloadT = {
  __typename?: 'CreateImageAssetLinePayload';
  /** Asset Line */
  assetLine?: Maybe<AssetLineT>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Organization */
  organization?: Maybe<OrganizationT>;
  /** Uploaded image */
  uploadedImage?: Maybe<UploadedImageT>;
};

/** Credit Transaction */
export type CreditTransactionT = {
  __typename?: 'CreditTransaction';
  /** Ad System */
  adSystem?: Maybe<AdSystemT>;
  /** When transaction happened */
  createdAt: Scalars['ISO8601DateTime'];
  /** Credit */
  credit: MoneyT;
  /**
   * Date
   * @deprecated Use `created_at` instead.
   */
  date: Scalars['ISO8601Date'];
  id: Scalars['ID'];
  /** Kind of transaction */
  kind: CreditTransactionKindT;
  /** Spend */
  spend: MoneyT;
  /** Used Credit */
  usedCredit: MoneyT;
  /** Used Spend */
  usedSpend: MoneyT;
};

/** Credit Transaction - Kind */
export enum CreditTransactionKindT {
  CurrencyExchangeDecreaseT = 'CURRENCY_EXCHANGE_DECREASE',
  CurrencyExchangeIncreaseT = 'CURRENCY_EXCHANGE_INCREASE',
  DecreaseT = 'DECREASE',
  IncreaseT = 'INCREASE',
  OverchargeT = 'OVERCHARGE',
  TarifExchangeDecreaseT = 'TARIF_EXCHANGE_DECREASE',
  TarifExchangeIncreaseT = 'TARIF_EXCHANGE_INCREASE',
  UsageT = 'USAGE'
}

/** Currency */
export enum CurrencyT {
  AudT = 'AUD',
  BgnT = 'BGN',
  BrlT = 'BRL',
  CadT = 'CAD',
  ChfT = 'CHF',
  CnyT = 'CNY',
  CzkT = 'CZK',
  DkkT = 'DKK',
  EurT = 'EUR',
  GbpT = 'GBP',
  HkdT = 'HKD',
  HrkT = 'HRK',
  HufT = 'HUF',
  IdrT = 'IDR',
  IlsT = 'ILS',
  InrT = 'INR',
  IskT = 'ISK',
  JpyT = 'JPY',
  KrwT = 'KRW',
  MxnT = 'MXN',
  MyrT = 'MYR',
  NokT = 'NOK',
  NzdT = 'NZD',
  PhpT = 'PHP',
  PlnT = 'PLN',
  RonT = 'RON',
  RubT = 'RUB',
  SekT = 'SEK',
  SgdT = 'SGD',
  ThbT = 'THB',
  TryT = 'TRY',
  UahT = 'UAH',
  UsdT = 'USD',
  VndT = 'VND',
  XdrT = 'XDR',
  ZarT = 'ZAR'
}

/** Enum with options for days ago query */
export enum DaysAgoT {
  Last_1DayT = 'LAST_1_DAY',
  Last_7DaysT = 'LAST_7_DAYS',
  Last_30DaysT = 'LAST_30_DAYS'
}

/** Autogenerated input type of DecreaseCredit */
export type DecreaseCreditInputT = {
  /** Payment amount */
  amount: Scalars['Float'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Payment currency */
  currency: CurrencyT;
};

/** Autogenerated return type of DecreaseCredit. */
export type DecreaseCreditPayloadT = {
  __typename?: 'DecreaseCreditPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Returns new credit balance */
  creditBalance?: Maybe<MoneyT>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of DeleteAssetLine */
export type DeleteAssetLineInputT = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Is operation draft change */
  draft?: InputMaybe<Scalars['Boolean']>;
  /** Content */
  id: Scalars['String'];
};

/** Autogenerated return type of DeleteAssetLine. */
export type DeleteAssetLinePayloadT = {
  __typename?: 'DeleteAssetLinePayload';
  /** Asset Line */
  assetLine?: Maybe<AssetLineT>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Organization */
  organization?: Maybe<OrganizationT>;
};

/** Autogenerated input type of DisapproveSuggestion */
export type DisapproveSuggestionInputT = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Content */
  id: Scalars['String'];
};

/** Autogenerated return type of DisapproveSuggestion. */
export type DisapproveSuggestionPayloadT = {
  __typename?: 'DisapproveSuggestionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Image Suggestion */
  imageSuggestion?: Maybe<ImageSuggestionT>;
  /** Text Suggestion */
  suggestion?: Maybe<SuggestionT>;
};

/** Autogenerated input type of DiscardDraftAssetLines */
export type DiscardDraftAssetLinesInputT = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Array of kinds to discard, when empty - discard all kinds */
  kinds?: InputMaybe<Array<AssetLineKindT>>;
};

/** Autogenerated return type of DiscardDraftAssetLines. */
export type DiscardDraftAssetLinesPayloadT = {
  __typename?: 'DiscardDraftAssetLinesPayload';
  /** Discarderd Asset Lines */
  assetLines?: Maybe<Array<AssetLineT>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Organization */
  organization?: Maybe<OrganizationT>;
};

/** Autogenerated input type of ExcludeCategories */
export type ExcludeCategoriesInputT = {
  /** Ad system for which product flags are excluded */
  adSystem?: AdSystemT;
  /** Category IDs to be excluded */
  categoryIds: Array<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ExcludeCategories. */
export type ExcludeCategoriesPayloadT = {
  __typename?: 'ExcludeCategoriesPayload';
  /** Modified Categories */
  categories: Array<CategoryT>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Organization */
  organization?: Maybe<OrganizationT>;
};

/** Autogenerated input type of ExcludeProductFlags */
export type ExcludeProductFlagsInputT = {
  /** Ad system for which product flags are excluded */
  adSystem?: InputMaybe<AdSystemT>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Product Flag IDs to be excluded */
  productFlagIds: Array<Scalars['String']>;
};

/** Autogenerated return type of ExcludeProductFlags. */
export type ExcludeProductFlagsPayloadT = {
  __typename?: 'ExcludeProductFlagsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Organization */
  organization?: Maybe<OrganizationT>;
  /** Modified Product Flags */
  productFlags: Array<ProductFlagT>;
};

/** Feature Flag */
export enum FeatureFlagT {
  MetaCampaignsT = 'META_CAMPAIGNS'
}

/** GMC Issue */
export type GmcIssueT = {
  __typename?: 'GMCIssue';
  /** Count of affected products */
  count: Scalars['Int'];
  id: Scalars['ID'];
  /** Name */
  name: Scalars['String'];
  /** Issue severity */
  severity: GmcIssueSeverityT;
};

/** Severity of GMC Issue */
export enum GmcIssueSeverityT {
  ErrorT = 'ERROR',
  WarningT = 'WARNING'
}

/** Autogenerated input type of GoogleAdsChangeSettings */
export type GoogleAdsChangeSettingsInputT = {
  /** Audience signals */
  audienceSignals?: InputMaybe<Scalars['Boolean']>;
  /** Bidding scheme */
  biddingScheme?: InputMaybe<BiddingSchemeT>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Extended conversions */
  extendedConversions?: InputMaybe<Scalars['Boolean']>;
  /** New State of campaign */
  state?: InputMaybe<AdSystemStateT>;
};

/** Autogenerated return type of GoogleAdsChangeSettings. */
export type GoogleAdsChangeSettingsPayloadT = {
  __typename?: 'GoogleAdsChangeSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Organization */
  organization?: Maybe<OrganizationT>;
};

/** Google Ads Setting */
export type GoogleAdsSettingT = {
  __typename?: 'GoogleAdsSetting';
  /** Adwords customer ID */
  adwordsCustomerId?: Maybe<Scalars['String']>;
  /** Audience signals */
  audienceSignals: Scalars['Boolean'];
  /** Bidding scheme */
  biddingScheme: BiddingSchemeT;
  /** Extended conversions */
  extendedConversions: Scalars['Boolean'];
  /** GMC ID */
  gmcId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Campaign in learning state */
  learningState: Scalars['Boolean'];
  /** Monthly budget */
  monthlyBudget: MoneyT;
  /** Optimizations enabled */
  optimizationsEnabled: Scalars['Boolean'];
  /** Campaign start date */
  startedAt?: Maybe<Scalars['ISO8601Date']>;
  /** State */
  state?: Maybe<AdSystemStateT>;
  /** Current wizard step */
  wizardStep: WizardStepT;
};

/** Google Performance Label */
export enum GooglePerformanceLabelT {
  BestT = 'BEST',
  GoodT = 'GOOD',
  LearningT = 'LEARNING',
  LowT = 'LOW',
  PendingT = 'PENDING',
  UnknownT = 'UNKNOWN',
  UnspecifiedT = 'UNSPECIFIED'
}

/** Image Suggestion */
export type ImageSuggestionT = {
  __typename?: 'ImageSuggestion';
  /** Number of approved asset lines */
  assetLineCount: Scalars['Int'];
  /** Disapproved at */
  disapprovedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** SVG height */
  height: Scalars['Int'];
  id: Scalars['ID'];
  /** Kind of template */
  kind: ImageSuggestionKindT;
  /** Name of template */
  name: Scalars['String'];
  /** SVG content */
  svg: Scalars['String'];
  /** SVG image link */
  svgLink: Scalars['String'];
  /** SVG width */
  width: Scalars['Int'];
};

export enum ImageSuggestionKindT {
  MarketingImageT = 'MARKETING_IMAGE',
  PortraitMarketingImageT = 'PORTRAIT_MARKETING_IMAGE',
  SquareMarketingImageT = 'SQUARE_MARKETING_IMAGE'
}

/** Image Suggestion Request */
export type ImageSuggestionRequestT = {
  __typename?: 'ImageSuggestionRequest';
  /** can ask for more images */
  canFetchMore: Scalars['Boolean'];
  /** Created at */
  createdAt: Scalars['ISO8601DateTime'];
  /** Eshop data */
  eshopData: Scalars['JSON'];
  id: Scalars['ID'];
  /** Suggestions */
  imageSuggestions: Array<ImageSuggestionT>;
  /** is request in progress */
  inProgress: Scalars['Boolean'];
  /** Organization */
  organization: OrganizationT;
};

/** Autogenerated input type of InitiatePayment */
export type InitiatePaymentInputT = {
  /** Payment amount */
  amount: Scalars['Float'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Payment currency */
  currency: CurrencyT;
  /** Where to return user to after payment */
  returnUrl?: InputMaybe<Scalars['String']>;
  /** Ad system to start campaign for */
  startCampaignFor?: InputMaybe<AdSystemT>;
};

/** Autogenerated return type of InitiatePayment. */
export type InitiatePaymentPayloadT = {
  __typename?: 'InitiatePaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Returns new payment */
  payment?: Maybe<PaymentT>;
};

/** Autogenerated input type of LeaveWizard */
export type LeaveWizardInputT = {
  /** Ad system whose wizard is left */
  adSystem: AdSystemT;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of LeaveWizard. */
export type LeaveWizardPayloadT = {
  __typename?: 'LeaveWizardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Organization */
  organization?: Maybe<OrganizationT>;
};

/** Autogenerated input type of MetaAdsChangeSettings */
export type MetaAdsChangeSettingsInputT = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Meta Page ID */
  pageId?: InputMaybe<Scalars['String']>;
  /** New State of campaign */
  state?: InputMaybe<AdSystemStateT>;
};

/** Autogenerated return type of MetaAdsChangeSettings. */
export type MetaAdsChangeSettingsPayloadT = {
  __typename?: 'MetaAdsChangeSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Meta Ads Setting */
  metaAdsSetting?: Maybe<MetaAdsSettingT>;
  /** Organization */
  organization?: Maybe<OrganizationT>;
};

/** Meta Ads Setting */
export type MetaAdsSettingT = {
  __typename?: 'MetaAdsSetting';
  /** Meta Ads Account ID */
  adAccountId?: Maybe<Scalars['String']>;
  /** Meta Ad Account status */
  adAccountStatus?: Maybe<Scalars['String']>;
  /** Since when Meta blocks the ad set pending advertiser verification */
  advertiserVerificationPendingSince?: Maybe<Scalars['ISO8601DateTime']>;
  /** Meta Business Manager ID */
  businessId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Campaign in learning state */
  learningState: Scalars['Boolean'];
  /** Monthly budget */
  monthlyBudget: MoneyT;
  /** Optimizations enabled */
  optimizationsEnabled: Scalars['Boolean'];
  /** Indicates if the page claim has been approved */
  pageClaimApproved: Scalars['Boolean'];
  /** Reason why the page claim request failed */
  pageClaimFailureReason?: Maybe<Scalars['String']>;
  /** When the page claim was requested */
  pageClaimRequestedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Page ID */
  pageId?: Maybe<Scalars['String']>;
  /** Campaign start date */
  startedAt?: Maybe<Scalars['ISO8601Date']>;
  /** State */
  state?: Maybe<AdSystemStateT>;
  /** Indicates if a user has been assigned to the page */
  userAssignedToPage: Scalars['Boolean'];
  /** Current wizard step */
  wizardStep: MetaAdsWizardStepT;
};

/** Wizard steps of Meta Ads Setting */
export enum MetaAdsWizardStepT {
  DashboardT = 'DASHBOARD',
  MetaBudgetT = 'META_BUDGET',
  MetaFinishT = 'META_FINISH',
  MetaFirstT = 'META_FIRST',
  MetaPageLinkingT = 'META_PAGE_LINKING',
  MetaProductsSelectionT = 'META_PRODUCTS_SELECTION',
  MetaTextSelectionT = 'META_TEXT_SELECTION'
}

/** Whether products are missing shipping configuration in GMC */
export enum MissingShippingStatusT {
  AllProductsT = 'ALL_PRODUCTS',
  NoneT = 'NONE',
  SomeProductsT = 'SOME_PRODUCTS'
}

/** Money type */
export type MoneyT = {
  __typename?: 'Money';
  /** Amount */
  amount?: Maybe<Scalars['Float']>;
  /** Currency */
  currency?: Maybe<CurrencyT>;
};

/** Represents mutation */
export type MutationT = {
  __typename?: 'Mutation';
  /** Clear Meta page claim request state */
  adminCancelMetaPageClaimRequest?: Maybe<AdminCancelMetaPageClaimRequestPayloadT>;
  /** Increase demo credit */
  adminIncreaseCredit?: Maybe<AdminIncreaseCreditPayloadT>;
  /** Reset Meta page claim state and re-enqueue claim request */
  adminResendMetaPageClaimRequest?: Maybe<AdminResendMetaPageClaimRequestPayloadT>;
  /**
   * Change campaign settings
   * @deprecated Use SetGoogleAdsWizardStep mutation instead
   */
  changeCampaignSettings?: Maybe<GoogleAdsChangeSettingsPayloadT>;
  /** Change Google ads settings */
  changeGoogleAdsSettings?: Maybe<GoogleAdsChangeSettingsPayloadT>;
  /** Change Meta ads settings */
  changeMetaAdsSettings?: Maybe<MetaAdsChangeSettingsPayloadT>;
  /** Change monthly budget */
  changeMonthlyBudget?: Maybe<ChangeMonthlyBudgetPayloadT>;
  /** Change Organization Design */
  changeOrganizationDesign?: Maybe<ChangeOrganizationDesignPayloadT>;
  /** Check Meta ads claim page approval */
  checkMetaAdsClaimPageApproval?: Maybe<CheckClaimPageApprovalPayloadT>;
  /** Create new asset line */
  createAssetLine?: Maybe<CreateAssetLinePayloadT>;
  /** Create new asset line from Uploaded Image */
  createImageAssetLine?: Maybe<CreateImageAssetLinePayloadT>;
  /** Decrease credit */
  decreaseCredit?: Maybe<DecreaseCreditPayloadT>;
  /** Delete existing asset line */
  deleteAssetLine?: Maybe<DeleteAssetLinePayloadT>;
  /** Disapprove suggestion */
  disapproveSuggestion?: Maybe<DisapproveSuggestionPayloadT>;
  /** Takes all draft asset lines and discards them */
  discardDraftAssetLines?: Maybe<DiscardDraftAssetLinesPayloadT>;
  /** Exclude Categories for organization */
  excludeCategories?: Maybe<ExcludeCategoriesPayloadT>;
  /** Exlude Product flags for organization */
  excludeProductFlags?: Maybe<ExcludeProductFlagsPayloadT>;
  /** Prepare new payment and get shoptet pay url */
  initiatePayment?: Maybe<InitiatePaymentPayloadT>;
  /** Leave the campaign wizard and return to the platform selection */
  leaveWizard?: Maybe<LeaveWizardPayloadT>;
  /** Takes all draft asset lines and publishes them */
  publishDraftAssetLines?: Maybe<PublishDraftAssetLinesPayloadT>;
  /** Removes disapproved asset lines */
  removeDisapprovedAssetLines?: Maybe<RemoveDisapprovedAssetLinesPayloadT>;
  /** Request additional suggestions */
  requestAdditionalSuggestion?: Maybe<RequestAdditionalSuggestionPayloadT>;
  /** Request new image suggestions */
  requestNewImageSuggestion?: Maybe<RequestNewImageSuggestionPayloadT>;
  /** Request new suggestions */
  requestNewSuggestion?: Maybe<RequestNewSuggestionPayloadT>;
  /** Restore draft remove asset line */
  restoreDraftRemoveAssetLine?: Maybe<RestoreDraftRemoveAssetLinePayloadT>;
  /** Select Categories for organization */
  selectCategories?: Maybe<SelectCategoriesPayloadT>;
  /** Set Google Ads wizard step */
  setGoogleAdsWizardStep?: Maybe<SetGoogleAdsWizardStepPayloadT>;
  /** Set Meta Ads wizard step */
  setMetaAdsWizardStep?: Maybe<SetMetaAdsWizardStepPayloadT>;
  /** Set labels for organization */
  setOrganizationLabels?: Maybe<SetOrganizationLabelsPayloadT>;
  /** Set note for organization */
  setOrganizationNote?: Maybe<SetOrganizationNotePayloadT>;
  /**
   * Set current wizard step
   * @deprecated Use SetGoogleAdsWizardStep mutation instead
   */
  setWizardStep?: Maybe<SetGoogleAdsWizardStepPayloadT>;
  /** Start synchronization of campaign */
  startSynchronization?: Maybe<StartSynchronizationPayloadT>;
  /** Update Organization */
  updateOrganization?: Maybe<UpdateOrganizationPayloadT>;
  /** Upload Image */
  uploadImage?: Maybe<UploadImagePayloadT>;
};


/** Represents mutation */
export type MutationAdminCancelMetaPageClaimRequestArgsT = {
  input: AdminCancelMetaPageClaimRequestInputT;
};


/** Represents mutation */
export type MutationAdminIncreaseCreditArgsT = {
  input: AdminIncreaseCreditInputT;
};


/** Represents mutation */
export type MutationAdminResendMetaPageClaimRequestArgsT = {
  input: AdminResendMetaPageClaimRequestInputT;
};


/** Represents mutation */
export type MutationChangeCampaignSettingsArgsT = {
  input: GoogleAdsChangeSettingsInputT;
};


/** Represents mutation */
export type MutationChangeGoogleAdsSettingsArgsT = {
  input: GoogleAdsChangeSettingsInputT;
};


/** Represents mutation */
export type MutationChangeMetaAdsSettingsArgsT = {
  input: MetaAdsChangeSettingsInputT;
};


/** Represents mutation */
export type MutationChangeMonthlyBudgetArgsT = {
  input: ChangeMonthlyBudgetInputT;
};


/** Represents mutation */
export type MutationChangeOrganizationDesignArgsT = {
  input: ChangeOrganizationDesignInputT;
};


/** Represents mutation */
export type MutationCheckMetaAdsClaimPageApprovalArgsT = {
  input: CheckClaimPageApprovalInputT;
};


/** Represents mutation */
export type MutationCreateAssetLineArgsT = {
  input: CreateAssetLineInputT;
};


/** Represents mutation */
export type MutationCreateImageAssetLineArgsT = {
  input: CreateImageAssetLineInputT;
};


/** Represents mutation */
export type MutationDecreaseCreditArgsT = {
  input: DecreaseCreditInputT;
};


/** Represents mutation */
export type MutationDeleteAssetLineArgsT = {
  input: DeleteAssetLineInputT;
};


/** Represents mutation */
export type MutationDisapproveSuggestionArgsT = {
  input: DisapproveSuggestionInputT;
};


/** Represents mutation */
export type MutationDiscardDraftAssetLinesArgsT = {
  input: DiscardDraftAssetLinesInputT;
};


/** Represents mutation */
export type MutationExcludeCategoriesArgsT = {
  input: ExcludeCategoriesInputT;
};


/** Represents mutation */
export type MutationExcludeProductFlagsArgsT = {
  input: ExcludeProductFlagsInputT;
};


/** Represents mutation */
export type MutationInitiatePaymentArgsT = {
  input: InitiatePaymentInputT;
};


/** Represents mutation */
export type MutationLeaveWizardArgsT = {
  input: LeaveWizardInputT;
};


/** Represents mutation */
export type MutationPublishDraftAssetLinesArgsT = {
  input: PublishDraftAssetLinesInputT;
};


/** Represents mutation */
export type MutationRemoveDisapprovedAssetLinesArgsT = {
  input: RemoveDisapprovedAssetLinesInputT;
};


/** Represents mutation */
export type MutationRequestAdditionalSuggestionArgsT = {
  input: RequestAdditionalSuggestionInputT;
};


/** Represents mutation */
export type MutationRequestNewImageSuggestionArgsT = {
  input: RequestNewImageSuggestionInputT;
};


/** Represents mutation */
export type MutationRequestNewSuggestionArgsT = {
  input: RequestNewSuggestionInputT;
};


/** Represents mutation */
export type MutationRestoreDraftRemoveAssetLineArgsT = {
  input: RestoreDraftRemoveAssetLineInputT;
};


/** Represents mutation */
export type MutationSelectCategoriesArgsT = {
  input: SelectCategoriesInputT;
};


/** Represents mutation */
export type MutationSetGoogleAdsWizardStepArgsT = {
  input: SetGoogleAdsWizardStepInputT;
};


/** Represents mutation */
export type MutationSetMetaAdsWizardStepArgsT = {
  input: SetMetaAdsWizardStepInputT;
};


/** Represents mutation */
export type MutationSetOrganizationLabelsArgsT = {
  input: SetOrganizationLabelsInputT;
};


/** Represents mutation */
export type MutationSetOrganizationNoteArgsT = {
  input: SetOrganizationNoteInputT;
};


/** Represents mutation */
export type MutationSetWizardStepArgsT = {
  input: SetGoogleAdsWizardStepInputT;
};


/** Represents mutation */
export type MutationStartSynchronizationArgsT = {
  input: StartSynchronizationInputT;
};


/** Represents mutation */
export type MutationUpdateOrganizationArgsT = {
  input: UpdateOrganizationInputT;
};


/** Represents mutation */
export type MutationUploadImageArgsT = {
  input: UploadImageInputT;
};

/** Enum with directions for ordering */
export enum OrderDirectionT {
  AscT = 'ASC',
  DescT = 'DESC'
}

/** Organization */
export type OrganizationT = {
  __typename?: 'Organization';
  /** Asset Lines only active */
  activeAssetLines: Array<AssetLineT>;
  /** Count of all active assets */
  activeAssetsCount: Scalars['Int'];
  /** Image Asset Lines only active images */
  activeImagesAssetLines: Array<AssetLineT>;
  /** Text Asset Lines only active texts */
  activeTextsAssetLines: Array<AssetLineT>;
  /** Admin api token */
  adminApiToken?: Maybe<Scalars['String']>;
  /** Admin app path */
  adminAppPath?: Maybe<Scalars['String']>;
  /**
   * Adwords customer ID
   * @deprecated Use google_ads_setting.adwords_customer_id instead
   */
  adwordsCustomerId?: Maybe<Scalars['String']>;
  /** Count of products banned for any ad system */
  allBannedProductsCount: Scalars['Int'];
  /** Percentage of products banned for any ad system */
  allBannedProductsPercentage: Scalars['Float'];
  /** When organization was archived */
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Asset Lines */
  assetLines: Array<AssetLineT>;
  /**
   * Audience signals
   * @deprecated Use google_ads_setting.audience_signals instead
   */
  audienceSignals: Scalars['Boolean'];
  /** Audit Logs */
  auditLogs: Array<AuditLogT>;
  /** Total count of Audit Logs */
  auditLogsCount: Scalars['Int'];
  /** Count of banned products for given ad system */
  bannedProductsCount: Scalars['Int'];
  /** Percentage of banned products for given ad system */
  bannedProductsPercentage: Scalars['Float'];
  /**
   * Bidding scheme
   * @deprecated Use google_ads_setting.bidding_scheme instead
   */
  biddingScheme: BiddingSchemeT;
  /** All time bought credits */
  boughtCredits: MoneyT;
  /** Campaign Optimizations */
  campaignOptimizations: Array<CampaignOptimizationT>;
  /** All categories */
  categories: Array<CategoryT>;
  /** All categories count */
  categoriesCount: Scalars['Int'];
  /** Organization category */
  category?: Maybe<OrganizationCategoryT>;
  /** Timestamp of consultation request */
  consultationRequestedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** When organization was created */
  createdAt?: Maybe<Scalars['ISO8601Date']>;
  /** Credit balance */
  creditBalance: MoneyT;
  /** Credit Transactions */
  creditTransactions: Array<CreditTransactionT>;
  /** Total count of Credit Transactions */
  creditTransactionsCount: Scalars['Int'];
  /** Credits for day */
  dailyCredits: MoneyT;
  /** Count of all disapproved assets */
  disapprovedAssetsCount: Scalars['Int'];
  /** dotidot id */
  dotidotId?: Maybe<Scalars['String']>;
  /** List of enabled feature flags */
  enabledFeatureFlags: Array<FeatureFlagT>;
  /** Count of all exluded by category products */
  excludedCategoriesProductsCount: Scalars['Int'];
  /** Count of all excluded by product flag products */
  excludedProductFlagsProductsCount: Scalars['Int'];
  /** Count of all excluded products (all reasons) */
  excludedProductsCount: Scalars['Int'];
  /**
   * Extended conversions
   * @deprecated Use google_ads_setting.extended_conversions instead
   */
  extendedConversions: Scalars['Boolean'];
  /** GMC account is suspended */
  gmcAccountSuspended: Scalars['Boolean'];
  /**
   * GMC ID
   * @deprecated Use google_ads_setting.gmc_id instead
   */
  gmcId?: Maybe<Scalars['String']>;
  /** List of All GMC Issues */
  gmcIssues: Array<GmcIssueT>;
  /** Google Ads Setting */
  googleAdsSetting?: Maybe<GoogleAdsSettingT>;
  /** Google Shopping destination is suspended in GMC */
  googleShoppingSuspended: Scalars['Boolean'];
  id: Scalars['ID'];
  /** Image Suggestions */
  imageSuggestions?: Maybe<Array<ImageSuggestionT>>;
  /** Admin labels */
  labels: Array<Scalars['String']>;
  /** Image Suggestion requests last 5 */
  lastImageSuggestionRequests: Array<ImageSuggestionRequestT>;
  /** Suggestion requests last 5 */
  lastSuggestionRequests: Array<SuggestionRequestT>;
  /** Meta ads account is suspended */
  metaAdsAccountSuspended: Scalars['Boolean'];
  /** Meta Ads Setting */
  metaAdsSetting?: Maybe<MetaAdsSettingT>;
  /** Products missing shipping configuration (Google/GMC) */
  missingShippingStatus: MissingShippingStatusT;
  /**
   * Monthly budget
   * @deprecated Use google_ads_setting.monthly_budget instead
   */
  monthlyBudget: MoneyT;
  /** Name */
  name: Scalars['String'];
  /** Image Asset Lines not_deleted with drafts */
  notDeletedImagesAssetLines: Array<AssetLineT>;
  /** Text Asset Lines not_deleted with drafts */
  notDeletedTextsAssetLines: Array<AssetLineT>;
  /** Returns steps thats needs to be done before wizard can start */
  notReadySteps: Array<OrganizationNotReadyStepsT>;
  /** Note for organization */
  note?: Maybe<Scalars['String']>;
  /** OrganizationDesignType */
  organizationDesign?: Maybe<OrganizationDesignT>;
  /** Count of all out of stock products */
  outOfStockProductsCount: Scalars['Int'];
  /** List of payments */
  payments: Array<PaymentT>;
  /** Credit withdrawal pending */
  pendingCreditWithdrawal: Scalars['Boolean'];
  /** Performance Stats */
  performanceStats: Array<PerformanceStatT>;
  /** All product flags */
  productFlags: Array<ProductFlagT>;
  /** All product flags count */
  productFlagsCount: Scalars['Int'];
  /** All products for organization */
  products: Array<ProductT>;
  /** Count of all products */
  productsCount: Scalars['Int'];
  /** State of number of products */
  productsCountState?: Maybe<ProductsCountStateT>;
  /** Count of all products to be synchronized during first import */
  productsCountToSynchronize: Scalars['Int'];
  /** Properties */
  properties: Scalars['JSON'];
  /** Recommended big credits increase amount */
  recommendedCreditIncreaseBig: MoneyT;
  /** Recommended small credits increase amount */
  recommendedCreditIncreaseSmall: MoneyT;
  /** Recommended monthly budget */
  recommendedMonthlyBudget: MoneyT;
  /** Approximate number of days until credit runs out */
  remainingCreditDays: Scalars['Int'];
  /** Approximate number of days until credit runs out once all set up campaigns run */
  remainingCreditDaysAfterStart: Scalars['Int'];
  /** Ad systems whose budget the credit runway counts */
  runningAdSystems: Array<AdSystemT>;
  /** Count of all selectable products */
  selectableProductsCount: Scalars['Int'];
  /** Best products non excluded */
  selectedProducts: Array<ProductT>;
  /** shoptet category */
  shoptetCategory?: Maybe<Scalars['String']>;
  /** shoptet eshop name */
  shoptetEshopName?: Maybe<Scalars['String']>;
  /** shoptet id */
  shoptetId?: Maybe<Scalars['String']>;
  /** shoptet url */
  shoptetUrl?: Maybe<Scalars['String']>;
  /**
   * Show learning banner for organization
   * @deprecated Use ad system learning_state instead
   */
  showLearningBanner: Scalars['Boolean'];
  /** Spend balance */
  spendBalance?: Maybe<MoneyT>;
  /**
   * When organization started campaigns
   * @deprecated Use google_ads_setting.started_at instead
   */
  startedAt?: Maybe<Scalars['ISO8601Date']>;
  /**
   * State
   * @deprecated Use ad system state instead
   */
  state?: Maybe<OrganizationStateT>;
  /** Suggestion requests */
  suggestionRequests?: Maybe<Array<SuggestionRequestT>>;
  /** Summary stats for organization */
  summaryStats: StatsT;
  /** Text Suggestions */
  textSuggestions?: Maybe<Array<SuggestionT>>;
  /** Used credits by campaign */
  usedCredits: MoneyT;
  /** Used spend by campaign */
  usedSpend?: Maybe<MoneyT>;
  /** Count of all not banned in_stock products */
  validInStockProductsCount: Scalars['Int'];
  /** Image Asset draft validation */
  validateDraftImages: ValidationResultT;
  /** Text Asset draft validation */
  validateDraftTexts: ValidationResultT;
  /** Image Asset validation */
  validateImages: ValidationResultT;
  /** Text Asset validation */
  validateTexts: ValidationResultT;
  /**
   * Organization current step in wizard
   * @deprecated Use google_ads_setting.wizard_step instead
   */
  wizardStep: WizardStepT;
};


/** Organization */
export type OrganizationActiveAssetLinesArgsT = {
  adSystem?: InputMaybe<AdSystemT>;
};


/** Organization */
export type OrganizationActiveImagesAssetLinesArgsT = {
  adSystem?: InputMaybe<AdSystemT>;
};


/** Organization */
export type OrganizationActiveTextsAssetLinesArgsT = {
  adSystem?: InputMaybe<AdSystemT>;
};


/** Organization */
export type OrganizationAssetLinesArgsT = {
  adSystem?: InputMaybe<AdSystemT>;
};


/** Organization */
export type OrganizationAuditLogsArgsT = {
  adSystem?: InputMaybe<AdSystemT>;
  dateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  dateTo: Scalars['ISO8601Date'];
  limit: Scalars['Int'];
  page: Scalars['Int'];
  type?: InputMaybe<AuditLogsT>;
  userEmail?: InputMaybe<Scalars['String']>;
};


/** Organization */
export type OrganizationAuditLogsCountArgsT = {
  adSystem?: InputMaybe<AdSystemT>;
  dateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  dateTo: Scalars['ISO8601Date'];
  type?: InputMaybe<AuditLogsT>;
  userEmail?: InputMaybe<Scalars['String']>;
};


/** Organization */
export type OrganizationBannedProductsCountArgsT = {
  adSystem?: AdSystemT;
};


/** Organization */
export type OrganizationBannedProductsPercentageArgsT = {
  adSystem?: AdSystemT;
};


/** Organization */
export type OrganizationCampaignOptimizationsArgsT = {
  adSystem?: InputMaybe<AdSystemT>;
  dateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  dateTo: Scalars['ISO8601Date'];
  limit: Scalars['Int'];
  page: Scalars['Int'];
};


/** Organization */
export type OrganizationCreditTransactionsArgsT = {
  adSystem?: InputMaybe<AdSystemT>;
  dateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  dateTo: Scalars['ISO8601Date'];
  kinds?: InputMaybe<Array<CreditTransactionKindT>>;
  limit: Scalars['Int'];
  page: Scalars['Int'];
};


/** Organization */
export type OrganizationCreditTransactionsCountArgsT = {
  adSystem?: InputMaybe<AdSystemT>;
  dateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  dateTo: Scalars['ISO8601Date'];
  kinds?: InputMaybe<Array<CreditTransactionKindT>>;
};


/** Organization */
export type OrganizationExcludedCategoriesProductsCountArgsT = {
  adSystem?: AdSystemT;
};


/** Organization */
export type OrganizationExcludedProductFlagsProductsCountArgsT = {
  adSystem?: AdSystemT;
};


/** Organization */
export type OrganizationExcludedProductsCountArgsT = {
  adSystem?: AdSystemT;
};


/** Organization */
export type OrganizationImageSuggestionsArgsT = {
  kind?: InputMaybe<ImageSuggestionKindT>;
  limit?: InputMaybe<Scalars['Int']>;
};


/** Organization */
export type OrganizationLastImageSuggestionRequestsArgsT = {
  limit?: InputMaybe<Scalars['Int']>;
};


/** Organization */
export type OrganizationLastSuggestionRequestsArgsT = {
  kind: SuggestionKindT;
  limit?: InputMaybe<Scalars['Int']>;
};


/** Organization */
export type OrganizationNotDeletedImagesAssetLinesArgsT = {
  adSystem?: InputMaybe<AdSystemT>;
};


/** Organization */
export type OrganizationNotDeletedTextsAssetLinesArgsT = {
  adSystem?: InputMaybe<AdSystemT>;
};


/** Organization */
export type OrganizationPaymentsArgsT = {
  limit: Scalars['Int'];
  page: Scalars['Int'];
  startCampaignFor?: InputMaybe<AdSystemT>;
};


/** Organization */
export type OrganizationPerformanceStatsArgsT = {
  adSystem?: InputMaybe<AdSystemT>;
  dateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  dateTo: Scalars['ISO8601Date'];
};


/** Organization */
export type OrganizationProductsArgsT = {
  gmcIssueId?: InputMaybe<Scalars['ID']>;
  limit: Scalars['Int'];
  page: Scalars['Int'];
};


/** Organization */
export type OrganizationRemainingCreditDaysArgsT = {
  launching?: InputMaybe<Array<AdSystemT>>;
};


/** Organization */
export type OrganizationRunningAdSystemsArgsT = {
  launching?: InputMaybe<Array<AdSystemT>>;
};


/** Organization */
export type OrganizationSelectableProductsCountArgsT = {
  adSystem?: AdSystemT;
};


/** Organization */
export type OrganizationSelectedProductsArgsT = {
  adSystem?: AdSystemT;
};


/** Organization */
export type OrganizationSummaryStatsArgsT = {
  adSystem?: InputMaybe<AdSystemT>;
  dateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  dateTo?: InputMaybe<Scalars['ISO8601Date']>;
};


/** Organization */
export type OrganizationTextSuggestionsArgsT = {
  kind: SuggestionKindT;
  limit?: InputMaybe<Scalars['Int']>;
};

/** Eshop Category of Organization */
export enum OrganizationCategoryT {
  Group1T = 'GROUP1',
  Group2T = 'GROUP2',
  Group3T = 'GROUP3',
  Group4T = 'GROUP4',
  Group5T = 'GROUP5',
  Group6T = 'GROUP6',
  Group7T = 'GROUP7',
  Group8T = 'GROUP8',
  Group9T = 'GROUP9',
  UnknownT = 'UNKNOWN'
}

/** The connection type for Organization. */
export type OrganizationConnectionT = {
  __typename?: 'OrganizationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganizationEdgeT>>>;
  /** A list of nodes. */
  nodes: Array<OrganizationT>;
  /** Information to aid in pagination. */
  pageInfo: PageInfoT;
};

/** Organization Design */
export type OrganizationDesignT = {
  __typename?: 'OrganizationDesign';
  /** Shoptet defined color1 */
  color1?: Maybe<Scalars['String']>;
  /** color2 */
  color2?: Maybe<Scalars['String']>;
  /** color3 */
  color3?: Maybe<Scalars['String']>;
  /** color4 */
  color4?: Maybe<Scalars['String']>;
  /** conversion color */
  conversionColor?: Maybe<Scalars['String']>;
  /** conversion color hover */
  conversionColorHover?: Maybe<Scalars['String']>;
  /** Final color1 */
  finalColor1?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** logo */
  logo?: Maybe<Scalars['String']>;
  /** logo background */
  logoBackground?: Maybe<Scalars['String']>;
  /** User defined color1 */
  overrideColor1?: Maybe<Scalars['String']>;
};

/** An edge in a connection. */
export type OrganizationEdgeT = {
  __typename?: 'OrganizationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<OrganizationT>;
};

/** Organization label */
export type OrganizationLabelT = {
  __typename?: 'OrganizationLabel';
  /** Count of affected products */
  count: Scalars['Int'];
  /** Name */
  name: Scalars['String'];
};

/** Steps that needs to be finished so use can start using app */
export enum OrganizationNotReadyStepsT {
  CategoriesT = 'CATEGORIES',
  DesignT = 'DESIGN',
  ProductsT = 'PRODUCTS'
}

/** State of Organization */
export enum OrganizationStateT {
  AccountSuspendedT = 'ACCOUNT_SUSPENDED',
  ActiveT = 'ACTIVE',
  NoCreditT = 'NO_CREDIT',
  NoProductsT = 'NO_PRODUCTS',
  PausedT = 'PAUSED',
  WizardT = 'WIZARD'
}

/** Enum with columns for Organizations ordering */
export enum OrganizationsOrderT {
  BannedProductsPercentageT = 'BANNED_PRODUCTS_PERCENTAGE',
  CreditBalanceT = 'CREDIT_BALANCE',
  DisapprovedAssetsPercentageT = 'DISAPPROVED_ASSETS_PERCENTAGE',
  MonthlyBudgetT = 'MONTHLY_BUDGET',
  StartedAtT = 'STARTED_AT',
  UsedSpendT = 'USED_SPEND'
}

/** Information about pagination in a connection. */
export type PageInfoT = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Number of items per page. */
  limit: Scalars['Int'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
  /** Total count of records. */
  total: Scalars['Int'];
};

/** Payment */
export type PaymentT = {
  __typename?: 'Payment';
  id: Scalars['ID'];
  /** requested Price to pay */
  price: MoneyT;
  /** Ad system for which to start campaign after payment */
  startCampaignFor?: Maybe<AdSystemT>;
  /** State of payment */
  state: PaymentStateT;
  /** Where to direct user to process payment */
  urlToPay: Scalars['String'];
};

/** State of Payment */
export enum PaymentStateT {
  FailureT = 'FAILURE',
  InitiatedT = 'INITIATED',
  SuccessT = 'SUCCESS'
}

/** Performance Stat result */
export type PerformanceStatT = {
  __typename?: 'PerformanceStat';
  /** Average Conversion Value */
  averageConversionValue?: Maybe<MoneyT>;
  /** Clicks */
  clicks?: Maybe<Scalars['Int']>;
  /** Conversion value */
  conversionValue?: Maybe<MoneyT>;
  /** Conversions */
  conversions?: Maybe<Scalars['Float']>;
  /** Used credit */
  credit?: Maybe<MoneyT>;
  /** Ctr */
  ctr?: Maybe<Scalars['Float']>;
  /** Date */
  date?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  /** Impressions */
  impressions?: Maybe<Scalars['Int']>;
  /** PNO */
  pno?: Maybe<Scalars['Float']>;
  /** Spend */
  spend?: Maybe<MoneyT>;
  /** Clicks without optimization */
  unoptimizedClicks?: Maybe<Scalars['Int']>;
  /** Conversion value without optimization */
  unoptimizedConversionValue?: Maybe<MoneyT>;
  /** Conversions without optimization */
  unoptimizedConversions?: Maybe<Scalars['Float']>;
  /** Impressions without optimization */
  unoptimizedImpressions?: Maybe<Scalars['Int']>;
};

/** Product */
export type ProductT = {
  __typename?: 'Product';
  id: Scalars['ID'];
  /** Image url */
  imageUrl: Scalars['String'];
  /** Name of product */
  name: Scalars['String'];
  /** order position */
  position: Scalars['Int'];
  /** Product price */
  price: MoneyT;
  /** URL to shoptet administration of product */
  shoptetProductDetailUrl: Scalars['String'];
};

/** Product Flag */
export type ProductFlagT = {
  __typename?: 'ProductFlag';
  /**
   * Is Product flag excluded
   * @deprecated Use specific ad system field like `excluded_google_ads` instead
   */
  excluded: Scalars['Boolean'];
  /** Is Product flag excluded for Google Ads */
  excludedGoogleAds: Scalars['Boolean'];
  /** Is Product flag excluded for Meta Ads */
  excludedMetaAds: Scalars['Boolean'];
  /** Code of flag */
  guid: Scalars['String'];
  id: Scalars['ID'];
  /** Name of product */
  name: Scalars['String'];
  /** Count of products with this flag */
  productsCount: Scalars['Int'];
};

/** State of number of products */
export enum ProductsCountStateT {
  NoProductsT = 'NO_PRODUCTS',
  OkT = 'OK'
}

/** Prompt */
export type PromptT = {
  __typename?: 'Prompt';
  /** Ad System */
  adSystem: AdSystemT;
  id: Scalars['ID'];
  /** Kind of suggestion */
  kind: SuggestionKindT;
  /** Name of prompt */
  name?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of PublishDraftAssetLines */
export type PublishDraftAssetLinesInputT = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Array of kinds to publish, when empty - publish all kinds */
  kinds?: InputMaybe<Array<AssetLineKindT>>;
};

/** Autogenerated return type of PublishDraftAssetLines. */
export type PublishDraftAssetLinesPayloadT = {
  __typename?: 'PublishDraftAssetLinesPayload';
  /** Published Asset Lines */
  assetLines?: Maybe<Array<AssetLineT>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Organization */
  organization?: Maybe<OrganizationT>;
};

/** Represents query */
export type QueryT = {
  __typename?: 'Query';
  /** Admin Summary */
  adminSummary?: Maybe<AdminSummaryT>;
  /** Environment */
  env?: Maybe<Scalars['String']>;
  /** List of All GMC Issues */
  gmcIssues?: Maybe<Array<GmcIssueT>>;
  /** Admin Meta Ads organizations */
  metaAdsOrganizations?: Maybe<OrganizationConnectionT>;
  /** Logged organization */
  organization?: Maybe<OrganizationT>;
  /** Organization labels */
  organizationLabels?: Maybe<Array<OrganizationLabelT>>;
  /** Admin All organizations */
  organizations?: Maybe<OrganizationConnectionT>;
  /** All prompts */
  prompts?: Maybe<Array<PromptT>>;
  /** Logged user */
  user?: Maybe<UserT>;
};


/** Represents query */
export type QueryAdminSummaryArgsT = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  labels?: InputMaybe<Array<Scalars['String']>>;
};


/** Represents query */
export type QueryMetaAdsOrganizationsArgsT = {
  adAccountId?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  businessId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderColumn?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<OrderDirectionT>;
  pageClaimApproved?: InputMaybe<Scalars['Boolean']>;
  pageClaimRequested?: InputMaybe<Scalars['Boolean']>;
  pageId?: InputMaybe<Scalars['String']>;
  shoptetId?: InputMaybe<Scalars['String']>;
  shoptetUrl?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AdSystemStateT>;
};


/** Represents query */
export type QueryOrganizationsArgsT = {
  adwordsCustomerId?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  gmcId?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderColumn?: InputMaybe<OrganizationsOrderT>;
  orderDirection?: InputMaybe<OrderDirectionT>;
  shoptetId?: InputMaybe<Scalars['String']>;
  shoptetUrl?: InputMaybe<Scalars['String']>;
  startedDaysAgo?: InputMaybe<DaysAgoT>;
  state?: InputMaybe<OrganizationStateT>;
};


/** Represents query */
export type QueryPromptsArgsT = {
  adSystem?: InputMaybe<AdSystemT>;
  kind?: InputMaybe<SuggestionKindT>;
};

/** Autogenerated input type of RemoveDisapprovedAssetLines */
export type RemoveDisapprovedAssetLinesInputT = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Removal do as a draft operation */
  draft?: InputMaybe<Scalars['Boolean']>;
  /** Array of kinds to discard, when empty - discard all kinds */
  kinds?: InputMaybe<Array<AssetLineKindT>>;
};

/** Autogenerated return type of RemoveDisapprovedAssetLines. */
export type RemoveDisapprovedAssetLinesPayloadT = {
  __typename?: 'RemoveDisapprovedAssetLinesPayload';
  /** Discarderd Asset Lines */
  assetLines?: Maybe<Array<AssetLineT>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Organization */
  organization?: Maybe<OrganizationT>;
};

/** Autogenerated input type of RequestAdditionalSuggestion */
export type RequestAdditionalSuggestionInputT = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Suggestion request Global ID */
  suggestionRequestId: Scalars['String'];
};

/** Autogenerated return type of RequestAdditionalSuggestion. */
export type RequestAdditionalSuggestionPayloadT = {
  __typename?: 'RequestAdditionalSuggestionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Suggestion request */
  suggestionRequest?: Maybe<SuggestionRequestT>;
};

/** Autogenerated input type of RequestNewImageSuggestion */
export type RequestNewImageSuggestionInputT = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Eshop data in valid json */
  eshopData?: InputMaybe<Scalars['JSON']>;
  /** Fetch More image suggestions */
  fetchMore?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of RequestNewImageSuggestion. */
export type RequestNewImageSuggestionPayloadT = {
  __typename?: 'RequestNewImageSuggestionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Image Suggestion request */
  imageSuggestionRequest?: Maybe<ImageSuggestionRequestT>;
};

/** Autogenerated input type of RequestNewSuggestion */
export type RequestNewSuggestionInputT = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Eshop data in valid json */
  eshopData?: InputMaybe<Scalars['JSON']>;
  /** Kind of suggestion */
  kind: SuggestionKindT;
  /** User input text */
  userInput: Scalars['String'];
};

/** Autogenerated return type of RequestNewSuggestion. */
export type RequestNewSuggestionPayloadT = {
  __typename?: 'RequestNewSuggestionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Suggestion request */
  suggestionRequest?: Maybe<SuggestionRequestT>;
};

/** Autogenerated input type of RestoreDraftRemoveAssetLine */
export type RestoreDraftRemoveAssetLineInputT = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Content */
  id: Scalars['String'];
};

/** Autogenerated return type of RestoreDraftRemoveAssetLine. */
export type RestoreDraftRemoveAssetLinePayloadT = {
  __typename?: 'RestoreDraftRemoveAssetLinePayload';
  /** Asset Line */
  assetLine?: Maybe<AssetLineT>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Organization */
  organization?: Maybe<OrganizationT>;
};

/** Autogenerated input type of SelectCategories */
export type SelectCategoriesInputT = {
  /** Category IDs to be selected */
  categoryIds: Array<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of SelectCategories. */
export type SelectCategoriesPayloadT = {
  __typename?: 'SelectCategoriesPayload';
  /** Modified Categories */
  categories: Array<CategoryT>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Organization */
  organization?: Maybe<OrganizationT>;
};

/** Autogenerated input type of SetGoogleAdsWizardStep */
export type SetGoogleAdsWizardStepInputT = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Set current wizard step */
  wizardStep: WizardStepT;
};

/** Autogenerated return type of SetGoogleAdsWizardStep. */
export type SetGoogleAdsWizardStepPayloadT = {
  __typename?: 'SetGoogleAdsWizardStepPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Google Ads Setting */
  googleAdsSetting?: Maybe<GoogleAdsSettingT>;
  /**
   * Organization
   * @deprecated Use google_ads_setting field instead
   */
  organization?: Maybe<OrganizationT>;
};

/** Autogenerated input type of SetMetaAdsWizardStep */
export type SetMetaAdsWizardStepInputT = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Set current wizard step */
  wizardStep: MetaAdsWizardStepT;
};

/** Autogenerated return type of SetMetaAdsWizardStep. */
export type SetMetaAdsWizardStepPayloadT = {
  __typename?: 'SetMetaAdsWizardStepPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Meta Ads Setting */
  metaAdsSetting?: Maybe<MetaAdsSettingT>;
};

/** Autogenerated input type of SetOrganizationLabels */
export type SetOrganizationLabelsInputT = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Labels */
  labels: Array<Scalars['String']>;
};

/** Autogenerated return type of SetOrganizationLabels. */
export type SetOrganizationLabelsPayloadT = {
  __typename?: 'SetOrganizationLabelsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Organization */
  organization?: Maybe<OrganizationT>;
};

/** Autogenerated input type of SetOrganizationNote */
export type SetOrganizationNoteInputT = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Note */
  note: Scalars['String'];
};

/** Autogenerated return type of SetOrganizationNote. */
export type SetOrganizationNotePayloadT = {
  __typename?: 'SetOrganizationNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Organization */
  organization?: Maybe<OrganizationT>;
};

/** Autogenerated input type of StartSynchronization */
export type StartSynchronizationInputT = {
  /** Ad system to start synchronization for */
  adSystem?: InputMaybe<AdSystemT>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of StartSynchronization. */
export type StartSynchronizationPayloadT = {
  __typename?: 'StartSynchronizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Result */
  message?: Maybe<Scalars['String']>;
};

/** Summary Stats type */
export type StatsT = {
  __typename?: 'Stats';
  /** Average Conversion Value */
  averageConversionValue?: Maybe<MoneyT>;
  /** Clicks */
  clicks?: Maybe<Scalars['Int']>;
  /** Conversion value */
  conversionValue?: Maybe<MoneyT>;
  /** Conversions */
  conversions?: Maybe<Scalars['Float']>;
  /** Used credit */
  credit?: Maybe<MoneyT>;
  /** Ctr */
  ctr?: Maybe<Scalars['Float']>;
  /** Id */
  id?: Maybe<Scalars['String']>;
  /** Impressions */
  impressions?: Maybe<Scalars['Int']>;
  /** PNO */
  pno?: Maybe<Scalars['Float']>;
  /** Spend */
  spend?: Maybe<MoneyT>;
  /** Clicks without optimization */
  unoptimizedClicks?: Maybe<Scalars['Int']>;
  /** Conversion value without optimization */
  unoptimizedConversionValue?: Maybe<MoneyT>;
  /** Conversions without optimization */
  unoptimizedConversions?: Maybe<Scalars['Float']>;
  /** Impressions without optimization */
  unoptimizedImpressions?: Maybe<Scalars['Int']>;
};

/** Admin summary stats by months */
export type StatsByMonthT = {
  __typename?: 'StatsByMonth';
  /** average spend of organizations */
  averageSpend: MoneyT;
  /** credit */
  credit: MoneyT;
  /** date range */
  date: Scalars['ISO8601Date'];
  /** income */
  income: MoneyT;
  /** count of organizations */
  organizationsCount: Scalars['Int'];
  /** spend */
  spend: MoneyT;
};

/** Admin summary stats by tarif */
export type StatsByTarifT = {
  __typename?: 'StatsByTarif';
  /** average spend of organizations */
  averageSpend: MoneyT;
  /** credit */
  credit: MoneyT;
  /** income */
  income: MoneyT;
  /** count of organizations */
  organizationsCount: Scalars['Int'];
  /** spend */
  spend: MoneyT;
  /** name of tarif */
  tarifName: Scalars['String'];
};

/** Suggestion Request */
export type SuggestionT = {
  __typename?: 'Suggestion';
  /** Number of approved asset lines */
  assetLineCount: Scalars['Int'];
  /** Content */
  content: Scalars['String'];
  /** Disapproved at */
  disapprovedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  /** Kind */
  kind: SuggestionKindT;
  /** Is length of suggestion valid for asset line kind */
  validLength: Scalars['Boolean'];
};

export enum SuggestionKindT {
  BusinessNameT = 'BUSINESS_NAME',
  LongDescriptionT = 'LONG_DESCRIPTION',
  LongHeadlineT = 'LONG_HEADLINE',
  PrimaryTextT = 'PRIMARY_TEXT',
  ShortDescriptionT = 'SHORT_DESCRIPTION',
  ShortHeadlineT = 'SHORT_HEADLINE',
  VideoT = 'VIDEO'
}

/** Suggestion Request */
export type SuggestionRequestT = {
  __typename?: 'SuggestionRequest';
  /** Created at */
  createdAt: Scalars['ISO8601DateTime'];
  /** Eshop data */
  eshopData: Scalars['JSON'];
  id: Scalars['ID'];
  /** is request in progress */
  inProgress: Scalars['Boolean'];
  /** Kind of suggestion */
  kind: SuggestionKindT;
  /** Organization */
  organization: OrganizationT;
  /** Prompt */
  prompt: PromptT;
  /** Suggestions */
  suggestions: Array<SuggestionT>;
  /** User inputed text */
  userInput: Scalars['String'];
};

/** Autogenerated input type of UpdateOrganization */
export type UpdateOrganizationInputT = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Timestamp of consultation request */
  consultationRequestedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Records the entry to the onboarding */
  onboardingEntered?: InputMaybe<Scalars['Boolean']>;
  /** Organization properties */
  properties?: InputMaybe<Scalars['JSON']>;
};

/** Autogenerated return type of UpdateOrganization. */
export type UpdateOrganizationPayloadT = {
  __typename?: 'UpdateOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Organization */
  organization?: Maybe<OrganizationT>;
};

/** Autogenerated input type of UploadImage */
export type UploadImageInputT = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Content Type */
  contentType: Scalars['String'];
  /** Height of cropped area */
  cropHeight: Scalars['Int'];
  /** Width of cropped area */
  cropWidth: Scalars['Int'];
  /** X where to start crop */
  cropX: Scalars['Int'];
  /** Y where to start crop */
  cropY: Scalars['Int'];
  /** Filename */
  filename: Scalars['String'];
  /** Height of image */
  height: Scalars['Int'];
  /** Image in base64 */
  image: Scalars['String'];
  /** Image Kind */
  kind: ImageSuggestionKindT;
  /** Width of image */
  width: Scalars['Int'];
};

/** Autogenerated return type of UploadImage. */
export type UploadImagePayloadT = {
  __typename?: 'UploadImagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of errors */
  errors?: Maybe<Array<Scalars['String']>>;
  /** Organization */
  organization?: Maybe<OrganizationT>;
  /** Uploaded Image */
  uploadedImage?: Maybe<UploadedImageT>;
};

/** Uploaded image */
export type UploadedImageT = {
  __typename?: 'UploadedImage';
  /** Number of approved asset lines */
  assetLineCount: Scalars['Int'];
  /** Height of cropped area */
  cropHeight: Scalars['Int'];
  /** Width of cropped area */
  cropWidth: Scalars['Int'];
  /** X where to start crop */
  cropX: Scalars['Int'];
  /** Y where to start crop */
  cropY: Scalars['Int'];
  /** Url to cropped image */
  croppedImageUrl: Scalars['String'];
  /** Height of image */
  height: Scalars['Int'];
  id: Scalars['ID'];
  /** Kind */
  kind: ImageSuggestionKindT;
  /** Url to source image */
  sourceImageUrl: Scalars['String'];
  /** Width of image */
  width: Scalars['Int'];
};

/** User */
export type UserT = {
  __typename?: 'User';
  /** Email */
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Name */
  name?: Maybe<Scalars['String']>;
};

/** Validation error */
export type ValidationErrorT = {
  __typename?: 'ValidationError';
  /** Field with errors */
  attribute?: Maybe<AssetLineKindT>;
  /** ID */
  id?: Maybe<Scalars['String']>;
  /** Message */
  kind?: Maybe<ValidationErrorKindT>;
  /** Validation options */
  options?: Maybe<Scalars['JSON']>;
};

/** Type of validation error */
export enum ValidationErrorKindT {
  TooLongT = 'too_long',
  TooShortT = 'too_short'
}

/** Validation result */
export type ValidationResultT = {
  __typename?: 'ValidationResult';
  /** Validation errors */
  errors?: Maybe<Array<ValidationErrorT>>;
  /** ID */
  id?: Maybe<Scalars['String']>;
  /** Is validtion ok */
  valid?: Maybe<Scalars['Boolean']>;
};

/** Wizard steps of Organization */
export enum WizardStepT {
  CheckT = 'CHECK',
  DashboardT = 'DASHBOARD',
  FinishT = 'FINISH',
  FirstT = 'FIRST',
  ImageSelectionT = 'IMAGE_SELECTION',
  MetaBudgetT = 'META_BUDGET',
  MetaFinishT = 'META_FINISH',
  MetaFirstT = 'META_FIRST',
  MetaPageLinkingT = 'META_PAGE_LINKING',
  MetaProductsSelectionT = 'META_PRODUCTS_SELECTION',
  MetaTextSelectionT = 'META_TEXT_SELECTION',
  SuggestionGeneratorT = 'SUGGESTION_GENERATOR',
  TextSelectionT = 'TEXT_SELECTION'
}

export type CampaignSettingsDetailsQueryVariablesT = Exact<{ [key: string]: never; }>;


export type CampaignSettingsDetailsQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, startedAt?: any | null } | null };

export type ActiveImageAssetLineFragmentT = { __typename?: 'AssetLine', id: string, kind: AssetLineKindT, adSystem: AdSystemT, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, draftState?: AssetLineDraftStateT | null, imageSuggestion?: { __typename?: 'ImageSuggestion', id: string, name: string, kind: ImageSuggestionKindT, height: number, width: number, svgLink: string, assetLineCount: number, disapprovedAt?: any | null } | null, uploadedImage?: { __typename?: 'UploadedImage', id: string, sourceImageUrl: string, croppedImageUrl: string, width: number, height: number, cropX: number, cropY: number, cropHeight: number, cropWidth: number, kind: ImageSuggestionKindT } | null };

export type ActiveTextAssetLineFragmentT = { __typename?: 'AssetLine', id: string, kind: AssetLineKindT, content: string, adSystem: AdSystemT, draftState?: AssetLineDraftStateT | null, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, invalidSymbols?: Array<string> | null };

export type ImageSuggestionFragmentT = { __typename?: 'ImageSuggestion', id: string, name: string, kind: ImageSuggestionKindT, height: number, width: number, svgLink: string, assetLineCount: number, disapprovedAt?: any | null };

export type MoneyFragmentT = { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null };

export type OrganizationCreditsFragmentT = { __typename?: 'Organization', remainingCreditDays: number, remainingCreditDaysAfterStart: number, runningAdSystems: Array<AdSystemT>, creditBalance: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, dailyCredits: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, usedCredits: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, boughtCredits: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, recommendedMonthlyBudget: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, recommendedCreditIncreaseBig: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, recommendedCreditIncreaseSmall: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } };

export type ProductFragmentT = { __typename?: 'Product', id: string, name: string, imageUrl: string, price: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } };

export type LastSuggestionRequestFragmentT = { __typename?: 'SuggestionRequest', id: string, inProgress: boolean, createdAt: any, userInput: string, eshopData: any };

export type SummaryStatsFragmentT = { __typename?: 'Stats', clicks?: number | null, impressions?: number | null, conversions?: number | null, pno?: number | null, conversionValue?: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } | null, credit?: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } | null, averageConversionValue?: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } | null };

export type UploadedImageFragmentT = { __typename?: 'UploadedImage', id: string, sourceImageUrl: string, croppedImageUrl: string, width: number, height: number, cropX: number, cropY: number, cropHeight: number, cropWidth: number, kind: ImageSuggestionKindT };

export type ValidationResultFragmentT = { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null };

export type AdminCancelMetaPageClaimRequestMutationVariablesT = Exact<{ [key: string]: never; }>;


export type AdminCancelMetaPageClaimRequestMutationT = { __typename?: 'Mutation', adminCancelMetaPageClaimRequest?: { __typename?: 'AdminCancelMetaPageClaimRequestPayload', success?: boolean | null, errors?: Array<string> | null } | null };

export type AdminIncreaseCreditMutationVariablesT = Exact<{
  amount: Scalars['Float'];
  currency: CurrencyT;
}>;


export type AdminIncreaseCreditMutationT = { __typename?: 'Mutation', adminIncreaseCredit?: { __typename?: 'AdminIncreaseCreditPayload', errors?: Array<string> | null, organization?: { __typename?: 'Organization', id: string, creditBalance: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } } | null } | null };

export type AdminResendMetaPageClaimRequestMutationVariablesT = Exact<{ [key: string]: never; }>;


export type AdminResendMetaPageClaimRequestMutationT = { __typename?: 'Mutation', adminResendMetaPageClaimRequest?: { __typename?: 'AdminResendMetaPageClaimRequestPayload', success?: boolean | null, errors?: Array<string> | null } | null };

export type ChangeGoogleAdsSettingsStateMutationVariablesT = Exact<{
  input: GoogleAdsChangeSettingsInputT;
}>;


export type ChangeGoogleAdsSettingsStateMutationT = { __typename?: 'Mutation', changeGoogleAdsSettings?: { __typename?: 'GoogleAdsChangeSettingsPayload', errors?: Array<string> | null, organization?: { __typename?: 'Organization', id: string, remainingCreditDays: number, remainingCreditDaysAfterStart: number, runningAdSystems: Array<AdSystemT>, googleAdsSetting?: { __typename?: 'GoogleAdsSetting', id: string, state?: AdSystemStateT | null } | null, creditBalance: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } } | null } | null };

export type ChangeMetaAdsSettingsStateMutationVariablesT = Exact<{
  input: MetaAdsChangeSettingsInputT;
}>;


export type ChangeMetaAdsSettingsStateMutationT = { __typename?: 'Mutation', changeMetaAdsSettings?: { __typename?: 'MetaAdsChangeSettingsPayload', errors?: Array<string> | null, metaAdsSetting?: { __typename?: 'MetaAdsSetting', id: string, state?: AdSystemStateT | null } | null, organization?: { __typename?: 'Organization', id: string, remainingCreditDays: number, remainingCreditDaysAfterStart: number, runningAdSystems: Array<AdSystemT>, creditBalance: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } } | null } | null };

export type ChangeCampaignSettingsMutationVariablesT = Exact<{
  biddingScheme?: InputMaybe<BiddingSchemeT>;
  audienceSignals?: InputMaybe<Scalars['Boolean']>;
  extendedConversions?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<AdSystemStateT>;
}>;


export type ChangeCampaignSettingsMutationT = { __typename?: 'Mutation', changeCampaignSettings?: { __typename?: 'GoogleAdsChangeSettingsPayload', errors?: Array<string> | null, organization?: { __typename?: 'Organization', id: string, biddingScheme: BiddingSchemeT, audienceSignals: boolean, extendedConversions: boolean, state?: OrganizationStateT | null } | null } | null };

export type ChangeMetaAdsSettingsMutationVariablesT = Exact<{
  pageId?: InputMaybe<Scalars['String']>;
}>;


export type ChangeMetaAdsSettingsMutationT = { __typename?: 'Mutation', changeMetaAdsSettings?: { __typename?: 'MetaAdsChangeSettingsPayload', errors?: Array<string> | null, metaAdsSetting?: { __typename?: 'MetaAdsSetting', id: string, pageId?: string | null, pageClaimApproved: boolean, pageClaimRequestedAt?: any | null, pageClaimFailureReason?: string | null, state?: AdSystemStateT | null } | null } | null };

export type ChangeMonthlyBudgetMutationVariablesT = Exact<{
  adSystem: AdSystemT;
  currency: Scalars['String'];
  monthlyBudget: Scalars['Float'];
}>;


export type ChangeMonthlyBudgetMutationT = { __typename?: 'Mutation', changeMonthlyBudget?: { __typename?: 'ChangeMonthlyBudgetPayload', errors?: Array<string> | null, organization?: { __typename?: 'Organization', id: string, remainingCreditDays: number, remainingCreditDaysAfterStart: number, runningAdSystems: Array<AdSystemT>, googleAdsSetting?: { __typename?: 'GoogleAdsSetting', id: string, monthlyBudget: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } } | null, metaAdsSetting?: { __typename?: 'MetaAdsSetting', id: string, monthlyBudget: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } } | null, monthlyBudget: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, dailyCredits: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, creditBalance: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, usedCredits: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, boughtCredits: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, recommendedMonthlyBudget: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, recommendedCreditIncreaseBig: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, recommendedCreditIncreaseSmall: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } } | null } | null };

export type ChangeOrganizationDesignMutationVariablesT = Exact<{
  overrideColor1?: InputMaybe<Scalars['String']>;
}>;


export type ChangeOrganizationDesignMutationT = { __typename?: 'Mutation', changeOrganizationDesign?: { __typename?: 'ChangeOrganizationDesignPayload', errors?: Array<string> | null } | null };

export type CheckMetaAdsClaimPageApprovalMutationVariablesT = Exact<{ [key: string]: never; }>;


export type CheckMetaAdsClaimPageApprovalMutationT = { __typename?: 'Mutation', checkMetaAdsClaimPageApproval?: { __typename?: 'CheckClaimPageApprovalPayload', errors?: Array<string> | null } | null };

export type CreateAssetLineMutationVariablesT = Exact<{
  content: Scalars['String'];
  kind: AssetLineKindT;
  suggestionId?: InputMaybe<Scalars['String']>;
  imageSuggestionId?: InputMaybe<Scalars['String']>;
  draft?: InputMaybe<Scalars['Boolean']>;
  adSystem?: InputMaybe<AdSystemT>;
}>;


export type CreateAssetLineMutationT = { __typename?: 'Mutation', createAssetLine?: { __typename?: 'CreateAssetLinePayload', errors?: Array<string> | null, assetLine?: { __typename?: 'AssetLine', id: string, invalidSymbols?: Array<string> | null, imageSuggestion?: { __typename?: 'ImageSuggestion', id: string, assetLineCount: number } | null, suggestion?: { __typename?: 'Suggestion', id: string, assetLineCount: number } | null } | null, organization?: { __typename?: 'Organization', id: string, activeTextsAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, content: string, adSystem: AdSystemT, draftState?: AssetLineDraftStateT | null, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, invalidSymbols?: Array<string> | null }>, activeImagesAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, adSystem: AdSystemT, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, draftState?: AssetLineDraftStateT | null, imageSuggestion?: { __typename?: 'ImageSuggestion', id: string, name: string, kind: ImageSuggestionKindT, height: number, width: number, svgLink: string, assetLineCount: number, disapprovedAt?: any | null } | null, uploadedImage?: { __typename?: 'UploadedImage', id: string, sourceImageUrl: string, croppedImageUrl: string, width: number, height: number, cropX: number, cropY: number, cropHeight: number, cropWidth: number, kind: ImageSuggestionKindT } | null }>, notDeletedTextsAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, content: string, adSystem: AdSystemT, draftState?: AssetLineDraftStateT | null, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, invalidSymbols?: Array<string> | null }>, notDeletedImagesAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, adSystem: AdSystemT, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, draftState?: AssetLineDraftStateT | null, imageSuggestion?: { __typename?: 'ImageSuggestion', id: string, name: string, kind: ImageSuggestionKindT, height: number, width: number, svgLink: string, assetLineCount: number, disapprovedAt?: any | null } | null, uploadedImage?: { __typename?: 'UploadedImage', id: string, sourceImageUrl: string, croppedImageUrl: string, width: number, height: number, cropX: number, cropY: number, cropHeight: number, cropWidth: number, kind: ImageSuggestionKindT } | null }>, validateImages: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null }, validateDraftImages: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null }, validateTexts: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null }, validateDraftTexts: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null } } | null } | null };

export type CreateImageAssetLineMutationVariablesT = Exact<{
  cropX: Scalars['Int'];
  cropY: Scalars['Int'];
  cropWidth: Scalars['Int'];
  cropHeight: Scalars['Int'];
  uploadedImageId: Scalars['String'];
  draft?: InputMaybe<Scalars['Boolean']>;
  adSystem?: InputMaybe<AdSystemT>;
}>;


export type CreateImageAssetLineMutationT = { __typename?: 'Mutation', createImageAssetLine?: { __typename?: 'CreateImageAssetLinePayload', errors?: Array<string> | null, assetLine?: { __typename?: 'AssetLine', id: string } | null, organization?: { __typename?: 'Organization', id: string, activeTextsAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, content: string, adSystem: AdSystemT, draftState?: AssetLineDraftStateT | null, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, invalidSymbols?: Array<string> | null }>, activeImagesAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, adSystem: AdSystemT, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, draftState?: AssetLineDraftStateT | null, imageSuggestion?: { __typename?: 'ImageSuggestion', id: string, name: string, kind: ImageSuggestionKindT, height: number, width: number, svgLink: string, assetLineCount: number, disapprovedAt?: any | null } | null, uploadedImage?: { __typename?: 'UploadedImage', id: string, sourceImageUrl: string, croppedImageUrl: string, width: number, height: number, cropX: number, cropY: number, cropHeight: number, cropWidth: number, kind: ImageSuggestionKindT } | null }>, notDeletedTextsAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, content: string, adSystem: AdSystemT, draftState?: AssetLineDraftStateT | null, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, invalidSymbols?: Array<string> | null }>, notDeletedImagesAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, adSystem: AdSystemT, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, draftState?: AssetLineDraftStateT | null, imageSuggestion?: { __typename?: 'ImageSuggestion', id: string, name: string, kind: ImageSuggestionKindT, height: number, width: number, svgLink: string, assetLineCount: number, disapprovedAt?: any | null } | null, uploadedImage?: { __typename?: 'UploadedImage', id: string, sourceImageUrl: string, croppedImageUrl: string, width: number, height: number, cropX: number, cropY: number, cropHeight: number, cropWidth: number, kind: ImageSuggestionKindT } | null }>, validateImages: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null }, validateDraftImages: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null }, validateTexts: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null }, validateDraftTexts: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null } } | null } | null };

export type DecreaseCreditMutationVariablesT = Exact<{
  amount: Scalars['Float'];
  currency: CurrencyT;
}>;


export type DecreaseCreditMutationT = { __typename?: 'Mutation', decreaseCredit?: { __typename?: 'DecreaseCreditPayload', errors?: Array<string> | null } | null };

export type DeleteAssetLineMutationVariablesT = Exact<{
  id: Scalars['String'];
  draft?: InputMaybe<Scalars['Boolean']>;
  adSystem?: InputMaybe<AdSystemT>;
}>;


export type DeleteAssetLineMutationT = { __typename?: 'Mutation', deleteAssetLine?: { __typename?: 'DeleteAssetLinePayload', errors?: Array<string> | null, assetLine?: { __typename?: 'AssetLine', id: string } | null, organization?: { __typename?: 'Organization', id: string, activeTextsAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, content: string, adSystem: AdSystemT, draftState?: AssetLineDraftStateT | null, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, invalidSymbols?: Array<string> | null }>, activeImagesAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, adSystem: AdSystemT, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, draftState?: AssetLineDraftStateT | null, imageSuggestion?: { __typename?: 'ImageSuggestion', id: string, name: string, kind: ImageSuggestionKindT, height: number, width: number, svgLink: string, assetLineCount: number, disapprovedAt?: any | null } | null, uploadedImage?: { __typename?: 'UploadedImage', id: string, sourceImageUrl: string, croppedImageUrl: string, width: number, height: number, cropX: number, cropY: number, cropHeight: number, cropWidth: number, kind: ImageSuggestionKindT } | null }>, notDeletedTextsAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, content: string, adSystem: AdSystemT, draftState?: AssetLineDraftStateT | null, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, invalidSymbols?: Array<string> | null }>, notDeletedImagesAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, adSystem: AdSystemT, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, draftState?: AssetLineDraftStateT | null, imageSuggestion?: { __typename?: 'ImageSuggestion', id: string, name: string, kind: ImageSuggestionKindT, height: number, width: number, svgLink: string, assetLineCount: number, disapprovedAt?: any | null } | null, uploadedImage?: { __typename?: 'UploadedImage', id: string, sourceImageUrl: string, croppedImageUrl: string, width: number, height: number, cropX: number, cropY: number, cropHeight: number, cropWidth: number, kind: ImageSuggestionKindT } | null }>, validateImages: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null }, validateDraftImages: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null }, validateTexts: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null }, validateDraftTexts: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null } } | null } | null };

export type DisapproveSuggestionMutationVariablesT = Exact<{
  id: Scalars['String'];
}>;


export type DisapproveSuggestionMutationT = { __typename?: 'Mutation', disapproveSuggestion?: { __typename?: 'DisapproveSuggestionPayload', errors?: Array<string> | null, suggestion?: { __typename?: 'Suggestion', id: string, disapprovedAt?: any | null } | null, imageSuggestion?: { __typename?: 'ImageSuggestion', id: string, disapprovedAt?: any | null } | null } | null };

export type DiscardDraftAssetLinesMutationVariablesT = Exact<{
  kinds?: InputMaybe<Array<AssetLineKindT> | AssetLineKindT>;
  adSystem?: InputMaybe<AdSystemT>;
}>;


export type DiscardDraftAssetLinesMutationT = { __typename?: 'Mutation', discardDraftAssetLines?: { __typename?: 'DiscardDraftAssetLinesPayload', errors?: Array<string> | null, assetLines?: Array<{ __typename?: 'AssetLine', id: string }> | null, organization?: { __typename?: 'Organization', id: string, activeTextsAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, content: string, adSystem: AdSystemT, draftState?: AssetLineDraftStateT | null, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, invalidSymbols?: Array<string> | null }>, activeImagesAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, adSystem: AdSystemT, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, draftState?: AssetLineDraftStateT | null, imageSuggestion?: { __typename?: 'ImageSuggestion', id: string, name: string, kind: ImageSuggestionKindT, height: number, width: number, svgLink: string, assetLineCount: number, disapprovedAt?: any | null } | null, uploadedImage?: { __typename?: 'UploadedImage', id: string, sourceImageUrl: string, croppedImageUrl: string, width: number, height: number, cropX: number, cropY: number, cropHeight: number, cropWidth: number, kind: ImageSuggestionKindT } | null }>, notDeletedTextsAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, content: string, adSystem: AdSystemT, draftState?: AssetLineDraftStateT | null, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, invalidSymbols?: Array<string> | null }>, notDeletedImagesAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, adSystem: AdSystemT, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, draftState?: AssetLineDraftStateT | null, imageSuggestion?: { __typename?: 'ImageSuggestion', id: string, name: string, kind: ImageSuggestionKindT, height: number, width: number, svgLink: string, assetLineCount: number, disapprovedAt?: any | null } | null, uploadedImage?: { __typename?: 'UploadedImage', id: string, sourceImageUrl: string, croppedImageUrl: string, width: number, height: number, cropX: number, cropY: number, cropHeight: number, cropWidth: number, kind: ImageSuggestionKindT } | null }>, validateImages: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null }, validateDraftImages: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null }, validateTexts: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null }, validateDraftTexts: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null } } | null } | null };

export type ExcludeCategoriesMutationVariablesT = Exact<{
  categoryIds: Array<Scalars['String']> | Scalars['String'];
  adSystem?: InputMaybe<AdSystemT>;
}>;


export type ExcludeCategoriesMutationT = { __typename?: 'Mutation', excludeCategories?: { __typename?: 'ExcludeCategoriesPayload', errors?: Array<string> | null, organization?: { __typename?: 'Organization', id: string, excludedCategoriesProductsCount: number, excludedProductsCount: number, selectableProductsCount: number } | null, categories: Array<{ __typename?: 'Category', id: string, name?: string | null, excludedGoogleAds: boolean, excludedMetaAds: boolean }> } | null };

export type ExcludeProductFlagsMutationVariablesT = Exact<{
  productFlagIds: Array<Scalars['String']> | Scalars['String'];
  adSystem?: InputMaybe<AdSystemT>;
}>;


export type ExcludeProductFlagsMutationT = { __typename?: 'Mutation', excludeProductFlags?: { __typename?: 'ExcludeProductFlagsPayload', errors?: Array<string> | null, organization?: { __typename?: 'Organization', id: string, excludedProductFlagsProductsCount: number, excludedProductsCount: number, selectableProductsCount: number } | null, productFlags: Array<{ __typename?: 'ProductFlag', id: string, name: string, excludedGoogleAds: boolean, excludedMetaAds: boolean }> } | null };

export type InitiatePaymentMutationVariablesT = Exact<{
  amount: Scalars['Float'];
  currency: CurrencyT;
  returnUrl?: InputMaybe<Scalars['String']>;
  startCampaignFor?: InputMaybe<AdSystemT>;
}>;


export type InitiatePaymentMutationT = { __typename?: 'Mutation', initiatePayment?: { __typename?: 'InitiatePaymentPayload', errors?: Array<string> | null, payment?: { __typename?: 'Payment', id: string, urlToPay: string } | null } | null };

export type LeaveWizardMutationVariablesT = Exact<{
  adSystem: AdSystemT;
}>;


export type LeaveWizardMutationT = { __typename?: 'Mutation', leaveWizard?: { __typename?: 'LeaveWizardPayload', errors?: Array<string> | null, organization?: { __typename?: 'Organization', id: string, googleAdsSetting?: { __typename?: 'GoogleAdsSetting', id: string, state?: AdSystemStateT | null, wizardStep: WizardStepT } | null, metaAdsSetting?: { __typename?: 'MetaAdsSetting', id: string, state?: AdSystemStateT | null, wizardStep: MetaAdsWizardStepT } | null } | null } | null };

export type OnboardingEnteredMutationVariablesT = Exact<{ [key: string]: never; }>;


export type OnboardingEnteredMutationT = { __typename?: 'Mutation', updateOrganization?: { __typename?: 'UpdateOrganizationPayload', errors?: Array<string> | null, organization?: { __typename?: 'Organization', id: string } | null } | null };

export type PublishDraftAssetLinesMutationVariablesT = Exact<{
  kinds?: InputMaybe<Array<AssetLineKindT> | AssetLineKindT>;
  adSystem?: InputMaybe<AdSystemT>;
}>;


export type PublishDraftAssetLinesMutationT = { __typename?: 'Mutation', publishDraftAssetLines?: { __typename?: 'PublishDraftAssetLinesPayload', errors?: Array<string> | null, assetLines?: Array<{ __typename?: 'AssetLine', id: string }> | null, organization?: { __typename?: 'Organization', id: string, activeTextsAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, content: string, adSystem: AdSystemT, draftState?: AssetLineDraftStateT | null, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, invalidSymbols?: Array<string> | null }>, activeImagesAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, adSystem: AdSystemT, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, draftState?: AssetLineDraftStateT | null, imageSuggestion?: { __typename?: 'ImageSuggestion', id: string, name: string, kind: ImageSuggestionKindT, height: number, width: number, svgLink: string, assetLineCount: number, disapprovedAt?: any | null } | null, uploadedImage?: { __typename?: 'UploadedImage', id: string, sourceImageUrl: string, croppedImageUrl: string, width: number, height: number, cropX: number, cropY: number, cropHeight: number, cropWidth: number, kind: ImageSuggestionKindT } | null }>, notDeletedTextsAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, content: string, adSystem: AdSystemT, draftState?: AssetLineDraftStateT | null, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, invalidSymbols?: Array<string> | null }>, notDeletedImagesAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, adSystem: AdSystemT, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, draftState?: AssetLineDraftStateT | null, imageSuggestion?: { __typename?: 'ImageSuggestion', id: string, name: string, kind: ImageSuggestionKindT, height: number, width: number, svgLink: string, assetLineCount: number, disapprovedAt?: any | null } | null, uploadedImage?: { __typename?: 'UploadedImage', id: string, sourceImageUrl: string, croppedImageUrl: string, width: number, height: number, cropX: number, cropY: number, cropHeight: number, cropWidth: number, kind: ImageSuggestionKindT } | null }>, validateImages: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null }, validateDraftImages: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null }, validateTexts: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null }, validateDraftTexts: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null } } | null } | null };

export type RemoveDisapprovedAssetLinesMutationVariablesT = Exact<{
  kinds?: InputMaybe<Array<AssetLineKindT> | AssetLineKindT>;
  draft?: InputMaybe<Scalars['Boolean']>;
  adSystem?: InputMaybe<AdSystemT>;
}>;


export type RemoveDisapprovedAssetLinesMutationT = { __typename?: 'Mutation', removeDisapprovedAssetLines?: { __typename?: 'RemoveDisapprovedAssetLinesPayload', errors?: Array<string> | null, assetLines?: Array<{ __typename?: 'AssetLine', id: string, draftState?: AssetLineDraftStateT | null }> | null, organization?: { __typename?: 'Organization', id: string, activeTextsAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, content: string, adSystem: AdSystemT, draftState?: AssetLineDraftStateT | null, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, invalidSymbols?: Array<string> | null }>, activeImagesAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, adSystem: AdSystemT, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, draftState?: AssetLineDraftStateT | null, imageSuggestion?: { __typename?: 'ImageSuggestion', id: string, name: string, kind: ImageSuggestionKindT, height: number, width: number, svgLink: string, assetLineCount: number, disapprovedAt?: any | null } | null, uploadedImage?: { __typename?: 'UploadedImage', id: string, sourceImageUrl: string, croppedImageUrl: string, width: number, height: number, cropX: number, cropY: number, cropHeight: number, cropWidth: number, kind: ImageSuggestionKindT } | null }>, notDeletedTextsAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, content: string, adSystem: AdSystemT, draftState?: AssetLineDraftStateT | null, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, invalidSymbols?: Array<string> | null }>, notDeletedImagesAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, adSystem: AdSystemT, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, draftState?: AssetLineDraftStateT | null, imageSuggestion?: { __typename?: 'ImageSuggestion', id: string, name: string, kind: ImageSuggestionKindT, height: number, width: number, svgLink: string, assetLineCount: number, disapprovedAt?: any | null } | null, uploadedImage?: { __typename?: 'UploadedImage', id: string, sourceImageUrl: string, croppedImageUrl: string, width: number, height: number, cropX: number, cropY: number, cropHeight: number, cropWidth: number, kind: ImageSuggestionKindT } | null }>, validateImages: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null }, validateDraftImages: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null }, validateTexts: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null }, validateDraftTexts: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null } } | null } | null };

export type RequestNewImageSuggestionMutationVariablesT = Exact<{
  eshopData?: InputMaybe<Scalars['JSON']>;
}>;


export type RequestNewImageSuggestionMutationT = { __typename?: 'Mutation', requestNewImageSuggestion?: { __typename?: 'RequestNewImageSuggestionPayload', errors?: Array<string> | null, imageSuggestionRequest?: { __typename?: 'ImageSuggestionRequest', id: string } | null } | null };

export type RequestAdditionalSuggestionMutationVariablesT = Exact<{
  suggestionRequestId: Scalars['String'];
}>;


export type RequestAdditionalSuggestionMutationT = { __typename?: 'Mutation', requestAdditionalSuggestion?: { __typename?: 'RequestAdditionalSuggestionPayload', errors?: Array<string> | null, suggestionRequest?: { __typename?: 'SuggestionRequest', id: string, userInput: string } | null } | null };

export type RequestConsultationMutationVariablesT = Exact<{
  consultationRequestedAt: Scalars['ISO8601DateTime'];
}>;


export type RequestConsultationMutationT = { __typename?: 'Mutation', updateOrganization?: { __typename?: 'UpdateOrganizationPayload', errors?: Array<string> | null, organization?: { __typename?: 'Organization', id: string, consultationRequestedAt?: any | null } | null } | null };

export type RequestAdditionalImageSuggestionMutationVariablesT = Exact<{
  eshopData?: InputMaybe<Scalars['JSON']>;
}>;


export type RequestAdditionalImageSuggestionMutationT = { __typename?: 'Mutation', requestNewImageSuggestion?: { __typename?: 'RequestNewImageSuggestionPayload', errors?: Array<string> | null, imageSuggestionRequest?: { __typename?: 'ImageSuggestionRequest', id: string, inProgress: boolean, canFetchMore: boolean } | null } | null };

export type RequestNewSuggestionMutationVariablesT = Exact<{
  userInput: Scalars['String'];
  eshopData?: InputMaybe<Scalars['JSON']>;
}>;


export type RequestNewSuggestionMutationT = { __typename?: 'Mutation', shortHeadlineRequest?: { __typename?: 'RequestNewSuggestionPayload', errors?: Array<string> | null, suggestionRequest?: { __typename?: 'SuggestionRequest', id: string, userInput: string } | null } | null, longHeadlineRequest?: { __typename?: 'RequestNewSuggestionPayload', errors?: Array<string> | null, suggestionRequest?: { __typename?: 'SuggestionRequest', id: string, userInput: string } | null } | null, shortDescriptionRequest?: { __typename?: 'RequestNewSuggestionPayload', errors?: Array<string> | null, suggestionRequest?: { __typename?: 'SuggestionRequest', id: string, userInput: string } | null } | null, londDescriptionRequest?: { __typename?: 'RequestNewSuggestionPayload', errors?: Array<string> | null, suggestionRequest?: { __typename?: 'SuggestionRequest', id: string, userInput: string } | null } | null };

export type RestoreDraftRemoveAssetLineMutationVariablesT = Exact<{
  id: Scalars['String'];
  adSystem?: InputMaybe<AdSystemT>;
}>;


export type RestoreDraftRemoveAssetLineMutationT = { __typename?: 'Mutation', restoreDraftRemoveAssetLine?: { __typename?: 'RestoreDraftRemoveAssetLinePayload', errors?: Array<string> | null, assetLine?: { __typename?: 'AssetLine', id: string } | null, organization?: { __typename?: 'Organization', id: string, activeTextsAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, content: string, adSystem: AdSystemT, draftState?: AssetLineDraftStateT | null, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, invalidSymbols?: Array<string> | null }>, activeImagesAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, adSystem: AdSystemT, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, draftState?: AssetLineDraftStateT | null, imageSuggestion?: { __typename?: 'ImageSuggestion', id: string, name: string, kind: ImageSuggestionKindT, height: number, width: number, svgLink: string, assetLineCount: number, disapprovedAt?: any | null } | null, uploadedImage?: { __typename?: 'UploadedImage', id: string, sourceImageUrl: string, croppedImageUrl: string, width: number, height: number, cropX: number, cropY: number, cropHeight: number, cropWidth: number, kind: ImageSuggestionKindT } | null }>, notDeletedTextsAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, content: string, adSystem: AdSystemT, draftState?: AssetLineDraftStateT | null, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, invalidSymbols?: Array<string> | null }>, notDeletedImagesAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, adSystem: AdSystemT, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, draftState?: AssetLineDraftStateT | null, imageSuggestion?: { __typename?: 'ImageSuggestion', id: string, name: string, kind: ImageSuggestionKindT, height: number, width: number, svgLink: string, assetLineCount: number, disapprovedAt?: any | null } | null, uploadedImage?: { __typename?: 'UploadedImage', id: string, sourceImageUrl: string, croppedImageUrl: string, width: number, height: number, cropX: number, cropY: number, cropHeight: number, cropWidth: number, kind: ImageSuggestionKindT } | null }>, validateImages: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null }, validateDraftImages: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null }, validateTexts: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null }, validateDraftTexts: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null } } | null } | null };

export type SelectCategoriesMutationVariablesT = Exact<{
  categoryIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type SelectCategoriesMutationT = { __typename?: 'Mutation', selectCategories?: { __typename?: 'SelectCategoriesPayload', errors?: Array<string> | null, categories: Array<{ __typename?: 'Category', id: string, name?: string | null, selected?: boolean | null }> } | null };

export type SetOrganizationLabelsMutationVariablesT = Exact<{
  labels: Array<Scalars['String']> | Scalars['String'];
}>;


export type SetOrganizationLabelsMutationT = { __typename?: 'Mutation', setOrganizationLabels?: { __typename?: 'SetOrganizationLabelsPayload', errors?: Array<string> | null, organization?: { __typename?: 'Organization', id: string, labels: Array<string> } | null } | null };

export type SetOrganizationNoteMutationVariablesT = Exact<{
  note: Scalars['String'];
}>;


export type SetOrganizationNoteMutationT = { __typename?: 'Mutation', setOrganizationNote?: { __typename?: 'SetOrganizationNotePayload', errors?: Array<string> | null, organization?: { __typename?: 'Organization', id: string, note?: string | null } | null } | null };

export type SetGoogleAdsWizardStepMutationVariablesT = Exact<{
  wizardStep: WizardStepT;
}>;


export type SetGoogleAdsWizardStepMutationT = { __typename?: 'Mutation', setGoogleAdsWizardStep?: { __typename?: 'SetGoogleAdsWizardStepPayload', organization?: { __typename?: 'Organization', id: string, wizardStep: WizardStepT } | null } | null };

export type SetMetaAdsWizardStepMutationVariablesT = Exact<{
  wizardStep: MetaAdsWizardStepT;
}>;


export type SetMetaAdsWizardStepMutationT = { __typename?: 'Mutation', setMetaAdsWizardStep?: { __typename?: 'SetMetaAdsWizardStepPayload', metaAdsSetting?: { __typename?: 'MetaAdsSetting', id: string, wizardStep: MetaAdsWizardStepT } | null } | null };

export type StartSynchronizationMutationVariablesT = Exact<{
  adSystem?: InputMaybe<AdSystemT>;
}>;


export type StartSynchronizationMutationT = { __typename?: 'Mutation', startSynchronization?: { __typename?: 'StartSynchronizationPayload', message?: string | null } | null };

export type UpdateOrganizationMutationVariablesT = Exact<{
  properties: Scalars['JSON'];
}>;


export type UpdateOrganizationMutationT = { __typename?: 'Mutation', updateOrganization?: { __typename?: 'UpdateOrganizationPayload', errors?: Array<string> | null, organization?: { __typename?: 'Organization', id: string, properties: any } | null } | null };

export type UploadImageMutationVariablesT = Exact<{
  image: Scalars['String'];
  filename: Scalars['String'];
  contentType: Scalars['String'];
  kind: ImageSuggestionKindT;
  width: Scalars['Int'];
  height: Scalars['Int'];
  cropX: Scalars['Int'];
  cropY: Scalars['Int'];
  cropWidth: Scalars['Int'];
  cropHeight: Scalars['Int'];
}>;


export type UploadImageMutationT = { __typename?: 'Mutation', uploadImage?: { __typename?: 'UploadImagePayload', errors?: Array<string> | null, uploadedImage?: { __typename?: 'UploadedImage', id: string, sourceImageUrl: string, croppedImageUrl: string, width: number, height: number, cropX: number, cropY: number, cropHeight: number, cropWidth: number, kind: ImageSuggestionKindT } | null } | null };

export type AdSystemCampaignStateQueryVariablesT = Exact<{
  adSystem: AdSystemT;
  dateTo: Scalars['ISO8601Date'];
}>;


export type AdSystemCampaignStateQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, consultationRequestedAt?: any | null, googleAdsSetting?: { __typename?: 'GoogleAdsSetting', id: string, learningState: boolean, optimizationsEnabled: boolean, state?: AdSystemStateT | null, wizardStep: WizardStepT, monthlyBudget: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } } | null, metaAdsSetting?: { __typename?: 'MetaAdsSetting', id: string, learningState: boolean, optimizationsEnabled: boolean, state?: AdSystemStateT | null, wizardStep: MetaAdsWizardStepT, monthlyBudget: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } } | null, summaryStats: { __typename?: 'Stats', id?: string | null, impressions?: number | null, conversions?: number | null }, campaignOptimizations: Array<{ __typename?: 'CampaignOptimization', id: string }> } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null };

export type AdminGmcIssuesQueryVariablesT = Exact<{ [key: string]: never; }>;


export type AdminGmcIssuesQueryT = { __typename?: 'Query', gmcIssues?: Array<{ __typename?: 'GMCIssue', id: string, name: string, count: number, severity: GmcIssueSeverityT }> | null };

export type AdminMetaAdsOrganizationsQueryVariablesT = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  shoptetId?: InputMaybe<Scalars['String']>;
  shoptetUrl?: InputMaybe<Scalars['String']>;
  orderColumn?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<OrderDirectionT>;
  pageClaimRequested?: InputMaybe<Scalars['Boolean']>;
  pageClaimApproved?: InputMaybe<Scalars['Boolean']>;
  businessId?: InputMaybe<Scalars['String']>;
  adAccountId?: InputMaybe<Scalars['String']>;
  pageId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AdSystemStateT>;
}>;


export type AdminMetaAdsOrganizationsQueryT = { __typename?: 'Query', metaAdsOrganizations?: { __typename?: 'OrganizationConnection', nodes: Array<{ __typename?: 'Organization', id: string, shoptetId?: string | null, shoptetUrl?: string | null, adminApiToken?: string | null, metaAdsSetting?: { __typename?: 'MetaAdsSetting', id: string, businessId?: string | null, adAccountId?: string | null, adAccountStatus?: string | null, advertiserVerificationPendingSince?: any | null, pageId?: string | null, pageClaimRequestedAt?: any | null, pageClaimFailureReason?: string | null, pageClaimApproved: boolean, state?: AdSystemStateT | null, wizardStep: MetaAdsWizardStepT, startedAt?: any | null } | null }>, pageInfo: { __typename?: 'PageInfo', total: number, limit: number, endCursor?: string | null, startCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type AdminOrganizationLabelsQueryVariablesT = Exact<{ [key: string]: never; }>;


export type AdminOrganizationLabelsQueryT = { __typename?: 'Query', organizationLabels?: Array<{ __typename?: 'OrganizationLabel', name: string, count: number }> | null };

export type AdminOrganizationsQueryVariablesT = Exact<{
  labels?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  shoptetId?: InputMaybe<Scalars['String']>;
  shoptetUrl?: InputMaybe<Scalars['String']>;
  gmcId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<OrganizationStateT>;
  startedDaysAgo?: InputMaybe<DaysAgoT>;
  orderDirection?: InputMaybe<OrderDirectionT>;
  orderColumn?: InputMaybe<OrganizationsOrderT>;
  adwordsCustomerId?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
}>;


export type AdminOrganizationsQueryT = { __typename?: 'Query', organizations?: { __typename?: 'OrganizationConnection', nodes: Array<{ __typename?: 'Organization', id: string, adwordsCustomerId?: string | null, shoptetUrl?: string | null, shoptetId?: string | null, adminApiToken?: string | null, adminAppPath?: string | null, labels: Array<string>, state?: OrganizationStateT | null, activeAssetsCount: number, disapprovedAssetsCount: number, startedAt?: any | null, createdAt?: any | null, allBannedProductsCount: number, productsCount: number, gmcId?: string | null, gmcAccountSuspended: boolean, metaAdsAccountSuspended: boolean, note?: string | null, archivedAt?: any | null, monthlyBudget: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, creditBalance: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, usedCredits: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, usedSpend?: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } | null, metaAdsSetting?: { __typename?: 'MetaAdsSetting', id: string, businessId?: string | null, adAccountId?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', total: number, limit: number, endCursor?: string | null, startCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type AdminSummaryQueryVariablesT = Exact<{
  dateFromYesterday: Scalars['ISO8601Date'];
  dateFromWeek: Scalars['ISO8601Date'];
  dateFromMonth: Scalars['ISO8601Date'];
  dateFromYear: Scalars['ISO8601Date'];
  labels?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
}>;


export type AdminSummaryQueryT = { __typename?: 'Query', adminSummary?: { __typename?: 'AdminSummary', firstPageOrganizations?: number | null, suggestionGenerationOrganizations?: number | null, imageSelectionOrganizations?: number | null, textSelectionOrganizations?: number | null, checkOrganizations?: number | null, finishWizardOrganizations?: number | null, allOrganizations?: number | null, allAfterWizardOrganizations?: number | null, activeOrganizations?: number | null, pausedOrganizations?: number | null, spendYesterday: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, spendWeek: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, spendMonth: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, spendYear: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, spendAllTime: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, creditYesterday: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, creditWeek: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, creditMonth: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, creditYear: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, creditAllTime: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, statsByTarifMonth: Array<{ __typename?: 'StatsByTarif', tarifName: string, organizationsCount: number, spend: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, credit: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, income: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, averageSpend: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } }>, statsByTarifAllTime: Array<{ __typename?: 'StatsByTarif', tarifName: string, organizationsCount: number, spend: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, credit: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, income: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, averageSpend: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } }>, statsByMonth: Array<{ __typename?: 'StatsByMonth', date: any, organizationsCount: number, spend: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, credit: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, income: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, averageSpend: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } }> } | null };

export type ActiveImagesAssetLinesQueryVariablesT = Exact<{
  adSystem?: InputMaybe<AdSystemT>;
}>;


export type ActiveImagesAssetLinesQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, activeImagesAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, adSystem: AdSystemT, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, draftState?: AssetLineDraftStateT | null, imageSuggestion?: { __typename?: 'ImageSuggestion', id: string, name: string, kind: ImageSuggestionKindT, height: number, width: number, svgLink: string, assetLineCount: number, disapprovedAt?: any | null } | null, uploadedImage?: { __typename?: 'UploadedImage', id: string, sourceImageUrl: string, croppedImageUrl: string, width: number, height: number, cropX: number, cropY: number, cropHeight: number, cropWidth: number, kind: ImageSuggestionKindT } | null }> } | null };

export type ActiveTextsAssetLinesQueryVariablesT = Exact<{
  adSystem?: InputMaybe<AdSystemT>;
}>;


export type ActiveTextsAssetLinesQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, activeTextsAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, content: string, adSystem: AdSystemT, draftState?: AssetLineDraftStateT | null, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, invalidSymbols?: Array<string> | null }> } | null };

export type NotDeletedImagesAssetLinesQueryVariablesT = Exact<{
  adSystem?: InputMaybe<AdSystemT>;
}>;


export type NotDeletedImagesAssetLinesQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, notDeletedImagesAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, adSystem: AdSystemT, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, draftState?: AssetLineDraftStateT | null, imageSuggestion?: { __typename?: 'ImageSuggestion', id: string, name: string, kind: ImageSuggestionKindT, height: number, width: number, svgLink: string, assetLineCount: number, disapprovedAt?: any | null } | null, uploadedImage?: { __typename?: 'UploadedImage', id: string, sourceImageUrl: string, croppedImageUrl: string, width: number, height: number, cropX: number, cropY: number, cropHeight: number, cropWidth: number, kind: ImageSuggestionKindT } | null }> } | null };

export type NotDeletedTextsAssetLinesQueryVariablesT = Exact<{
  adSystem?: InputMaybe<AdSystemT>;
}>;


export type NotDeletedTextsAssetLinesQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, notDeletedTextsAssetLines: Array<{ __typename?: 'AssetLine', id: string, kind: AssetLineKindT, content: string, adSystem: AdSystemT, draftState?: AssetLineDraftStateT | null, googleDisapproved: boolean, googlePerformanceLabel?: GooglePerformanceLabelT | null, invalidSymbols?: Array<string> | null }> } | null };

export type AuditLogsQueryVariablesT = Exact<{
  dateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  dateTo: Scalars['ISO8601Date'];
  page: Scalars['Int'];
  limit: Scalars['Int'];
  adSystem?: InputMaybe<AdSystemT>;
  type?: InputMaybe<AuditLogsT>;
  userEmail?: InputMaybe<Scalars['String']>;
}>;


export type AuditLogsQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, auditLogsCount: number, auditLogs: Array<{ __typename?: 'AuditLog', id: string, type: AuditLogsT, message: string, userEmail?: string | null, createdAt: any, adSystem?: AdSystemT | null, assetLine?: { __typename?: 'AssetLine', id: string, kind: AssetLineKindT, imageSuggestion?: { __typename?: 'ImageSuggestion', id: string, name: string, kind: ImageSuggestionKindT, height: number, width: number, svgLink: string, assetLineCount: number, disapprovedAt?: any | null } | null, uploadedImage?: { __typename?: 'UploadedImage', id: string, sourceImageUrl: string, croppedImageUrl: string, width: number, height: number, cropX: number, cropY: number, cropHeight: number, cropWidth: number, kind: ImageSuggestionKindT } | null } | null }> } | null };

export type CampaignOptimizationsQueryVariablesT = Exact<{
  dateTo: Scalars['ISO8601Date'];
  dateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  limit: Scalars['Int'];
  page: Scalars['Int'];
  adSystem?: InputMaybe<AdSystemT>;
}>;


export type CampaignOptimizationsQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, campaignOptimizations: Array<{ __typename?: 'CampaignOptimization', id: string, createdAt: any, rule: CampaignOptimizationRuleT, type: CampaignOptimizationsT }> } | null };

export type CreditTransactionsQueryVariablesT = Exact<{
  dateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  dateTo: Scalars['ISO8601Date'];
  page: Scalars['Int'];
  limit: Scalars['Int'];
  adSystem?: InputMaybe<AdSystemT>;
  kinds?: InputMaybe<Array<CreditTransactionKindT> | CreditTransactionKindT>;
}>;


export type CreditTransactionsQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, creditTransactionsCount: number, creditTransactions: Array<{ __typename?: 'CreditTransaction', id: string, createdAt: any, kind: CreditTransactionKindT, adSystem?: AdSystemT | null, spend: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, credit: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, usedSpend: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, usedCredit: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } }> } | null };

export type CreditsQueryVariablesT = Exact<{ [key: string]: never; }>;


export type CreditsQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, pendingCreditWithdrawal: boolean, remainingCreditDays: number, remainingCreditDaysAfterStart: number, runningAdSystems: Array<AdSystemT>, googleAdsSetting?: { __typename?: 'GoogleAdsSetting', id: string, monthlyBudget: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } } | null, metaAdsSetting?: { __typename?: 'MetaAdsSetting', id: string, monthlyBudget: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } } | null, creditBalance: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, dailyCredits: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, usedCredits: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, boughtCredits: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, recommendedMonthlyBudget: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, recommendedCreditIncreaseBig: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, recommendedCreditIncreaseSmall: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } } | null };

export type FacebookPageInfoQueryVariablesT = Exact<{ [key: string]: never; }>;


export type FacebookPageInfoQueryT = { __typename?: 'Query', user?: { __typename?: 'User', id: string, email?: string | null } | null, organization?: { __typename?: 'Organization', id: string, metaAdsSetting?: { __typename?: 'MetaAdsSetting', id: string, pageId?: string | null, pageClaimApproved: boolean, pageClaimRequestedAt?: any | null, pageClaimFailureReason?: string | null } | null } | null };

export type GmcIssuesQueryVariablesT = Exact<{ [key: string]: never; }>;


export type GmcIssuesQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, validInStockProductsCount: number, gmcIssues: Array<{ __typename?: 'GMCIssue', id: string, name: string, count: number, severity: GmcIssueSeverityT }> } | null };

export type ImageSuggestionsQueryVariablesT = Exact<{
  kind?: InputMaybe<ImageSuggestionKindT>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type ImageSuggestionsQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, imageSuggestions?: Array<{ __typename?: 'ImageSuggestion', id: string, name: string, kind: ImageSuggestionKindT, height: number, width: number, svgLink: string, assetLineCount: number, disapprovedAt?: any | null }> | null } | null };

export type LastImageSuggestionRequestsQueryVariablesT = Exact<{ [key: string]: never; }>;


export type LastImageSuggestionRequestsQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, lastImageSuggestionRequests: Array<{ __typename?: 'ImageSuggestionRequest', id: string, inProgress: boolean, canFetchMore: boolean }> } | null };

export type LastSuggestionRequestQueryVariablesT = Exact<{ [key: string]: never; }>;


export type LastSuggestionRequestQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, category?: OrganizationCategoryT | null, lastSuggestionRequestsShortHeadline: Array<{ __typename?: 'SuggestionRequest', id: string, inProgress: boolean, createdAt: any, userInput: string, eshopData: any }>, lastSuggestionRequestsLongHeadline: Array<{ __typename?: 'SuggestionRequest', id: string, inProgress: boolean, createdAt: any, userInput: string, eshopData: any }>, lastSuggestionRequestsShortDescription: Array<{ __typename?: 'SuggestionRequest', id: string, inProgress: boolean, createdAt: any, userInput: string, eshopData: any }>, lastSuggestionRequestsLongDescription: Array<{ __typename?: 'SuggestionRequest', id: string, inProgress: boolean, createdAt: any, userInput: string, eshopData: any }> } | null };

export type LaunchRunwayQueryVariablesT = Exact<{
  adSystem: AdSystemT;
}>;


export type LaunchRunwayQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, remainingCreditDays: number, runningAdSystems: Array<AdSystemT> } | null };

export type MonthSummaryStatsQueryVariablesT = Exact<{
  thisMonthDateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  thisMonthDateTo?: InputMaybe<Scalars['ISO8601Date']>;
  lastMonthDateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  lastMonthDateTo?: InputMaybe<Scalars['ISO8601Date']>;
  adSystem?: InputMaybe<AdSystemT>;
}>;


export type MonthSummaryStatsQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, summaryStats: { __typename?: 'Stats', id?: string | null, clicks?: number | null, impressions?: number | null, conversions?: number | null, pno?: number | null, conversionValue?: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } | null, credit?: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } | null, averageConversionValue?: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } | null }, thisMonthStats: { __typename?: 'Stats', id?: string | null, clicks?: number | null, impressions?: number | null, conversions?: number | null, pno?: number | null, conversionValue?: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } | null, credit?: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } | null, averageConversionValue?: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } | null }, lastMonthStats: { __typename?: 'Stats', id?: string | null, clicks?: number | null, impressions?: number | null, conversions?: number | null, pno?: number | null, conversionValue?: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } | null, credit?: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } | null, averageConversionValue?: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } | null } } | null };

export type OrganizationQueryVariablesT = Exact<{ [key: string]: never; }>;


export type OrganizationQueryT = { __typename?: 'Query', env?: string | null, organization?: { __typename?: 'Organization', id: string, shoptetUrl?: string | null, notReadySteps: Array<OrganizationNotReadyStepsT>, wizardStep: WizardStepT, productsCount: number, productsCountState?: ProductsCountStateT | null, outOfStockProductsCount: number, selectableProductsCount: number, categoriesCount: number, productFlagsCount: number, productsCountToSynchronize: number, missingShippingStatus: MissingShippingStatusT, googleShoppingSuspended: boolean, archivedAt?: any | null, organizationDesign?: { __typename?: 'OrganizationDesign', id: string, color1?: string | null, overrideColor1?: string | null, finalColor1?: string | null, color2?: string | null, color3?: string | null, color4?: string | null, logo?: string | null } | null } | null };

export type OrganizationCampaignStateQueryVariablesT = Exact<{ [key: string]: never; }>;


export type OrganizationCampaignStateQueryT = { __typename?: 'Query', env?: string | null, organization?: { __typename?: 'Organization', id: string, enabledFeatureFlags: Array<FeatureFlagT>, notReadySteps: Array<OrganizationNotReadyStepsT>, productsCountState?: ProductsCountStateT | null, shoptetId?: string | null, googleAdsSetting?: { __typename?: 'GoogleAdsSetting', id: string, wizardStep: WizardStepT } | null, metaAdsSetting?: { __typename?: 'MetaAdsSetting', id: string, wizardStep: MetaAdsWizardStepT } | null } | null };

export type OrganizationCategoriesQueryVariablesT = Exact<{ [key: string]: never; }>;


export type OrganizationCategoriesQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, categories: Array<{ __typename?: 'Category', id: string, parentGuid?: string | null, guid?: string | null, name?: string | null, selected?: boolean | null, excluded: boolean }> } | null };

export type OrganizationDataQueryVariablesT = Exact<{ [key: string]: never; }>;


export type OrganizationDataQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, shoptetUrl?: string | null, shoptetEshopName?: string | null, organizationDesign?: { __typename?: 'OrganizationDesign', id: string, color1?: string | null, color2?: string | null, color3?: string | null, color4?: string | null, logo?: string | null } | null, selectedProducts: Array<{ __typename?: 'Product', id: string, name: string, imageUrl: string, price: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } }> } | null };

export type OrganizationEnabledFeatureFlagsQueryVariablesT = Exact<{ [key: string]: never; }>;


export type OrganizationEnabledFeatureFlagsQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, enabledFeatureFlags: Array<FeatureFlagT> } | null };

export type OrganizationMonthlyBudgetQueryVariablesT = Exact<{ [key: string]: never; }>;


export type OrganizationMonthlyBudgetQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, creditBalance: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, googleAdsSetting?: { __typename?: 'GoogleAdsSetting', id: string, state?: AdSystemStateT | null, monthlyBudget: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } } | null, metaAdsSetting?: { __typename?: 'MetaAdsSetting', id: string, state?: AdSystemStateT | null, monthlyBudget: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } } | null, monthlyBudget: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, recommendedMonthlyBudget: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } } | null };

export type OrganizationPaymentsQueryVariablesT = Exact<{
  limit: Scalars['Int'];
  page: Scalars['Int'];
  startCampaignFor?: InputMaybe<AdSystemT>;
}>;


export type OrganizationPaymentsQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, payments: Array<{ __typename?: 'Payment', id: string, state: PaymentStateT, startCampaignFor?: AdSystemT | null }> } | null };

export type OrganizationPaymentsByAdSystemQueryVariablesT = Exact<{
  startCampaignFor: AdSystemT;
  limit: Scalars['Int'];
  page: Scalars['Int'];
}>;


export type OrganizationPaymentsByAdSystemQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, payments: Array<{ __typename?: 'Payment', id: string, state: PaymentStateT, startCampaignFor?: AdSystemT | null }> } | null };

export type OrganizationProductsCountQueryVariablesT = Exact<{ [key: string]: never; }>;


export type OrganizationProductsCountQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, notReadySteps: Array<OrganizationNotReadyStepsT>, productsCount: number, categoriesCount: number, productFlagsCount: number, productsCountToSynchronize: number } | null };

export type OrganizationPropertiesQueryVariablesT = Exact<{ [key: string]: never; }>;


export type OrganizationPropertiesQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, properties: any } | null };

export type OrganizationSettingsQueryVariablesT = Exact<{ [key: string]: never; }>;


export type OrganizationSettingsQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, biddingScheme: BiddingSchemeT, audienceSignals: boolean, extendedConversions: boolean, state?: OrganizationStateT | null, consultationRequestedAt?: any | null, properties: any } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null };

export type OrganizationStateQueryVariablesT = Exact<{
  dateTo: Scalars['ISO8601Date'];
}>;


export type OrganizationStateQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, state?: OrganizationStateT | null, showLearningBanner: boolean, creditBalance: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, usedCredits: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null }, summaryStats: { __typename?: 'Stats', id?: string | null, impressions?: number | null }, campaignOptimizations: Array<{ __typename?: 'CampaignOptimization', id: string }> } | null };

export type OrganizationValidateImagesQueryVariablesT = Exact<{ [key: string]: never; }>;


export type OrganizationValidateImagesQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, validateImages: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null }, validateDraftImages: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null } } | null };

export type OrganizationValidateTextsQueryVariablesT = Exact<{ [key: string]: never; }>;


export type OrganizationValidateTextsQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, validateTexts: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null }, validateDraftTexts: { __typename?: 'ValidationResult', id?: string | null, valid?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', id?: string | null, attribute?: AssetLineKindT | null, kind?: ValidationErrorKindT | null, options?: any | null }> | null } } | null };

export type OrganizationWizardStepsQueryVariablesT = Exact<{ [key: string]: never; }>;


export type OrganizationWizardStepsQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, googleAdsSetting?: { __typename?: 'GoogleAdsSetting', id: string, wizardStep: WizardStepT } | null, metaAdsSetting?: { __typename?: 'MetaAdsSetting', id: string, wizardStep: MetaAdsWizardStepT } | null } | null };

export type PerformanceStatsQueryVariablesT = Exact<{
  dateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  dateTo: Scalars['ISO8601Date'];
  adSystem?: InputMaybe<AdSystemT>;
}>;


export type PerformanceStatsQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, performanceStats: Array<{ __typename?: 'PerformanceStat', id: string, date?: any | null, clicks?: number | null, impressions?: number | null, ctr?: number | null, conversions?: number | null, pno?: number | null, unoptimizedClicks?: number | null, unoptimizedConversions?: number | null, unoptimizedImpressions?: number | null, conversionValue?: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } | null, credit?: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } | null, averageConversionValue?: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } | null, unoptimizedConversionValue?: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } | null }> } | null };

export type ProductExclusionQueryVariablesT = Exact<{
  adSystem: AdSystemT;
}>;


export type ProductExclusionQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, productsCount: number, selectableProductsCount: number, bannedProductsCount: number, outOfStockProductsCount: number, excludedProductsCount: number, excludedProductFlagsProductsCount: number, excludedCategoriesProductsCount: number, productFlags: Array<{ __typename?: 'ProductFlag', id: string, name: string, guid: string, excludedGoogleAds: boolean, excludedMetaAds: boolean, productsCount: number }>, categories: Array<{ __typename?: 'Category', id: string, parentGuid?: string | null, guid?: string | null, name?: string | null, path?: string | null, selected?: boolean | null, excludedGoogleAds: boolean, excludedMetaAds: boolean }> } | null };

export type ProductsQueryVariablesT = Exact<{
  gmcIssueId?: InputMaybe<Scalars['ID']>;
  page: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type ProductsQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, products: Array<{ __typename?: 'Product', id: string, imageUrl: string, name: string, shoptetProductDetailUrl: string, price: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } }> } | null };

export type StopCampaignQuestionnaireStatusQueryVariablesT = Exact<{ [key: string]: never; }>;


export type StopCampaignQuestionnaireStatusQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, properties: any, shoptetId?: string | null } | null, user?: { __typename?: 'User', id: string, email?: string | null } | null };

export type SummaryStatsQueryVariablesT = Exact<{ [key: string]: never; }>;


export type SummaryStatsQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, summaryStats: { __typename?: 'Stats', id?: string | null, clicks?: number | null, impressions?: number | null, conversions?: number | null, pno?: number | null, conversionValue?: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } | null, credit?: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } | null, averageConversionValue?: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } | null } } | null };

export type TextSuggestionsQueryVariablesT = Exact<{
  kind: SuggestionKindT;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type TextSuggestionsQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, textSuggestions?: Array<{ __typename?: 'Suggestion', id: string, content: string, kind: SuggestionKindT, assetLineCount: number, disapprovedAt?: any | null }> | null } | null };

export type UnoptimizedPerformanceStatsQueryVariablesT = Exact<{
  dateFrom?: InputMaybe<Scalars['ISO8601Date']>;
  dateTo: Scalars['ISO8601Date'];
  adSystem?: InputMaybe<AdSystemT>;
}>;


export type UnoptimizedPerformanceStatsQueryT = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, performanceStats: Array<{ __typename?: 'PerformanceStat', id: string, date?: any | null, unoptimizedClicks?: number | null, unoptimizedConversions?: number | null, unoptimizedImpressions?: number | null, unoptimizedConversionValue?: { __typename?: 'Money', amount?: number | null, currency?: CurrencyT | null } | null }> } | null };

export const ImageSuggestionFragmentDocT = gql`
    fragment ImageSuggestion on ImageSuggestion {
  id
  name
  kind
  height
  width
  svgLink
  assetLineCount
  disapprovedAt
}
    `;
export const UploadedImageFragmentDocT = gql`
    fragment UploadedImage on UploadedImage {
  id
  sourceImageUrl
  croppedImageUrl
  width
  height
  cropX
  cropY
  cropHeight
  cropWidth
  kind
}
    `;
export const ActiveImageAssetLineFragmentDocT = gql`
    fragment ActiveImageAssetLine on AssetLine {
  id
  kind
  adSystem
  googleDisapproved
  googlePerformanceLabel
  draftState
  imageSuggestion {
    ...ImageSuggestion
  }
  uploadedImage {
    ...UploadedImage
  }
}
    ${ImageSuggestionFragmentDocT}
${UploadedImageFragmentDocT}`;
export const ActiveTextAssetLineFragmentDocT = gql`
    fragment ActiveTextAssetLine on AssetLine {
  id
  kind
  content
  adSystem
  draftState
  googleDisapproved
  googlePerformanceLabel
  invalidSymbols
}
    `;
export const MoneyFragmentDocT = gql`
    fragment Money on Money {
  amount
  currency
}
    `;
export const OrganizationCreditsFragmentDocT = gql`
    fragment OrganizationCredits on Organization {
  creditBalance {
    ...Money
  }
  dailyCredits {
    ...Money
  }
  usedCredits {
    ...Money
  }
  boughtCredits {
    ...Money
  }
  remainingCreditDays
  remainingCreditDaysAfterStart
  runningAdSystems
  recommendedMonthlyBudget {
    ...Money
  }
  recommendedCreditIncreaseBig {
    ...Money
  }
  recommendedCreditIncreaseSmall {
    ...Money
  }
}
    ${MoneyFragmentDocT}`;
export const ProductFragmentDocT = gql`
    fragment Product on Product {
  id
  name
  price {
    ...Money
  }
  imageUrl
}
    ${MoneyFragmentDocT}`;
export const LastSuggestionRequestFragmentDocT = gql`
    fragment LastSuggestionRequest on SuggestionRequest {
  id
  inProgress
  createdAt
  userInput
  eshopData
}
    `;
export const SummaryStatsFragmentDocT = gql`
    fragment SummaryStats on Stats {
  clicks
  impressions
  conversions
  conversionValue {
    ...Money
  }
  credit {
    ...Money
  }
  averageConversionValue {
    ...Money
  }
  pno
}
    ${MoneyFragmentDocT}`;
export const ValidationResultFragmentDocT = gql`
    fragment ValidationResult on ValidationResult {
  id
  valid
  errors {
    id
    attribute
    kind
    options
  }
}
    `;
export const CampaignSettingsDetailsDocumentT = gql`
    query CampaignSettingsDetails {
  organization {
    id
    startedAt
  }
}
    `;

/**
 * __useCampaignSettingsDetailsQuery__
 *
 * To run a query within a React component, call `useCampaignSettingsDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignSettingsDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignSettingsDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCampaignSettingsDetailsQuery(baseOptions?: Apollo.QueryHookOptions<CampaignSettingsDetailsQueryT, CampaignSettingsDetailsQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignSettingsDetailsQueryT, CampaignSettingsDetailsQueryVariablesT>(CampaignSettingsDetailsDocumentT, options);
      }
export function useCampaignSettingsDetailsLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<CampaignSettingsDetailsQueryT, CampaignSettingsDetailsQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignSettingsDetailsQueryT, CampaignSettingsDetailsQueryVariablesT>(CampaignSettingsDetailsDocumentT, options);
        }
export type CampaignSettingsDetailsQueryHookResult = ReturnType<typeof useCampaignSettingsDetailsQuery>;
export type CampaignSettingsDetailsLazyQueryTHookResult = ReturnType<typeof useCampaignSettingsDetailsLazyQueryT>;
export type CampaignSettingsDetailsQueryResultT = Apollo.QueryResult<CampaignSettingsDetailsQueryT, CampaignSettingsDetailsQueryVariablesT>;
export const AdminCancelMetaPageClaimRequestDocumentT = gql`
    mutation AdminCancelMetaPageClaimRequest {
  adminCancelMetaPageClaimRequest(input: {}) {
    success
    errors
  }
}
    `;
export type AdminCancelMetaPageClaimRequestMutationFnT = Apollo.MutationFunction<AdminCancelMetaPageClaimRequestMutationT, AdminCancelMetaPageClaimRequestMutationVariablesT>;

/**
 * __useAdminCancelMetaPageClaimRequestMutation__
 *
 * To run a mutation, you first call `useAdminCancelMetaPageClaimRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCancelMetaPageClaimRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCancelMetaPageClaimRequestMutation, { data, loading, error }] = useAdminCancelMetaPageClaimRequestMutation({
 *   variables: {
 *   },
 * });
 */
export function useAdminCancelMetaPageClaimRequestMutation(baseOptions?: Apollo.MutationHookOptions<AdminCancelMetaPageClaimRequestMutationT, AdminCancelMetaPageClaimRequestMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCancelMetaPageClaimRequestMutationT, AdminCancelMetaPageClaimRequestMutationVariablesT>(AdminCancelMetaPageClaimRequestDocumentT, options);
      }
export type AdminCancelMetaPageClaimRequestMutationHookResult = ReturnType<typeof useAdminCancelMetaPageClaimRequestMutation>;
export type AdminCancelMetaPageClaimRequestMutationResultT = Apollo.MutationResult<AdminCancelMetaPageClaimRequestMutationT>;
export type AdminCancelMetaPageClaimRequestMutationOptionsT = Apollo.BaseMutationOptions<AdminCancelMetaPageClaimRequestMutationT, AdminCancelMetaPageClaimRequestMutationVariablesT>;
export const AdminIncreaseCreditDocumentT = gql`
    mutation AdminIncreaseCredit($amount: Float!, $currency: Currency!) {
  adminIncreaseCredit(input: {amount: $amount, currency: $currency}) {
    organization {
      id
      creditBalance {
        ...Money
      }
    }
    errors
  }
}
    ${MoneyFragmentDocT}`;
export type AdminIncreaseCreditMutationFnT = Apollo.MutationFunction<AdminIncreaseCreditMutationT, AdminIncreaseCreditMutationVariablesT>;

/**
 * __useAdminIncreaseCreditMutation__
 *
 * To run a mutation, you first call `useAdminIncreaseCreditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminIncreaseCreditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminIncreaseCreditMutation, { data, loading, error }] = useAdminIncreaseCreditMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useAdminIncreaseCreditMutation(baseOptions?: Apollo.MutationHookOptions<AdminIncreaseCreditMutationT, AdminIncreaseCreditMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminIncreaseCreditMutationT, AdminIncreaseCreditMutationVariablesT>(AdminIncreaseCreditDocumentT, options);
      }
export type AdminIncreaseCreditMutationHookResult = ReturnType<typeof useAdminIncreaseCreditMutation>;
export type AdminIncreaseCreditMutationResultT = Apollo.MutationResult<AdminIncreaseCreditMutationT>;
export type AdminIncreaseCreditMutationOptionsT = Apollo.BaseMutationOptions<AdminIncreaseCreditMutationT, AdminIncreaseCreditMutationVariablesT>;
export const AdminResendMetaPageClaimRequestDocumentT = gql`
    mutation AdminResendMetaPageClaimRequest {
  adminResendMetaPageClaimRequest(input: {}) {
    success
    errors
  }
}
    `;
export type AdminResendMetaPageClaimRequestMutationFnT = Apollo.MutationFunction<AdminResendMetaPageClaimRequestMutationT, AdminResendMetaPageClaimRequestMutationVariablesT>;

/**
 * __useAdminResendMetaPageClaimRequestMutation__
 *
 * To run a mutation, you first call `useAdminResendMetaPageClaimRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminResendMetaPageClaimRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminResendMetaPageClaimRequestMutation, { data, loading, error }] = useAdminResendMetaPageClaimRequestMutation({
 *   variables: {
 *   },
 * });
 */
export function useAdminResendMetaPageClaimRequestMutation(baseOptions?: Apollo.MutationHookOptions<AdminResendMetaPageClaimRequestMutationT, AdminResendMetaPageClaimRequestMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminResendMetaPageClaimRequestMutationT, AdminResendMetaPageClaimRequestMutationVariablesT>(AdminResendMetaPageClaimRequestDocumentT, options);
      }
export type AdminResendMetaPageClaimRequestMutationHookResult = ReturnType<typeof useAdminResendMetaPageClaimRequestMutation>;
export type AdminResendMetaPageClaimRequestMutationResultT = Apollo.MutationResult<AdminResendMetaPageClaimRequestMutationT>;
export type AdminResendMetaPageClaimRequestMutationOptionsT = Apollo.BaseMutationOptions<AdminResendMetaPageClaimRequestMutationT, AdminResendMetaPageClaimRequestMutationVariablesT>;
export const ChangeGoogleAdsSettingsStateDocumentT = gql`
    mutation ChangeGoogleAdsSettingsState($input: GoogleAdsChangeSettingsInput!) {
  changeGoogleAdsSettings(input: $input) {
    organization {
      id
      googleAdsSetting {
        id
        state
      }
      creditBalance {
        ...Money
      }
      remainingCreditDays
      remainingCreditDaysAfterStart
      runningAdSystems
    }
    errors
  }
}
    ${MoneyFragmentDocT}`;
export type ChangeGoogleAdsSettingsStateMutationFnT = Apollo.MutationFunction<ChangeGoogleAdsSettingsStateMutationT, ChangeGoogleAdsSettingsStateMutationVariablesT>;

/**
 * __useChangeGoogleAdsSettingsStateMutation__
 *
 * To run a mutation, you first call `useChangeGoogleAdsSettingsStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeGoogleAdsSettingsStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeGoogleAdsSettingsStateMutation, { data, loading, error }] = useChangeGoogleAdsSettingsStateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeGoogleAdsSettingsStateMutation(baseOptions?: Apollo.MutationHookOptions<ChangeGoogleAdsSettingsStateMutationT, ChangeGoogleAdsSettingsStateMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeGoogleAdsSettingsStateMutationT, ChangeGoogleAdsSettingsStateMutationVariablesT>(ChangeGoogleAdsSettingsStateDocumentT, options);
      }
export type ChangeGoogleAdsSettingsStateMutationHookResult = ReturnType<typeof useChangeGoogleAdsSettingsStateMutation>;
export type ChangeGoogleAdsSettingsStateMutationResultT = Apollo.MutationResult<ChangeGoogleAdsSettingsStateMutationT>;
export type ChangeGoogleAdsSettingsStateMutationOptionsT = Apollo.BaseMutationOptions<ChangeGoogleAdsSettingsStateMutationT, ChangeGoogleAdsSettingsStateMutationVariablesT>;
export const ChangeMetaAdsSettingsStateDocumentT = gql`
    mutation ChangeMetaAdsSettingsState($input: MetaAdsChangeSettingsInput!) {
  changeMetaAdsSettings(input: $input) {
    metaAdsSetting {
      id
      state
    }
    organization {
      id
      creditBalance {
        ...Money
      }
      remainingCreditDays
      remainingCreditDaysAfterStart
      runningAdSystems
    }
    errors
  }
}
    ${MoneyFragmentDocT}`;
export type ChangeMetaAdsSettingsStateMutationFnT = Apollo.MutationFunction<ChangeMetaAdsSettingsStateMutationT, ChangeMetaAdsSettingsStateMutationVariablesT>;

/**
 * __useChangeMetaAdsSettingsStateMutation__
 *
 * To run a mutation, you first call `useChangeMetaAdsSettingsStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeMetaAdsSettingsStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeMetaAdsSettingsStateMutation, { data, loading, error }] = useChangeMetaAdsSettingsStateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeMetaAdsSettingsStateMutation(baseOptions?: Apollo.MutationHookOptions<ChangeMetaAdsSettingsStateMutationT, ChangeMetaAdsSettingsStateMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeMetaAdsSettingsStateMutationT, ChangeMetaAdsSettingsStateMutationVariablesT>(ChangeMetaAdsSettingsStateDocumentT, options);
      }
export type ChangeMetaAdsSettingsStateMutationHookResult = ReturnType<typeof useChangeMetaAdsSettingsStateMutation>;
export type ChangeMetaAdsSettingsStateMutationResultT = Apollo.MutationResult<ChangeMetaAdsSettingsStateMutationT>;
export type ChangeMetaAdsSettingsStateMutationOptionsT = Apollo.BaseMutationOptions<ChangeMetaAdsSettingsStateMutationT, ChangeMetaAdsSettingsStateMutationVariablesT>;
export const ChangeCampaignSettingsDocumentT = gql`
    mutation ChangeCampaignSettings($biddingScheme: BiddingScheme, $audienceSignals: Boolean, $extendedConversions: Boolean, $state: AdSystemState) {
  changeCampaignSettings(
    input: {biddingScheme: $biddingScheme, audienceSignals: $audienceSignals, extendedConversions: $extendedConversions, state: $state}
  ) {
    organization {
      id
      biddingScheme
      audienceSignals
      extendedConversions
      state
    }
    errors
  }
}
    `;
export type ChangeCampaignSettingsMutationFnT = Apollo.MutationFunction<ChangeCampaignSettingsMutationT, ChangeCampaignSettingsMutationVariablesT>;

/**
 * __useChangeCampaignSettingsMutation__
 *
 * To run a mutation, you first call `useChangeCampaignSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCampaignSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCampaignSettingsMutation, { data, loading, error }] = useChangeCampaignSettingsMutation({
 *   variables: {
 *      biddingScheme: // value for 'biddingScheme'
 *      audienceSignals: // value for 'audienceSignals'
 *      extendedConversions: // value for 'extendedConversions'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useChangeCampaignSettingsMutation(baseOptions?: Apollo.MutationHookOptions<ChangeCampaignSettingsMutationT, ChangeCampaignSettingsMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeCampaignSettingsMutationT, ChangeCampaignSettingsMutationVariablesT>(ChangeCampaignSettingsDocumentT, options);
      }
export type ChangeCampaignSettingsMutationHookResult = ReturnType<typeof useChangeCampaignSettingsMutation>;
export type ChangeCampaignSettingsMutationResultT = Apollo.MutationResult<ChangeCampaignSettingsMutationT>;
export type ChangeCampaignSettingsMutationOptionsT = Apollo.BaseMutationOptions<ChangeCampaignSettingsMutationT, ChangeCampaignSettingsMutationVariablesT>;
export const ChangeMetaAdsSettingsDocumentT = gql`
    mutation ChangeMetaAdsSettings($pageId: String) {
  changeMetaAdsSettings(input: {pageId: $pageId}) {
    metaAdsSetting {
      id
      pageId
      pageClaimApproved
      pageClaimRequestedAt
      pageClaimFailureReason
      state
    }
    errors
  }
}
    `;
export type ChangeMetaAdsSettingsMutationFnT = Apollo.MutationFunction<ChangeMetaAdsSettingsMutationT, ChangeMetaAdsSettingsMutationVariablesT>;

/**
 * __useChangeMetaAdsSettingsMutation__
 *
 * To run a mutation, you first call `useChangeMetaAdsSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeMetaAdsSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeMetaAdsSettingsMutation, { data, loading, error }] = useChangeMetaAdsSettingsMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useChangeMetaAdsSettingsMutation(baseOptions?: Apollo.MutationHookOptions<ChangeMetaAdsSettingsMutationT, ChangeMetaAdsSettingsMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeMetaAdsSettingsMutationT, ChangeMetaAdsSettingsMutationVariablesT>(ChangeMetaAdsSettingsDocumentT, options);
      }
export type ChangeMetaAdsSettingsMutationHookResult = ReturnType<typeof useChangeMetaAdsSettingsMutation>;
export type ChangeMetaAdsSettingsMutationResultT = Apollo.MutationResult<ChangeMetaAdsSettingsMutationT>;
export type ChangeMetaAdsSettingsMutationOptionsT = Apollo.BaseMutationOptions<ChangeMetaAdsSettingsMutationT, ChangeMetaAdsSettingsMutationVariablesT>;
export const ChangeMonthlyBudgetDocumentT = gql`
    mutation ChangeMonthlyBudget($adSystem: AdSystem!, $currency: String!, $monthlyBudget: Float!) {
  changeMonthlyBudget(
    input: {adSystem: $adSystem, currency: $currency, monthlyBudget: $monthlyBudget}
  ) {
    organization {
      id
      googleAdsSetting {
        id
        monthlyBudget {
          ...Money
        }
      }
      metaAdsSetting {
        id
        monthlyBudget {
          ...Money
        }
      }
      monthlyBudget {
        ...Money
      }
      dailyCredits {
        ...Money
      }
      ...OrganizationCredits
    }
    errors
  }
}
    ${MoneyFragmentDocT}
${OrganizationCreditsFragmentDocT}`;
export type ChangeMonthlyBudgetMutationFnT = Apollo.MutationFunction<ChangeMonthlyBudgetMutationT, ChangeMonthlyBudgetMutationVariablesT>;

/**
 * __useChangeMonthlyBudgetMutation__
 *
 * To run a mutation, you first call `useChangeMonthlyBudgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeMonthlyBudgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeMonthlyBudgetMutation, { data, loading, error }] = useChangeMonthlyBudgetMutation({
 *   variables: {
 *      adSystem: // value for 'adSystem'
 *      currency: // value for 'currency'
 *      monthlyBudget: // value for 'monthlyBudget'
 *   },
 * });
 */
export function useChangeMonthlyBudgetMutation(baseOptions?: Apollo.MutationHookOptions<ChangeMonthlyBudgetMutationT, ChangeMonthlyBudgetMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeMonthlyBudgetMutationT, ChangeMonthlyBudgetMutationVariablesT>(ChangeMonthlyBudgetDocumentT, options);
      }
export type ChangeMonthlyBudgetMutationHookResult = ReturnType<typeof useChangeMonthlyBudgetMutation>;
export type ChangeMonthlyBudgetMutationResultT = Apollo.MutationResult<ChangeMonthlyBudgetMutationT>;
export type ChangeMonthlyBudgetMutationOptionsT = Apollo.BaseMutationOptions<ChangeMonthlyBudgetMutationT, ChangeMonthlyBudgetMutationVariablesT>;
export const ChangeOrganizationDesignDocumentT = gql`
    mutation ChangeOrganizationDesign($overrideColor1: String) {
  changeOrganizationDesign(input: {overrideColor1: $overrideColor1}) {
    errors
  }
}
    `;
export type ChangeOrganizationDesignMutationFnT = Apollo.MutationFunction<ChangeOrganizationDesignMutationT, ChangeOrganizationDesignMutationVariablesT>;

/**
 * __useChangeOrganizationDesignMutation__
 *
 * To run a mutation, you first call `useChangeOrganizationDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeOrganizationDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeOrganizationDesignMutation, { data, loading, error }] = useChangeOrganizationDesignMutation({
 *   variables: {
 *      overrideColor1: // value for 'overrideColor1'
 *   },
 * });
 */
export function useChangeOrganizationDesignMutation(baseOptions?: Apollo.MutationHookOptions<ChangeOrganizationDesignMutationT, ChangeOrganizationDesignMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeOrganizationDesignMutationT, ChangeOrganizationDesignMutationVariablesT>(ChangeOrganizationDesignDocumentT, options);
      }
export type ChangeOrganizationDesignMutationHookResult = ReturnType<typeof useChangeOrganizationDesignMutation>;
export type ChangeOrganizationDesignMutationResultT = Apollo.MutationResult<ChangeOrganizationDesignMutationT>;
export type ChangeOrganizationDesignMutationOptionsT = Apollo.BaseMutationOptions<ChangeOrganizationDesignMutationT, ChangeOrganizationDesignMutationVariablesT>;
export const CheckMetaAdsClaimPageApprovalDocumentT = gql`
    mutation CheckMetaAdsClaimPageApproval {
  checkMetaAdsClaimPageApproval(input: {}) {
    errors
  }
}
    `;
export type CheckMetaAdsClaimPageApprovalMutationFnT = Apollo.MutationFunction<CheckMetaAdsClaimPageApprovalMutationT, CheckMetaAdsClaimPageApprovalMutationVariablesT>;

/**
 * __useCheckMetaAdsClaimPageApprovalMutation__
 *
 * To run a mutation, you first call `useCheckMetaAdsClaimPageApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckMetaAdsClaimPageApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkMetaAdsClaimPageApprovalMutation, { data, loading, error }] = useCheckMetaAdsClaimPageApprovalMutation({
 *   variables: {
 *   },
 * });
 */
export function useCheckMetaAdsClaimPageApprovalMutation(baseOptions?: Apollo.MutationHookOptions<CheckMetaAdsClaimPageApprovalMutationT, CheckMetaAdsClaimPageApprovalMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckMetaAdsClaimPageApprovalMutationT, CheckMetaAdsClaimPageApprovalMutationVariablesT>(CheckMetaAdsClaimPageApprovalDocumentT, options);
      }
export type CheckMetaAdsClaimPageApprovalMutationHookResult = ReturnType<typeof useCheckMetaAdsClaimPageApprovalMutation>;
export type CheckMetaAdsClaimPageApprovalMutationResultT = Apollo.MutationResult<CheckMetaAdsClaimPageApprovalMutationT>;
export type CheckMetaAdsClaimPageApprovalMutationOptionsT = Apollo.BaseMutationOptions<CheckMetaAdsClaimPageApprovalMutationT, CheckMetaAdsClaimPageApprovalMutationVariablesT>;
export const CreateAssetLineDocumentT = gql`
    mutation CreateAssetLine($content: String!, $kind: AssetLineKind!, $suggestionId: String, $imageSuggestionId: String, $draft: Boolean, $adSystem: AdSystem = GOOGLE_ADS) {
  createAssetLine(
    input: {content: $content, draft: $draft, kind: $kind, suggestionId: $suggestionId, imageSuggestionId: $imageSuggestionId, adSystem: $adSystem}
  ) {
    assetLine {
      id
      invalidSymbols
      imageSuggestion {
        id
        assetLineCount
      }
      suggestion {
        id
        assetLineCount
      }
    }
    organization {
      id
      activeTextsAssetLines(adSystem: $adSystem) {
        ...ActiveTextAssetLine
      }
      activeImagesAssetLines(adSystem: $adSystem) {
        ...ActiveImageAssetLine
      }
      notDeletedTextsAssetLines(adSystem: $adSystem) {
        ...ActiveTextAssetLine
      }
      notDeletedImagesAssetLines(adSystem: $adSystem) {
        ...ActiveImageAssetLine
      }
      validateImages {
        ...ValidationResult
      }
      validateDraftImages {
        ...ValidationResult
      }
      validateTexts {
        ...ValidationResult
      }
      validateDraftTexts {
        ...ValidationResult
      }
    }
    errors
  }
}
    ${ActiveTextAssetLineFragmentDocT}
${ActiveImageAssetLineFragmentDocT}
${ValidationResultFragmentDocT}`;
export type CreateAssetLineMutationFnT = Apollo.MutationFunction<CreateAssetLineMutationT, CreateAssetLineMutationVariablesT>;

/**
 * __useCreateAssetLineMutation__
 *
 * To run a mutation, you first call `useCreateAssetLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssetLineMutation, { data, loading, error }] = useCreateAssetLineMutation({
 *   variables: {
 *      content: // value for 'content'
 *      kind: // value for 'kind'
 *      suggestionId: // value for 'suggestionId'
 *      imageSuggestionId: // value for 'imageSuggestionId'
 *      draft: // value for 'draft'
 *      adSystem: // value for 'adSystem'
 *   },
 * });
 */
export function useCreateAssetLineMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssetLineMutationT, CreateAssetLineMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssetLineMutationT, CreateAssetLineMutationVariablesT>(CreateAssetLineDocumentT, options);
      }
export type CreateAssetLineMutationHookResult = ReturnType<typeof useCreateAssetLineMutation>;
export type CreateAssetLineMutationResultT = Apollo.MutationResult<CreateAssetLineMutationT>;
export type CreateAssetLineMutationOptionsT = Apollo.BaseMutationOptions<CreateAssetLineMutationT, CreateAssetLineMutationVariablesT>;
export const CreateImageAssetLineDocumentT = gql`
    mutation CreateImageAssetLine($cropX: Int!, $cropY: Int!, $cropWidth: Int!, $cropHeight: Int!, $uploadedImageId: String!, $draft: Boolean, $adSystem: AdSystem = GOOGLE_ADS) {
  createImageAssetLine(
    input: {draft: $draft, cropX: $cropX, cropY: $cropY, cropWidth: $cropWidth, cropHeight: $cropHeight, uploadedImageId: $uploadedImageId}
  ) {
    assetLine {
      id
    }
    organization {
      id
      activeTextsAssetLines(adSystem: $adSystem) {
        ...ActiveTextAssetLine
      }
      activeImagesAssetLines(adSystem: $adSystem) {
        ...ActiveImageAssetLine
      }
      notDeletedTextsAssetLines(adSystem: $adSystem) {
        ...ActiveTextAssetLine
      }
      notDeletedImagesAssetLines(adSystem: $adSystem) {
        ...ActiveImageAssetLine
      }
      validateImages {
        ...ValidationResult
      }
      validateDraftImages {
        ...ValidationResult
      }
      validateTexts {
        ...ValidationResult
      }
      validateDraftTexts {
        ...ValidationResult
      }
    }
    errors
  }
}
    ${ActiveTextAssetLineFragmentDocT}
${ActiveImageAssetLineFragmentDocT}
${ValidationResultFragmentDocT}`;
export type CreateImageAssetLineMutationFnT = Apollo.MutationFunction<CreateImageAssetLineMutationT, CreateImageAssetLineMutationVariablesT>;

/**
 * __useCreateImageAssetLineMutation__
 *
 * To run a mutation, you first call `useCreateImageAssetLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImageAssetLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImageAssetLineMutation, { data, loading, error }] = useCreateImageAssetLineMutation({
 *   variables: {
 *      cropX: // value for 'cropX'
 *      cropY: // value for 'cropY'
 *      cropWidth: // value for 'cropWidth'
 *      cropHeight: // value for 'cropHeight'
 *      uploadedImageId: // value for 'uploadedImageId'
 *      draft: // value for 'draft'
 *      adSystem: // value for 'adSystem'
 *   },
 * });
 */
export function useCreateImageAssetLineMutation(baseOptions?: Apollo.MutationHookOptions<CreateImageAssetLineMutationT, CreateImageAssetLineMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateImageAssetLineMutationT, CreateImageAssetLineMutationVariablesT>(CreateImageAssetLineDocumentT, options);
      }
export type CreateImageAssetLineMutationHookResult = ReturnType<typeof useCreateImageAssetLineMutation>;
export type CreateImageAssetLineMutationResultT = Apollo.MutationResult<CreateImageAssetLineMutationT>;
export type CreateImageAssetLineMutationOptionsT = Apollo.BaseMutationOptions<CreateImageAssetLineMutationT, CreateImageAssetLineMutationVariablesT>;
export const DecreaseCreditDocumentT = gql`
    mutation DecreaseCredit($amount: Float!, $currency: Currency!) {
  decreaseCredit(input: {amount: $amount, currency: $currency}) {
    errors
  }
}
    `;
export type DecreaseCreditMutationFnT = Apollo.MutationFunction<DecreaseCreditMutationT, DecreaseCreditMutationVariablesT>;

/**
 * __useDecreaseCreditMutation__
 *
 * To run a mutation, you first call `useDecreaseCreditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDecreaseCreditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [decreaseCreditMutation, { data, loading, error }] = useDecreaseCreditMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useDecreaseCreditMutation(baseOptions?: Apollo.MutationHookOptions<DecreaseCreditMutationT, DecreaseCreditMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DecreaseCreditMutationT, DecreaseCreditMutationVariablesT>(DecreaseCreditDocumentT, options);
      }
export type DecreaseCreditMutationHookResult = ReturnType<typeof useDecreaseCreditMutation>;
export type DecreaseCreditMutationResultT = Apollo.MutationResult<DecreaseCreditMutationT>;
export type DecreaseCreditMutationOptionsT = Apollo.BaseMutationOptions<DecreaseCreditMutationT, DecreaseCreditMutationVariablesT>;
export const DeleteAssetLineDocumentT = gql`
    mutation DeleteAssetLine($id: String!, $draft: Boolean, $adSystem: AdSystem = GOOGLE_ADS) {
  deleteAssetLine(input: {id: $id, draft: $draft}) {
    assetLine {
      id
    }
    organization {
      id
      activeTextsAssetLines(adSystem: $adSystem) {
        ...ActiveTextAssetLine
      }
      activeImagesAssetLines(adSystem: $adSystem) {
        ...ActiveImageAssetLine
      }
      notDeletedTextsAssetLines(adSystem: $adSystem) {
        ...ActiveTextAssetLine
      }
      notDeletedImagesAssetLines(adSystem: $adSystem) {
        ...ActiveImageAssetLine
      }
      validateImages {
        ...ValidationResult
      }
      validateDraftImages {
        ...ValidationResult
      }
      validateTexts {
        ...ValidationResult
      }
      validateDraftTexts {
        ...ValidationResult
      }
    }
    errors
  }
}
    ${ActiveTextAssetLineFragmentDocT}
${ActiveImageAssetLineFragmentDocT}
${ValidationResultFragmentDocT}`;
export type DeleteAssetLineMutationFnT = Apollo.MutationFunction<DeleteAssetLineMutationT, DeleteAssetLineMutationVariablesT>;

/**
 * __useDeleteAssetLineMutation__
 *
 * To run a mutation, you first call `useDeleteAssetLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssetLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssetLineMutation, { data, loading, error }] = useDeleteAssetLineMutation({
 *   variables: {
 *      id: // value for 'id'
 *      draft: // value for 'draft'
 *      adSystem: // value for 'adSystem'
 *   },
 * });
 */
export function useDeleteAssetLineMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssetLineMutationT, DeleteAssetLineMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssetLineMutationT, DeleteAssetLineMutationVariablesT>(DeleteAssetLineDocumentT, options);
      }
export type DeleteAssetLineMutationHookResult = ReturnType<typeof useDeleteAssetLineMutation>;
export type DeleteAssetLineMutationResultT = Apollo.MutationResult<DeleteAssetLineMutationT>;
export type DeleteAssetLineMutationOptionsT = Apollo.BaseMutationOptions<DeleteAssetLineMutationT, DeleteAssetLineMutationVariablesT>;
export const DisapproveSuggestionDocumentT = gql`
    mutation DisapproveSuggestion($id: String!) {
  disapproveSuggestion(input: {id: $id}) {
    suggestion {
      id
      disapprovedAt
    }
    imageSuggestion {
      id
      disapprovedAt
    }
    errors
  }
}
    `;
export type DisapproveSuggestionMutationFnT = Apollo.MutationFunction<DisapproveSuggestionMutationT, DisapproveSuggestionMutationVariablesT>;

/**
 * __useDisapproveSuggestionMutation__
 *
 * To run a mutation, you first call `useDisapproveSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisapproveSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disapproveSuggestionMutation, { data, loading, error }] = useDisapproveSuggestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisapproveSuggestionMutation(baseOptions?: Apollo.MutationHookOptions<DisapproveSuggestionMutationT, DisapproveSuggestionMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisapproveSuggestionMutationT, DisapproveSuggestionMutationVariablesT>(DisapproveSuggestionDocumentT, options);
      }
export type DisapproveSuggestionMutationHookResult = ReturnType<typeof useDisapproveSuggestionMutation>;
export type DisapproveSuggestionMutationResultT = Apollo.MutationResult<DisapproveSuggestionMutationT>;
export type DisapproveSuggestionMutationOptionsT = Apollo.BaseMutationOptions<DisapproveSuggestionMutationT, DisapproveSuggestionMutationVariablesT>;
export const DiscardDraftAssetLinesDocumentT = gql`
    mutation DiscardDraftAssetLines($kinds: [AssetLineKind!], $adSystem: AdSystem = GOOGLE_ADS) {
  discardDraftAssetLines(input: {kinds: $kinds}) {
    assetLines {
      id
    }
    organization {
      id
      activeTextsAssetLines(adSystem: $adSystem) {
        ...ActiveTextAssetLine
      }
      activeImagesAssetLines(adSystem: $adSystem) {
        ...ActiveImageAssetLine
      }
      notDeletedTextsAssetLines(adSystem: $adSystem) {
        ...ActiveTextAssetLine
      }
      notDeletedImagesAssetLines(adSystem: $adSystem) {
        ...ActiveImageAssetLine
      }
      validateImages {
        ...ValidationResult
      }
      validateDraftImages {
        ...ValidationResult
      }
      validateTexts {
        ...ValidationResult
      }
      validateDraftTexts {
        ...ValidationResult
      }
    }
    errors
  }
}
    ${ActiveTextAssetLineFragmentDocT}
${ActiveImageAssetLineFragmentDocT}
${ValidationResultFragmentDocT}`;
export type DiscardDraftAssetLinesMutationFnT = Apollo.MutationFunction<DiscardDraftAssetLinesMutationT, DiscardDraftAssetLinesMutationVariablesT>;

/**
 * __useDiscardDraftAssetLinesMutation__
 *
 * To run a mutation, you first call `useDiscardDraftAssetLinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscardDraftAssetLinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discardDraftAssetLinesMutation, { data, loading, error }] = useDiscardDraftAssetLinesMutation({
 *   variables: {
 *      kinds: // value for 'kinds'
 *      adSystem: // value for 'adSystem'
 *   },
 * });
 */
export function useDiscardDraftAssetLinesMutation(baseOptions?: Apollo.MutationHookOptions<DiscardDraftAssetLinesMutationT, DiscardDraftAssetLinesMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DiscardDraftAssetLinesMutationT, DiscardDraftAssetLinesMutationVariablesT>(DiscardDraftAssetLinesDocumentT, options);
      }
export type DiscardDraftAssetLinesMutationHookResult = ReturnType<typeof useDiscardDraftAssetLinesMutation>;
export type DiscardDraftAssetLinesMutationResultT = Apollo.MutationResult<DiscardDraftAssetLinesMutationT>;
export type DiscardDraftAssetLinesMutationOptionsT = Apollo.BaseMutationOptions<DiscardDraftAssetLinesMutationT, DiscardDraftAssetLinesMutationVariablesT>;
export const ExcludeCategoriesDocumentT = gql`
    mutation ExcludeCategories($categoryIds: [String!]!, $adSystem: AdSystem) {
  excludeCategories(input: {categoryIds: $categoryIds, adSystem: $adSystem}) {
    organization {
      id
      excludedCategoriesProductsCount
      excludedProductsCount
      selectableProductsCount
    }
    categories {
      id
      name
      excludedGoogleAds
      excludedMetaAds
    }
    errors
  }
}
    `;
export type ExcludeCategoriesMutationFnT = Apollo.MutationFunction<ExcludeCategoriesMutationT, ExcludeCategoriesMutationVariablesT>;

/**
 * __useExcludeCategoriesMutation__
 *
 * To run a mutation, you first call `useExcludeCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcludeCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excludeCategoriesMutation, { data, loading, error }] = useExcludeCategoriesMutation({
 *   variables: {
 *      categoryIds: // value for 'categoryIds'
 *      adSystem: // value for 'adSystem'
 *   },
 * });
 */
export function useExcludeCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<ExcludeCategoriesMutationT, ExcludeCategoriesMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExcludeCategoriesMutationT, ExcludeCategoriesMutationVariablesT>(ExcludeCategoriesDocumentT, options);
      }
export type ExcludeCategoriesMutationHookResult = ReturnType<typeof useExcludeCategoriesMutation>;
export type ExcludeCategoriesMutationResultT = Apollo.MutationResult<ExcludeCategoriesMutationT>;
export type ExcludeCategoriesMutationOptionsT = Apollo.BaseMutationOptions<ExcludeCategoriesMutationT, ExcludeCategoriesMutationVariablesT>;
export const ExcludeProductFlagsDocumentT = gql`
    mutation ExcludeProductFlags($productFlagIds: [String!]!, $adSystem: AdSystem) {
  excludeProductFlags(
    input: {productFlagIds: $productFlagIds, adSystem: $adSystem}
  ) {
    organization {
      id
      excludedProductFlagsProductsCount
      excludedProductsCount
      selectableProductsCount
    }
    productFlags {
      id
      name
      excludedGoogleAds
      excludedMetaAds
    }
    errors
  }
}
    `;
export type ExcludeProductFlagsMutationFnT = Apollo.MutationFunction<ExcludeProductFlagsMutationT, ExcludeProductFlagsMutationVariablesT>;

/**
 * __useExcludeProductFlagsMutation__
 *
 * To run a mutation, you first call `useExcludeProductFlagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcludeProductFlagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excludeProductFlagsMutation, { data, loading, error }] = useExcludeProductFlagsMutation({
 *   variables: {
 *      productFlagIds: // value for 'productFlagIds'
 *      adSystem: // value for 'adSystem'
 *   },
 * });
 */
export function useExcludeProductFlagsMutation(baseOptions?: Apollo.MutationHookOptions<ExcludeProductFlagsMutationT, ExcludeProductFlagsMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExcludeProductFlagsMutationT, ExcludeProductFlagsMutationVariablesT>(ExcludeProductFlagsDocumentT, options);
      }
export type ExcludeProductFlagsMutationHookResult = ReturnType<typeof useExcludeProductFlagsMutation>;
export type ExcludeProductFlagsMutationResultT = Apollo.MutationResult<ExcludeProductFlagsMutationT>;
export type ExcludeProductFlagsMutationOptionsT = Apollo.BaseMutationOptions<ExcludeProductFlagsMutationT, ExcludeProductFlagsMutationVariablesT>;
export const InitiatePaymentDocumentT = gql`
    mutation InitiatePayment($amount: Float!, $currency: Currency!, $returnUrl: String, $startCampaignFor: AdSystem) {
  initiatePayment(
    input: {amount: $amount, currency: $currency, returnUrl: $returnUrl, startCampaignFor: $startCampaignFor}
  ) {
    payment {
      id
      urlToPay
    }
    errors
  }
}
    `;
export type InitiatePaymentMutationFnT = Apollo.MutationFunction<InitiatePaymentMutationT, InitiatePaymentMutationVariablesT>;

/**
 * __useInitiatePaymentMutation__
 *
 * To run a mutation, you first call `useInitiatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiatePaymentMutation, { data, loading, error }] = useInitiatePaymentMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      currency: // value for 'currency'
 *      returnUrl: // value for 'returnUrl'
 *      startCampaignFor: // value for 'startCampaignFor'
 *   },
 * });
 */
export function useInitiatePaymentMutation(baseOptions?: Apollo.MutationHookOptions<InitiatePaymentMutationT, InitiatePaymentMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiatePaymentMutationT, InitiatePaymentMutationVariablesT>(InitiatePaymentDocumentT, options);
      }
export type InitiatePaymentMutationHookResult = ReturnType<typeof useInitiatePaymentMutation>;
export type InitiatePaymentMutationResultT = Apollo.MutationResult<InitiatePaymentMutationT>;
export type InitiatePaymentMutationOptionsT = Apollo.BaseMutationOptions<InitiatePaymentMutationT, InitiatePaymentMutationVariablesT>;
export const LeaveWizardDocumentT = gql`
    mutation LeaveWizard($adSystem: AdSystem!) {
  leaveWizard(input: {adSystem: $adSystem}) {
    organization {
      id
      googleAdsSetting {
        id
        state
        wizardStep
      }
      metaAdsSetting {
        id
        state
        wizardStep
      }
    }
    errors
  }
}
    `;
export type LeaveWizardMutationFnT = Apollo.MutationFunction<LeaveWizardMutationT, LeaveWizardMutationVariablesT>;

/**
 * __useLeaveWizardMutation__
 *
 * To run a mutation, you first call `useLeaveWizardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveWizardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveWizardMutation, { data, loading, error }] = useLeaveWizardMutation({
 *   variables: {
 *      adSystem: // value for 'adSystem'
 *   },
 * });
 */
export function useLeaveWizardMutation(baseOptions?: Apollo.MutationHookOptions<LeaveWizardMutationT, LeaveWizardMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveWizardMutationT, LeaveWizardMutationVariablesT>(LeaveWizardDocumentT, options);
      }
export type LeaveWizardMutationHookResult = ReturnType<typeof useLeaveWizardMutation>;
export type LeaveWizardMutationResultT = Apollo.MutationResult<LeaveWizardMutationT>;
export type LeaveWizardMutationOptionsT = Apollo.BaseMutationOptions<LeaveWizardMutationT, LeaveWizardMutationVariablesT>;
export const OnboardingEnteredDocumentT = gql`
    mutation OnboardingEntered {
  updateOrganization(input: {onboardingEntered: true}) {
    organization {
      id
    }
    errors
  }
}
    `;
export type OnboardingEnteredMutationFnT = Apollo.MutationFunction<OnboardingEnteredMutationT, OnboardingEnteredMutationVariablesT>;

/**
 * __useOnboardingEnteredMutation__
 *
 * To run a mutation, you first call `useOnboardingEnteredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardingEnteredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardingEnteredMutation, { data, loading, error }] = useOnboardingEnteredMutation({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingEnteredMutation(baseOptions?: Apollo.MutationHookOptions<OnboardingEnteredMutationT, OnboardingEnteredMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardingEnteredMutationT, OnboardingEnteredMutationVariablesT>(OnboardingEnteredDocumentT, options);
      }
export type OnboardingEnteredMutationHookResult = ReturnType<typeof useOnboardingEnteredMutation>;
export type OnboardingEnteredMutationResultT = Apollo.MutationResult<OnboardingEnteredMutationT>;
export type OnboardingEnteredMutationOptionsT = Apollo.BaseMutationOptions<OnboardingEnteredMutationT, OnboardingEnteredMutationVariablesT>;
export const PublishDraftAssetLinesDocumentT = gql`
    mutation PublishDraftAssetLines($kinds: [AssetLineKind!], $adSystem: AdSystem = GOOGLE_ADS) {
  publishDraftAssetLines(input: {kinds: $kinds}) {
    assetLines {
      id
    }
    organization {
      id
      activeTextsAssetLines(adSystem: $adSystem) {
        ...ActiveTextAssetLine
      }
      activeImagesAssetLines(adSystem: $adSystem) {
        ...ActiveImageAssetLine
      }
      notDeletedTextsAssetLines(adSystem: $adSystem) {
        ...ActiveTextAssetLine
      }
      notDeletedImagesAssetLines(adSystem: $adSystem) {
        ...ActiveImageAssetLine
      }
      validateImages {
        ...ValidationResult
      }
      validateDraftImages {
        ...ValidationResult
      }
      validateTexts {
        ...ValidationResult
      }
      validateDraftTexts {
        ...ValidationResult
      }
    }
    errors
  }
}
    ${ActiveTextAssetLineFragmentDocT}
${ActiveImageAssetLineFragmentDocT}
${ValidationResultFragmentDocT}`;
export type PublishDraftAssetLinesMutationFnT = Apollo.MutationFunction<PublishDraftAssetLinesMutationT, PublishDraftAssetLinesMutationVariablesT>;

/**
 * __usePublishDraftAssetLinesMutation__
 *
 * To run a mutation, you first call `usePublishDraftAssetLinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishDraftAssetLinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishDraftAssetLinesMutation, { data, loading, error }] = usePublishDraftAssetLinesMutation({
 *   variables: {
 *      kinds: // value for 'kinds'
 *      adSystem: // value for 'adSystem'
 *   },
 * });
 */
export function usePublishDraftAssetLinesMutation(baseOptions?: Apollo.MutationHookOptions<PublishDraftAssetLinesMutationT, PublishDraftAssetLinesMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishDraftAssetLinesMutationT, PublishDraftAssetLinesMutationVariablesT>(PublishDraftAssetLinesDocumentT, options);
      }
export type PublishDraftAssetLinesMutationHookResult = ReturnType<typeof usePublishDraftAssetLinesMutation>;
export type PublishDraftAssetLinesMutationResultT = Apollo.MutationResult<PublishDraftAssetLinesMutationT>;
export type PublishDraftAssetLinesMutationOptionsT = Apollo.BaseMutationOptions<PublishDraftAssetLinesMutationT, PublishDraftAssetLinesMutationVariablesT>;
export const RemoveDisapprovedAssetLinesDocumentT = gql`
    mutation RemoveDisapprovedAssetLines($kinds: [AssetLineKind!], $draft: Boolean, $adSystem: AdSystem = GOOGLE_ADS) {
  removeDisapprovedAssetLines(input: {kinds: $kinds, draft: $draft}) {
    assetLines {
      id
      draftState
    }
    organization {
      id
      activeTextsAssetLines(adSystem: $adSystem) {
        ...ActiveTextAssetLine
      }
      activeImagesAssetLines(adSystem: $adSystem) {
        ...ActiveImageAssetLine
      }
      notDeletedTextsAssetLines(adSystem: $adSystem) {
        ...ActiveTextAssetLine
      }
      notDeletedImagesAssetLines(adSystem: $adSystem) {
        ...ActiveImageAssetLine
      }
      validateImages {
        ...ValidationResult
      }
      validateDraftImages {
        ...ValidationResult
      }
      validateTexts {
        ...ValidationResult
      }
      validateDraftTexts {
        ...ValidationResult
      }
    }
    errors
  }
}
    ${ActiveTextAssetLineFragmentDocT}
${ActiveImageAssetLineFragmentDocT}
${ValidationResultFragmentDocT}`;
export type RemoveDisapprovedAssetLinesMutationFnT = Apollo.MutationFunction<RemoveDisapprovedAssetLinesMutationT, RemoveDisapprovedAssetLinesMutationVariablesT>;

/**
 * __useRemoveDisapprovedAssetLinesMutation__
 *
 * To run a mutation, you first call `useRemoveDisapprovedAssetLinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDisapprovedAssetLinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDisapprovedAssetLinesMutation, { data, loading, error }] = useRemoveDisapprovedAssetLinesMutation({
 *   variables: {
 *      kinds: // value for 'kinds'
 *      draft: // value for 'draft'
 *      adSystem: // value for 'adSystem'
 *   },
 * });
 */
export function useRemoveDisapprovedAssetLinesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDisapprovedAssetLinesMutationT, RemoveDisapprovedAssetLinesMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDisapprovedAssetLinesMutationT, RemoveDisapprovedAssetLinesMutationVariablesT>(RemoveDisapprovedAssetLinesDocumentT, options);
      }
export type RemoveDisapprovedAssetLinesMutationHookResult = ReturnType<typeof useRemoveDisapprovedAssetLinesMutation>;
export type RemoveDisapprovedAssetLinesMutationResultT = Apollo.MutationResult<RemoveDisapprovedAssetLinesMutationT>;
export type RemoveDisapprovedAssetLinesMutationOptionsT = Apollo.BaseMutationOptions<RemoveDisapprovedAssetLinesMutationT, RemoveDisapprovedAssetLinesMutationVariablesT>;
export const RequestNewImageSuggestionDocumentT = gql`
    mutation RequestNewImageSuggestion($eshopData: JSON) {
  requestNewImageSuggestion(input: {eshopData: $eshopData}) {
    imageSuggestionRequest {
      id
    }
    errors
  }
}
    `;
export type RequestNewImageSuggestionMutationFnT = Apollo.MutationFunction<RequestNewImageSuggestionMutationT, RequestNewImageSuggestionMutationVariablesT>;

/**
 * __useRequestNewImageSuggestionMutation__
 *
 * To run a mutation, you first call `useRequestNewImageSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestNewImageSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestNewImageSuggestionMutation, { data, loading, error }] = useRequestNewImageSuggestionMutation({
 *   variables: {
 *      eshopData: // value for 'eshopData'
 *   },
 * });
 */
export function useRequestNewImageSuggestionMutation(baseOptions?: Apollo.MutationHookOptions<RequestNewImageSuggestionMutationT, RequestNewImageSuggestionMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestNewImageSuggestionMutationT, RequestNewImageSuggestionMutationVariablesT>(RequestNewImageSuggestionDocumentT, options);
      }
export type RequestNewImageSuggestionMutationHookResult = ReturnType<typeof useRequestNewImageSuggestionMutation>;
export type RequestNewImageSuggestionMutationResultT = Apollo.MutationResult<RequestNewImageSuggestionMutationT>;
export type RequestNewImageSuggestionMutationOptionsT = Apollo.BaseMutationOptions<RequestNewImageSuggestionMutationT, RequestNewImageSuggestionMutationVariablesT>;
export const RequestAdditionalSuggestionDocumentT = gql`
    mutation RequestAdditionalSuggestion($suggestionRequestId: String!) {
  requestAdditionalSuggestion(input: {suggestionRequestId: $suggestionRequestId}) {
    suggestionRequest {
      id
      userInput
    }
    errors
  }
}
    `;
export type RequestAdditionalSuggestionMutationFnT = Apollo.MutationFunction<RequestAdditionalSuggestionMutationT, RequestAdditionalSuggestionMutationVariablesT>;

/**
 * __useRequestAdditionalSuggestionMutation__
 *
 * To run a mutation, you first call `useRequestAdditionalSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAdditionalSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAdditionalSuggestionMutation, { data, loading, error }] = useRequestAdditionalSuggestionMutation({
 *   variables: {
 *      suggestionRequestId: // value for 'suggestionRequestId'
 *   },
 * });
 */
export function useRequestAdditionalSuggestionMutation(baseOptions?: Apollo.MutationHookOptions<RequestAdditionalSuggestionMutationT, RequestAdditionalSuggestionMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAdditionalSuggestionMutationT, RequestAdditionalSuggestionMutationVariablesT>(RequestAdditionalSuggestionDocumentT, options);
      }
export type RequestAdditionalSuggestionMutationHookResult = ReturnType<typeof useRequestAdditionalSuggestionMutation>;
export type RequestAdditionalSuggestionMutationResultT = Apollo.MutationResult<RequestAdditionalSuggestionMutationT>;
export type RequestAdditionalSuggestionMutationOptionsT = Apollo.BaseMutationOptions<RequestAdditionalSuggestionMutationT, RequestAdditionalSuggestionMutationVariablesT>;
export const RequestConsultationDocumentT = gql`
    mutation RequestConsultation($consultationRequestedAt: ISO8601DateTime!) {
  updateOrganization(input: {consultationRequestedAt: $consultationRequestedAt}) {
    organization {
      id
      consultationRequestedAt
    }
    errors
  }
}
    `;
export type RequestConsultationMutationFnT = Apollo.MutationFunction<RequestConsultationMutationT, RequestConsultationMutationVariablesT>;

/**
 * __useRequestConsultationMutation__
 *
 * To run a mutation, you first call `useRequestConsultationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestConsultationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestConsultationMutation, { data, loading, error }] = useRequestConsultationMutation({
 *   variables: {
 *      consultationRequestedAt: // value for 'consultationRequestedAt'
 *   },
 * });
 */
export function useRequestConsultationMutation(baseOptions?: Apollo.MutationHookOptions<RequestConsultationMutationT, RequestConsultationMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestConsultationMutationT, RequestConsultationMutationVariablesT>(RequestConsultationDocumentT, options);
      }
export type RequestConsultationMutationHookResult = ReturnType<typeof useRequestConsultationMutation>;
export type RequestConsultationMutationResultT = Apollo.MutationResult<RequestConsultationMutationT>;
export type RequestConsultationMutationOptionsT = Apollo.BaseMutationOptions<RequestConsultationMutationT, RequestConsultationMutationVariablesT>;
export const RequestAdditionalImageSuggestionDocumentT = gql`
    mutation RequestAdditionalImageSuggestion($eshopData: JSON) {
  requestNewImageSuggestion(input: {eshopData: $eshopData, fetchMore: true}) {
    imageSuggestionRequest {
      id
      inProgress
      canFetchMore
    }
    errors
  }
}
    `;
export type RequestAdditionalImageSuggestionMutationFnT = Apollo.MutationFunction<RequestAdditionalImageSuggestionMutationT, RequestAdditionalImageSuggestionMutationVariablesT>;

/**
 * __useRequestAdditionalImageSuggestionMutation__
 *
 * To run a mutation, you first call `useRequestAdditionalImageSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAdditionalImageSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAdditionalImageSuggestionMutation, { data, loading, error }] = useRequestAdditionalImageSuggestionMutation({
 *   variables: {
 *      eshopData: // value for 'eshopData'
 *   },
 * });
 */
export function useRequestAdditionalImageSuggestionMutation(baseOptions?: Apollo.MutationHookOptions<RequestAdditionalImageSuggestionMutationT, RequestAdditionalImageSuggestionMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAdditionalImageSuggestionMutationT, RequestAdditionalImageSuggestionMutationVariablesT>(RequestAdditionalImageSuggestionDocumentT, options);
      }
export type RequestAdditionalImageSuggestionMutationHookResult = ReturnType<typeof useRequestAdditionalImageSuggestionMutation>;
export type RequestAdditionalImageSuggestionMutationResultT = Apollo.MutationResult<RequestAdditionalImageSuggestionMutationT>;
export type RequestAdditionalImageSuggestionMutationOptionsT = Apollo.BaseMutationOptions<RequestAdditionalImageSuggestionMutationT, RequestAdditionalImageSuggestionMutationVariablesT>;
export const RequestNewSuggestionDocumentT = gql`
    mutation RequestNewSuggestion($userInput: String!, $eshopData: JSON) {
  shortHeadlineRequest: requestNewSuggestion(
    input: {userInput: $userInput, kind: SHORT_HEADLINE, eshopData: $eshopData}
  ) {
    suggestionRequest {
      id
      userInput
    }
    errors
  }
  longHeadlineRequest: requestNewSuggestion(
    input: {userInput: $userInput, kind: LONG_HEADLINE, eshopData: $eshopData}
  ) {
    suggestionRequest {
      id
      userInput
    }
    errors
  }
  shortDescriptionRequest: requestNewSuggestion(
    input: {userInput: $userInput, kind: SHORT_DESCRIPTION, eshopData: $eshopData}
  ) {
    suggestionRequest {
      id
      userInput
    }
    errors
  }
  londDescriptionRequest: requestNewSuggestion(
    input: {userInput: $userInput, kind: LONG_DESCRIPTION, eshopData: $eshopData}
  ) {
    suggestionRequest {
      id
      userInput
    }
    errors
  }
}
    `;
export type RequestNewSuggestionMutationFnT = Apollo.MutationFunction<RequestNewSuggestionMutationT, RequestNewSuggestionMutationVariablesT>;

/**
 * __useRequestNewSuggestionMutation__
 *
 * To run a mutation, you first call `useRequestNewSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestNewSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestNewSuggestionMutation, { data, loading, error }] = useRequestNewSuggestionMutation({
 *   variables: {
 *      userInput: // value for 'userInput'
 *      eshopData: // value for 'eshopData'
 *   },
 * });
 */
export function useRequestNewSuggestionMutation(baseOptions?: Apollo.MutationHookOptions<RequestNewSuggestionMutationT, RequestNewSuggestionMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestNewSuggestionMutationT, RequestNewSuggestionMutationVariablesT>(RequestNewSuggestionDocumentT, options);
      }
export type RequestNewSuggestionMutationHookResult = ReturnType<typeof useRequestNewSuggestionMutation>;
export type RequestNewSuggestionMutationResultT = Apollo.MutationResult<RequestNewSuggestionMutationT>;
export type RequestNewSuggestionMutationOptionsT = Apollo.BaseMutationOptions<RequestNewSuggestionMutationT, RequestNewSuggestionMutationVariablesT>;
export const RestoreDraftRemoveAssetLineDocumentT = gql`
    mutation RestoreDraftRemoveAssetLine($id: String!, $adSystem: AdSystem = GOOGLE_ADS) {
  restoreDraftRemoveAssetLine(input: {id: $id}) {
    assetLine {
      id
    }
    organization {
      id
      activeTextsAssetLines(adSystem: $adSystem) {
        ...ActiveTextAssetLine
      }
      activeImagesAssetLines(adSystem: $adSystem) {
        ...ActiveImageAssetLine
      }
      notDeletedTextsAssetLines(adSystem: $adSystem) {
        ...ActiveTextAssetLine
      }
      notDeletedImagesAssetLines(adSystem: $adSystem) {
        ...ActiveImageAssetLine
      }
      validateImages {
        ...ValidationResult
      }
      validateDraftImages {
        ...ValidationResult
      }
      validateTexts {
        ...ValidationResult
      }
      validateDraftTexts {
        ...ValidationResult
      }
    }
    errors
  }
}
    ${ActiveTextAssetLineFragmentDocT}
${ActiveImageAssetLineFragmentDocT}
${ValidationResultFragmentDocT}`;
export type RestoreDraftRemoveAssetLineMutationFnT = Apollo.MutationFunction<RestoreDraftRemoveAssetLineMutationT, RestoreDraftRemoveAssetLineMutationVariablesT>;

/**
 * __useRestoreDraftRemoveAssetLineMutation__
 *
 * To run a mutation, you first call `useRestoreDraftRemoveAssetLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreDraftRemoveAssetLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreDraftRemoveAssetLineMutation, { data, loading, error }] = useRestoreDraftRemoveAssetLineMutation({
 *   variables: {
 *      id: // value for 'id'
 *      adSystem: // value for 'adSystem'
 *   },
 * });
 */
export function useRestoreDraftRemoveAssetLineMutation(baseOptions?: Apollo.MutationHookOptions<RestoreDraftRemoveAssetLineMutationT, RestoreDraftRemoveAssetLineMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreDraftRemoveAssetLineMutationT, RestoreDraftRemoveAssetLineMutationVariablesT>(RestoreDraftRemoveAssetLineDocumentT, options);
      }
export type RestoreDraftRemoveAssetLineMutationHookResult = ReturnType<typeof useRestoreDraftRemoveAssetLineMutation>;
export type RestoreDraftRemoveAssetLineMutationResultT = Apollo.MutationResult<RestoreDraftRemoveAssetLineMutationT>;
export type RestoreDraftRemoveAssetLineMutationOptionsT = Apollo.BaseMutationOptions<RestoreDraftRemoveAssetLineMutationT, RestoreDraftRemoveAssetLineMutationVariablesT>;
export const SelectCategoriesDocumentT = gql`
    mutation SelectCategories($categoryIds: [String!]!) {
  selectCategories(input: {categoryIds: $categoryIds}) {
    categories {
      id
      name
      selected
    }
    errors
  }
}
    `;
export type SelectCategoriesMutationFnT = Apollo.MutationFunction<SelectCategoriesMutationT, SelectCategoriesMutationVariablesT>;

/**
 * __useSelectCategoriesMutation__
 *
 * To run a mutation, you first call `useSelectCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectCategoriesMutation, { data, loading, error }] = useSelectCategoriesMutation({
 *   variables: {
 *      categoryIds: // value for 'categoryIds'
 *   },
 * });
 */
export function useSelectCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<SelectCategoriesMutationT, SelectCategoriesMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelectCategoriesMutationT, SelectCategoriesMutationVariablesT>(SelectCategoriesDocumentT, options);
      }
export type SelectCategoriesMutationHookResult = ReturnType<typeof useSelectCategoriesMutation>;
export type SelectCategoriesMutationResultT = Apollo.MutationResult<SelectCategoriesMutationT>;
export type SelectCategoriesMutationOptionsT = Apollo.BaseMutationOptions<SelectCategoriesMutationT, SelectCategoriesMutationVariablesT>;
export const SetOrganizationLabelsDocumentT = gql`
    mutation SetOrganizationLabels($labels: [String!]!) {
  setOrganizationLabels(input: {labels: $labels}) {
    organization {
      id
      labels
    }
    errors
  }
}
    `;
export type SetOrganizationLabelsMutationFnT = Apollo.MutationFunction<SetOrganizationLabelsMutationT, SetOrganizationLabelsMutationVariablesT>;

/**
 * __useSetOrganizationLabelsMutation__
 *
 * To run a mutation, you first call `useSetOrganizationLabelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrganizationLabelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrganizationLabelsMutation, { data, loading, error }] = useSetOrganizationLabelsMutation({
 *   variables: {
 *      labels: // value for 'labels'
 *   },
 * });
 */
export function useSetOrganizationLabelsMutation(baseOptions?: Apollo.MutationHookOptions<SetOrganizationLabelsMutationT, SetOrganizationLabelsMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOrganizationLabelsMutationT, SetOrganizationLabelsMutationVariablesT>(SetOrganizationLabelsDocumentT, options);
      }
export type SetOrganizationLabelsMutationHookResult = ReturnType<typeof useSetOrganizationLabelsMutation>;
export type SetOrganizationLabelsMutationResultT = Apollo.MutationResult<SetOrganizationLabelsMutationT>;
export type SetOrganizationLabelsMutationOptionsT = Apollo.BaseMutationOptions<SetOrganizationLabelsMutationT, SetOrganizationLabelsMutationVariablesT>;
export const SetOrganizationNoteDocumentT = gql`
    mutation SetOrganizationNote($note: String!) {
  setOrganizationNote(input: {note: $note}) {
    organization {
      id
      note
    }
    errors
  }
}
    `;
export type SetOrganizationNoteMutationFnT = Apollo.MutationFunction<SetOrganizationNoteMutationT, SetOrganizationNoteMutationVariablesT>;

/**
 * __useSetOrganizationNoteMutation__
 *
 * To run a mutation, you first call `useSetOrganizationNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrganizationNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrganizationNoteMutation, { data, loading, error }] = useSetOrganizationNoteMutation({
 *   variables: {
 *      note: // value for 'note'
 *   },
 * });
 */
export function useSetOrganizationNoteMutation(baseOptions?: Apollo.MutationHookOptions<SetOrganizationNoteMutationT, SetOrganizationNoteMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOrganizationNoteMutationT, SetOrganizationNoteMutationVariablesT>(SetOrganizationNoteDocumentT, options);
      }
export type SetOrganizationNoteMutationHookResult = ReturnType<typeof useSetOrganizationNoteMutation>;
export type SetOrganizationNoteMutationResultT = Apollo.MutationResult<SetOrganizationNoteMutationT>;
export type SetOrganizationNoteMutationOptionsT = Apollo.BaseMutationOptions<SetOrganizationNoteMutationT, SetOrganizationNoteMutationVariablesT>;
export const SetGoogleAdsWizardStepDocumentT = gql`
    mutation SetGoogleAdsWizardStep($wizardStep: WizardStep!) {
  setGoogleAdsWizardStep(input: {wizardStep: $wizardStep}) {
    organization {
      id
      wizardStep
    }
  }
}
    `;
export type SetGoogleAdsWizardStepMutationFnT = Apollo.MutationFunction<SetGoogleAdsWizardStepMutationT, SetGoogleAdsWizardStepMutationVariablesT>;

/**
 * __useSetGoogleAdsWizardStepMutation__
 *
 * To run a mutation, you first call `useSetGoogleAdsWizardStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGoogleAdsWizardStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGoogleAdsWizardStepMutation, { data, loading, error }] = useSetGoogleAdsWizardStepMutation({
 *   variables: {
 *      wizardStep: // value for 'wizardStep'
 *   },
 * });
 */
export function useSetGoogleAdsWizardStepMutation(baseOptions?: Apollo.MutationHookOptions<SetGoogleAdsWizardStepMutationT, SetGoogleAdsWizardStepMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetGoogleAdsWizardStepMutationT, SetGoogleAdsWizardStepMutationVariablesT>(SetGoogleAdsWizardStepDocumentT, options);
      }
export type SetGoogleAdsWizardStepMutationHookResult = ReturnType<typeof useSetGoogleAdsWizardStepMutation>;
export type SetGoogleAdsWizardStepMutationResultT = Apollo.MutationResult<SetGoogleAdsWizardStepMutationT>;
export type SetGoogleAdsWizardStepMutationOptionsT = Apollo.BaseMutationOptions<SetGoogleAdsWizardStepMutationT, SetGoogleAdsWizardStepMutationVariablesT>;
export const SetMetaAdsWizardStepDocumentT = gql`
    mutation SetMetaAdsWizardStep($wizardStep: MetaAdsWizardStep!) {
  setMetaAdsWizardStep(input: {wizardStep: $wizardStep}) {
    metaAdsSetting {
      id
      wizardStep
    }
  }
}
    `;
export type SetMetaAdsWizardStepMutationFnT = Apollo.MutationFunction<SetMetaAdsWizardStepMutationT, SetMetaAdsWizardStepMutationVariablesT>;

/**
 * __useSetMetaAdsWizardStepMutation__
 *
 * To run a mutation, you first call `useSetMetaAdsWizardStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMetaAdsWizardStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMetaAdsWizardStepMutation, { data, loading, error }] = useSetMetaAdsWizardStepMutation({
 *   variables: {
 *      wizardStep: // value for 'wizardStep'
 *   },
 * });
 */
export function useSetMetaAdsWizardStepMutation(baseOptions?: Apollo.MutationHookOptions<SetMetaAdsWizardStepMutationT, SetMetaAdsWizardStepMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMetaAdsWizardStepMutationT, SetMetaAdsWizardStepMutationVariablesT>(SetMetaAdsWizardStepDocumentT, options);
      }
export type SetMetaAdsWizardStepMutationHookResult = ReturnType<typeof useSetMetaAdsWizardStepMutation>;
export type SetMetaAdsWizardStepMutationResultT = Apollo.MutationResult<SetMetaAdsWizardStepMutationT>;
export type SetMetaAdsWizardStepMutationOptionsT = Apollo.BaseMutationOptions<SetMetaAdsWizardStepMutationT, SetMetaAdsWizardStepMutationVariablesT>;
export const StartSynchronizationDocumentT = gql`
    mutation StartSynchronization($adSystem: AdSystem) {
  startSynchronization(input: {adSystem: $adSystem}) {
    message
  }
}
    `;
export type StartSynchronizationMutationFnT = Apollo.MutationFunction<StartSynchronizationMutationT, StartSynchronizationMutationVariablesT>;

/**
 * __useStartSynchronizationMutation__
 *
 * To run a mutation, you first call `useStartSynchronizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSynchronizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSynchronizationMutation, { data, loading, error }] = useStartSynchronizationMutation({
 *   variables: {
 *      adSystem: // value for 'adSystem'
 *   },
 * });
 */
export function useStartSynchronizationMutation(baseOptions?: Apollo.MutationHookOptions<StartSynchronizationMutationT, StartSynchronizationMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartSynchronizationMutationT, StartSynchronizationMutationVariablesT>(StartSynchronizationDocumentT, options);
      }
export type StartSynchronizationMutationHookResult = ReturnType<typeof useStartSynchronizationMutation>;
export type StartSynchronizationMutationResultT = Apollo.MutationResult<StartSynchronizationMutationT>;
export type StartSynchronizationMutationOptionsT = Apollo.BaseMutationOptions<StartSynchronizationMutationT, StartSynchronizationMutationVariablesT>;
export const UpdateOrganizationDocumentT = gql`
    mutation UpdateOrganization($properties: JSON!) {
  updateOrganization(input: {properties: $properties}) {
    organization {
      id
      properties
    }
    errors
  }
}
    `;
export type UpdateOrganizationMutationFnT = Apollo.MutationFunction<UpdateOrganizationMutationT, UpdateOrganizationMutationVariablesT>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      properties: // value for 'properties'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutationT, UpdateOrganizationMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutationT, UpdateOrganizationMutationVariablesT>(UpdateOrganizationDocumentT, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResultT = Apollo.MutationResult<UpdateOrganizationMutationT>;
export type UpdateOrganizationMutationOptionsT = Apollo.BaseMutationOptions<UpdateOrganizationMutationT, UpdateOrganizationMutationVariablesT>;
export const UploadImageDocumentT = gql`
    mutation UploadImage($image: String!, $filename: String!, $contentType: String!, $kind: ImageSuggestionKind!, $width: Int!, $height: Int!, $cropX: Int!, $cropY: Int!, $cropWidth: Int!, $cropHeight: Int!) {
  uploadImage(
    input: {image: $image, filename: $filename, contentType: $contentType, kind: $kind, width: $width, height: $height, cropX: $cropX, cropY: $cropY, cropWidth: $cropWidth, cropHeight: $cropHeight}
  ) {
    uploadedImage {
      ...UploadedImage
    }
    errors
  }
}
    ${UploadedImageFragmentDocT}`;
export type UploadImageMutationFnT = Apollo.MutationFunction<UploadImageMutationT, UploadImageMutationVariablesT>;

/**
 * __useUploadImageMutation__
 *
 * To run a mutation, you first call `useUploadImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadImageMutation, { data, loading, error }] = useUploadImageMutation({
 *   variables: {
 *      image: // value for 'image'
 *      filename: // value for 'filename'
 *      contentType: // value for 'contentType'
 *      kind: // value for 'kind'
 *      width: // value for 'width'
 *      height: // value for 'height'
 *      cropX: // value for 'cropX'
 *      cropY: // value for 'cropY'
 *      cropWidth: // value for 'cropWidth'
 *      cropHeight: // value for 'cropHeight'
 *   },
 * });
 */
export function useUploadImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadImageMutationT, UploadImageMutationVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadImageMutationT, UploadImageMutationVariablesT>(UploadImageDocumentT, options);
      }
export type UploadImageMutationHookResult = ReturnType<typeof useUploadImageMutation>;
export type UploadImageMutationResultT = Apollo.MutationResult<UploadImageMutationT>;
export type UploadImageMutationOptionsT = Apollo.BaseMutationOptions<UploadImageMutationT, UploadImageMutationVariablesT>;
export const AdSystemCampaignStateDocumentT = gql`
    query AdSystemCampaignState($adSystem: AdSystem!, $dateTo: ISO8601Date!) {
  organization {
    id
    consultationRequestedAt
    googleAdsSetting {
      id
      learningState
      monthlyBudget {
        amount
        currency
      }
      optimizationsEnabled
      state
      wizardStep
    }
    metaAdsSetting {
      id
      learningState
      monthlyBudget {
        amount
        currency
      }
      optimizationsEnabled
      state
      wizardStep
    }
    summaryStats(adSystem: $adSystem) {
      id
      impressions
      conversions
    }
    campaignOptimizations(adSystem: $adSystem, dateTo: $dateTo, limit: 1, page: 1) {
      id
    }
  }
  user {
    id
    email
  }
}
    `;

/**
 * __useAdSystemCampaignStateQuery__
 *
 * To run a query within a React component, call `useAdSystemCampaignStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdSystemCampaignStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdSystemCampaignStateQuery({
 *   variables: {
 *      adSystem: // value for 'adSystem'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useAdSystemCampaignStateQuery(baseOptions: Apollo.QueryHookOptions<AdSystemCampaignStateQueryT, AdSystemCampaignStateQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdSystemCampaignStateQueryT, AdSystemCampaignStateQueryVariablesT>(AdSystemCampaignStateDocumentT, options);
      }
export function useAdSystemCampaignStateLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<AdSystemCampaignStateQueryT, AdSystemCampaignStateQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdSystemCampaignStateQueryT, AdSystemCampaignStateQueryVariablesT>(AdSystemCampaignStateDocumentT, options);
        }
export type AdSystemCampaignStateQueryHookResult = ReturnType<typeof useAdSystemCampaignStateQuery>;
export type AdSystemCampaignStateLazyQueryTHookResult = ReturnType<typeof useAdSystemCampaignStateLazyQueryT>;
export type AdSystemCampaignStateQueryResultT = Apollo.QueryResult<AdSystemCampaignStateQueryT, AdSystemCampaignStateQueryVariablesT>;
export const AdminGmcIssuesDocumentT = gql`
    query AdminGmcIssues {
  gmcIssues {
    id
    name
    count
    severity
  }
}
    `;

/**
 * __useAdminGmcIssuesQuery__
 *
 * To run a query within a React component, call `useAdminGmcIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGmcIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGmcIssuesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminGmcIssuesQuery(baseOptions?: Apollo.QueryHookOptions<AdminGmcIssuesQueryT, AdminGmcIssuesQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGmcIssuesQueryT, AdminGmcIssuesQueryVariablesT>(AdminGmcIssuesDocumentT, options);
      }
export function useAdminGmcIssuesLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<AdminGmcIssuesQueryT, AdminGmcIssuesQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGmcIssuesQueryT, AdminGmcIssuesQueryVariablesT>(AdminGmcIssuesDocumentT, options);
        }
export type AdminGmcIssuesQueryHookResult = ReturnType<typeof useAdminGmcIssuesQuery>;
export type AdminGmcIssuesLazyQueryTHookResult = ReturnType<typeof useAdminGmcIssuesLazyQueryT>;
export type AdminGmcIssuesQueryResultT = Apollo.QueryResult<AdminGmcIssuesQueryT, AdminGmcIssuesQueryVariablesT>;
export const AdminMetaAdsOrganizationsDocumentT = gql`
    query AdminMetaAdsOrganizations($limit: Int, $offset: Int, $shoptetId: String, $shoptetUrl: String, $orderColumn: String, $orderDirection: OrderDirection, $pageClaimRequested: Boolean, $pageClaimApproved: Boolean, $businessId: String, $adAccountId: String, $pageId: String, $state: AdSystemState) {
  metaAdsOrganizations(
    limit: $limit
    offset: $offset
    shoptetId: $shoptetId
    shoptetUrl: $shoptetUrl
    orderColumn: $orderColumn
    orderDirection: $orderDirection
    pageClaimRequested: $pageClaimRequested
    pageClaimApproved: $pageClaimApproved
    businessId: $businessId
    adAccountId: $adAccountId
    pageId: $pageId
    state: $state
  ) {
    nodes {
      id
      shoptetId
      shoptetUrl
      adminApiToken
      metaAdsSetting {
        id
        businessId
        adAccountId
        adAccountStatus
        advertiserVerificationPendingSince
        pageId
        pageClaimRequestedAt
        pageClaimFailureReason
        pageClaimApproved
        state
        wizardStep
        startedAt
      }
    }
    pageInfo {
      total
      limit
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useAdminMetaAdsOrganizationsQuery__
 *
 * To run a query within a React component, call `useAdminMetaAdsOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMetaAdsOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMetaAdsOrganizationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      shoptetId: // value for 'shoptetId'
 *      shoptetUrl: // value for 'shoptetUrl'
 *      orderColumn: // value for 'orderColumn'
 *      orderDirection: // value for 'orderDirection'
 *      pageClaimRequested: // value for 'pageClaimRequested'
 *      pageClaimApproved: // value for 'pageClaimApproved'
 *      businessId: // value for 'businessId'
 *      adAccountId: // value for 'adAccountId'
 *      pageId: // value for 'pageId'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useAdminMetaAdsOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<AdminMetaAdsOrganizationsQueryT, AdminMetaAdsOrganizationsQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMetaAdsOrganizationsQueryT, AdminMetaAdsOrganizationsQueryVariablesT>(AdminMetaAdsOrganizationsDocumentT, options);
      }
export function useAdminMetaAdsOrganizationsLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<AdminMetaAdsOrganizationsQueryT, AdminMetaAdsOrganizationsQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMetaAdsOrganizationsQueryT, AdminMetaAdsOrganizationsQueryVariablesT>(AdminMetaAdsOrganizationsDocumentT, options);
        }
export type AdminMetaAdsOrganizationsQueryHookResult = ReturnType<typeof useAdminMetaAdsOrganizationsQuery>;
export type AdminMetaAdsOrganizationsLazyQueryTHookResult = ReturnType<typeof useAdminMetaAdsOrganizationsLazyQueryT>;
export type AdminMetaAdsOrganizationsQueryResultT = Apollo.QueryResult<AdminMetaAdsOrganizationsQueryT, AdminMetaAdsOrganizationsQueryVariablesT>;
export const AdminOrganizationLabelsDocumentT = gql`
    query AdminOrganizationLabels {
  organizationLabels {
    name
    count
  }
}
    `;

/**
 * __useAdminOrganizationLabelsQuery__
 *
 * To run a query within a React component, call `useAdminOrganizationLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrganizationLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrganizationLabelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminOrganizationLabelsQuery(baseOptions?: Apollo.QueryHookOptions<AdminOrganizationLabelsQueryT, AdminOrganizationLabelsQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOrganizationLabelsQueryT, AdminOrganizationLabelsQueryVariablesT>(AdminOrganizationLabelsDocumentT, options);
      }
export function useAdminOrganizationLabelsLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<AdminOrganizationLabelsQueryT, AdminOrganizationLabelsQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOrganizationLabelsQueryT, AdminOrganizationLabelsQueryVariablesT>(AdminOrganizationLabelsDocumentT, options);
        }
export type AdminOrganizationLabelsQueryHookResult = ReturnType<typeof useAdminOrganizationLabelsQuery>;
export type AdminOrganizationLabelsLazyQueryTHookResult = ReturnType<typeof useAdminOrganizationLabelsLazyQueryT>;
export type AdminOrganizationLabelsQueryResultT = Apollo.QueryResult<AdminOrganizationLabelsQueryT, AdminOrganizationLabelsQueryVariablesT>;
export const AdminOrganizationsDocumentT = gql`
    query AdminOrganizations($labels: [String!], $exclude: Boolean, $limit: Int, $offset: Int, $shoptetId: String, $shoptetUrl: String, $gmcId: String, $state: OrganizationState, $startedDaysAgo: DaysAgo, $orderDirection: OrderDirection, $orderColumn: OrganizationsOrder, $adwordsCustomerId: String, $archived: Boolean) {
  organizations(
    labels: $labels
    exclude: $exclude
    limit: $limit
    offset: $offset
    shoptetId: $shoptetId
    shoptetUrl: $shoptetUrl
    gmcId: $gmcId
    state: $state
    startedDaysAgo: $startedDaysAgo
    orderDirection: $orderDirection
    orderColumn: $orderColumn
    adwordsCustomerId: $adwordsCustomerId
    archived: $archived
  ) {
    nodes {
      id
      adwordsCustomerId
      shoptetUrl
      shoptetId
      adminApiToken
      adminAppPath
      labels
      monthlyBudget {
        ...Money
      }
      state
      creditBalance {
        ...Money
      }
      usedCredits {
        ...Money
      }
      usedSpend {
        ...Money
      }
      activeAssetsCount
      disapprovedAssetsCount
      startedAt
      createdAt
      allBannedProductsCount
      productsCount
      gmcId
      gmcAccountSuspended
      metaAdsAccountSuspended
      metaAdsSetting {
        id
        businessId
        adAccountId
      }
      note
      archivedAt
    }
    pageInfo {
      total
      limit
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${MoneyFragmentDocT}`;

/**
 * __useAdminOrganizationsQuery__
 *
 * To run a query within a React component, call `useAdminOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrganizationsQuery({
 *   variables: {
 *      labels: // value for 'labels'
 *      exclude: // value for 'exclude'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      shoptetId: // value for 'shoptetId'
 *      shoptetUrl: // value for 'shoptetUrl'
 *      gmcId: // value for 'gmcId'
 *      state: // value for 'state'
 *      startedDaysAgo: // value for 'startedDaysAgo'
 *      orderDirection: // value for 'orderDirection'
 *      orderColumn: // value for 'orderColumn'
 *      adwordsCustomerId: // value for 'adwordsCustomerId'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useAdminOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<AdminOrganizationsQueryT, AdminOrganizationsQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOrganizationsQueryT, AdminOrganizationsQueryVariablesT>(AdminOrganizationsDocumentT, options);
      }
export function useAdminOrganizationsLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<AdminOrganizationsQueryT, AdminOrganizationsQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOrganizationsQueryT, AdminOrganizationsQueryVariablesT>(AdminOrganizationsDocumentT, options);
        }
export type AdminOrganizationsQueryHookResult = ReturnType<typeof useAdminOrganizationsQuery>;
export type AdminOrganizationsLazyQueryTHookResult = ReturnType<typeof useAdminOrganizationsLazyQueryT>;
export type AdminOrganizationsQueryResultT = Apollo.QueryResult<AdminOrganizationsQueryT, AdminOrganizationsQueryVariablesT>;
export const AdminSummaryDocumentT = gql`
    query AdminSummary($dateFromYesterday: ISO8601Date!, $dateFromWeek: ISO8601Date!, $dateFromMonth: ISO8601Date!, $dateFromYear: ISO8601Date!, $labels: [String!], $exclude: Boolean) {
  adminSummary(labels: $labels, exclude: $exclude) {
    spendYesterday: spend(dateFrom: $dateFromYesterday, dateTo: $dateFromYesterday) {
      ...Money
    }
    spendWeek: spend(dateFrom: $dateFromWeek, dateTo: $dateFromYesterday) {
      ...Money
    }
    spendMonth: spend(dateFrom: $dateFromMonth, dateTo: $dateFromYesterday) {
      ...Money
    }
    spendYear: spend(dateFrom: $dateFromYear, dateTo: $dateFromYesterday) {
      ...Money
    }
    spendAllTime: spend(dateFrom: $dateFromYear, dateTo: $dateFromYesterday) {
      ...Money
    }
    creditYesterday: credit(
      dateFrom: $dateFromYesterday
      dateTo: $dateFromYesterday
    ) {
      ...Money
    }
    creditWeek: credit(dateFrom: $dateFromWeek, dateTo: $dateFromYesterday) {
      ...Money
    }
    creditMonth: credit(dateFrom: $dateFromMonth, dateTo: $dateFromYesterday) {
      ...Money
    }
    creditYear: credit(dateFrom: $dateFromYear, dateTo: $dateFromYesterday) {
      ...Money
    }
    creditAllTime: credit(dateFrom: $dateFromYear, dateTo: $dateFromYesterday) {
      ...Money
    }
    statsByTarifMonth: statsByTarif(
      dateFrom: $dateFromMonth
      dateTo: $dateFromYesterday
    ) {
      tarifName
      organizationsCount
      spend {
        ...Money
      }
      credit {
        ...Money
      }
      income {
        ...Money
      }
      averageSpend {
        ...Money
      }
    }
    statsByTarifAllTime: statsByTarif(dateTo: $dateFromYesterday) {
      tarifName
      organizationsCount
      spend {
        ...Money
      }
      credit {
        ...Money
      }
      income {
        ...Money
      }
      averageSpend {
        ...Money
      }
    }
    statsByMonth(dateTo: $dateFromYesterday) {
      date
      organizationsCount
      spend {
        ...Money
      }
      credit {
        ...Money
      }
      income {
        ...Money
      }
      averageSpend {
        ...Money
      }
    }
    firstPageOrganizations: organizationsCount(wizardStep: FIRST)
    suggestionGenerationOrganizations: organizationsCount(
      wizardStep: SUGGESTION_GENERATOR
    )
    imageSelectionOrganizations: organizationsCount(wizardStep: IMAGE_SELECTION)
    textSelectionOrganizations: organizationsCount(wizardStep: TEXT_SELECTION)
    checkOrganizations: organizationsCount(wizardStep: CHECK)
    finishWizardOrganizations: organizationsCount(wizardStep: FINISH)
    allOrganizations: organizationsCount
    allAfterWizardOrganizations: organizationsCount(wizardStep: DASHBOARD)
    activeOrganizations: organizationsCount(wizardStep: DASHBOARD, state: ACTIVE)
    pausedOrganizations: organizationsCount(wizardStep: DASHBOARD, state: PAUSED)
  }
}
    ${MoneyFragmentDocT}`;

/**
 * __useAdminSummaryQuery__
 *
 * To run a query within a React component, call `useAdminSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSummaryQuery({
 *   variables: {
 *      dateFromYesterday: // value for 'dateFromYesterday'
 *      dateFromWeek: // value for 'dateFromWeek'
 *      dateFromMonth: // value for 'dateFromMonth'
 *      dateFromYear: // value for 'dateFromYear'
 *      labels: // value for 'labels'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useAdminSummaryQuery(baseOptions: Apollo.QueryHookOptions<AdminSummaryQueryT, AdminSummaryQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminSummaryQueryT, AdminSummaryQueryVariablesT>(AdminSummaryDocumentT, options);
      }
export function useAdminSummaryLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<AdminSummaryQueryT, AdminSummaryQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminSummaryQueryT, AdminSummaryQueryVariablesT>(AdminSummaryDocumentT, options);
        }
export type AdminSummaryQueryHookResult = ReturnType<typeof useAdminSummaryQuery>;
export type AdminSummaryLazyQueryTHookResult = ReturnType<typeof useAdminSummaryLazyQueryT>;
export type AdminSummaryQueryResultT = Apollo.QueryResult<AdminSummaryQueryT, AdminSummaryQueryVariablesT>;
export const ActiveImagesAssetLinesDocumentT = gql`
    query ActiveImagesAssetLines($adSystem: AdSystem = GOOGLE_ADS) {
  organization {
    id
    activeImagesAssetLines(adSystem: $adSystem) {
      ...ActiveImageAssetLine
    }
  }
}
    ${ActiveImageAssetLineFragmentDocT}`;

/**
 * __useActiveImagesAssetLinesQuery__
 *
 * To run a query within a React component, call `useActiveImagesAssetLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveImagesAssetLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveImagesAssetLinesQuery({
 *   variables: {
 *      adSystem: // value for 'adSystem'
 *   },
 * });
 */
export function useActiveImagesAssetLinesQuery(baseOptions?: Apollo.QueryHookOptions<ActiveImagesAssetLinesQueryT, ActiveImagesAssetLinesQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveImagesAssetLinesQueryT, ActiveImagesAssetLinesQueryVariablesT>(ActiveImagesAssetLinesDocumentT, options);
      }
export function useActiveImagesAssetLinesLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<ActiveImagesAssetLinesQueryT, ActiveImagesAssetLinesQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveImagesAssetLinesQueryT, ActiveImagesAssetLinesQueryVariablesT>(ActiveImagesAssetLinesDocumentT, options);
        }
export type ActiveImagesAssetLinesQueryHookResult = ReturnType<typeof useActiveImagesAssetLinesQuery>;
export type ActiveImagesAssetLinesLazyQueryTHookResult = ReturnType<typeof useActiveImagesAssetLinesLazyQueryT>;
export type ActiveImagesAssetLinesQueryResultT = Apollo.QueryResult<ActiveImagesAssetLinesQueryT, ActiveImagesAssetLinesQueryVariablesT>;
export const ActiveTextsAssetLinesDocumentT = gql`
    query ActiveTextsAssetLines($adSystem: AdSystem = GOOGLE_ADS) {
  organization {
    id
    activeTextsAssetLines(adSystem: $adSystem) {
      ...ActiveTextAssetLine
    }
  }
}
    ${ActiveTextAssetLineFragmentDocT}`;

/**
 * __useActiveTextsAssetLinesQuery__
 *
 * To run a query within a React component, call `useActiveTextsAssetLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveTextsAssetLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveTextsAssetLinesQuery({
 *   variables: {
 *      adSystem: // value for 'adSystem'
 *   },
 * });
 */
export function useActiveTextsAssetLinesQuery(baseOptions?: Apollo.QueryHookOptions<ActiveTextsAssetLinesQueryT, ActiveTextsAssetLinesQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveTextsAssetLinesQueryT, ActiveTextsAssetLinesQueryVariablesT>(ActiveTextsAssetLinesDocumentT, options);
      }
export function useActiveTextsAssetLinesLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<ActiveTextsAssetLinesQueryT, ActiveTextsAssetLinesQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveTextsAssetLinesQueryT, ActiveTextsAssetLinesQueryVariablesT>(ActiveTextsAssetLinesDocumentT, options);
        }
export type ActiveTextsAssetLinesQueryHookResult = ReturnType<typeof useActiveTextsAssetLinesQuery>;
export type ActiveTextsAssetLinesLazyQueryTHookResult = ReturnType<typeof useActiveTextsAssetLinesLazyQueryT>;
export type ActiveTextsAssetLinesQueryResultT = Apollo.QueryResult<ActiveTextsAssetLinesQueryT, ActiveTextsAssetLinesQueryVariablesT>;
export const NotDeletedImagesAssetLinesDocumentT = gql`
    query NotDeletedImagesAssetLines($adSystem: AdSystem = GOOGLE_ADS) {
  organization {
    id
    notDeletedImagesAssetLines(adSystem: $adSystem) {
      ...ActiveImageAssetLine
    }
  }
}
    ${ActiveImageAssetLineFragmentDocT}`;

/**
 * __useNotDeletedImagesAssetLinesQuery__
 *
 * To run a query within a React component, call `useNotDeletedImagesAssetLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotDeletedImagesAssetLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotDeletedImagesAssetLinesQuery({
 *   variables: {
 *      adSystem: // value for 'adSystem'
 *   },
 * });
 */
export function useNotDeletedImagesAssetLinesQuery(baseOptions?: Apollo.QueryHookOptions<NotDeletedImagesAssetLinesQueryT, NotDeletedImagesAssetLinesQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotDeletedImagesAssetLinesQueryT, NotDeletedImagesAssetLinesQueryVariablesT>(NotDeletedImagesAssetLinesDocumentT, options);
      }
export function useNotDeletedImagesAssetLinesLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<NotDeletedImagesAssetLinesQueryT, NotDeletedImagesAssetLinesQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotDeletedImagesAssetLinesQueryT, NotDeletedImagesAssetLinesQueryVariablesT>(NotDeletedImagesAssetLinesDocumentT, options);
        }
export type NotDeletedImagesAssetLinesQueryHookResult = ReturnType<typeof useNotDeletedImagesAssetLinesQuery>;
export type NotDeletedImagesAssetLinesLazyQueryTHookResult = ReturnType<typeof useNotDeletedImagesAssetLinesLazyQueryT>;
export type NotDeletedImagesAssetLinesQueryResultT = Apollo.QueryResult<NotDeletedImagesAssetLinesQueryT, NotDeletedImagesAssetLinesQueryVariablesT>;
export const NotDeletedTextsAssetLinesDocumentT = gql`
    query NotDeletedTextsAssetLines($adSystem: AdSystem = GOOGLE_ADS) {
  organization {
    id
    notDeletedTextsAssetLines(adSystem: $adSystem) {
      ...ActiveTextAssetLine
    }
  }
}
    ${ActiveTextAssetLineFragmentDocT}`;

/**
 * __useNotDeletedTextsAssetLinesQuery__
 *
 * To run a query within a React component, call `useNotDeletedTextsAssetLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotDeletedTextsAssetLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotDeletedTextsAssetLinesQuery({
 *   variables: {
 *      adSystem: // value for 'adSystem'
 *   },
 * });
 */
export function useNotDeletedTextsAssetLinesQuery(baseOptions?: Apollo.QueryHookOptions<NotDeletedTextsAssetLinesQueryT, NotDeletedTextsAssetLinesQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotDeletedTextsAssetLinesQueryT, NotDeletedTextsAssetLinesQueryVariablesT>(NotDeletedTextsAssetLinesDocumentT, options);
      }
export function useNotDeletedTextsAssetLinesLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<NotDeletedTextsAssetLinesQueryT, NotDeletedTextsAssetLinesQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotDeletedTextsAssetLinesQueryT, NotDeletedTextsAssetLinesQueryVariablesT>(NotDeletedTextsAssetLinesDocumentT, options);
        }
export type NotDeletedTextsAssetLinesQueryHookResult = ReturnType<typeof useNotDeletedTextsAssetLinesQuery>;
export type NotDeletedTextsAssetLinesLazyQueryTHookResult = ReturnType<typeof useNotDeletedTextsAssetLinesLazyQueryT>;
export type NotDeletedTextsAssetLinesQueryResultT = Apollo.QueryResult<NotDeletedTextsAssetLinesQueryT, NotDeletedTextsAssetLinesQueryVariablesT>;
export const AuditLogsDocumentT = gql`
    query AuditLogs($dateFrom: ISO8601Date, $dateTo: ISO8601Date!, $page: Int!, $limit: Int!, $adSystem: AdSystem, $type: AuditLogs, $userEmail: String) {
  organization {
    id
    auditLogs(
      dateFrom: $dateFrom
      dateTo: $dateTo
      page: $page
      limit: $limit
      adSystem: $adSystem
      type: $type
      userEmail: $userEmail
    ) {
      id
      type
      message
      userEmail
      createdAt
      adSystem
      assetLine {
        id
        kind
        imageSuggestion {
          ...ImageSuggestion
        }
        uploadedImage {
          ...UploadedImage
        }
      }
    }
    auditLogsCount(
      dateFrom: $dateFrom
      dateTo: $dateTo
      adSystem: $adSystem
      type: $type
      userEmail: $userEmail
    )
  }
}
    ${ImageSuggestionFragmentDocT}
${UploadedImageFragmentDocT}`;

/**
 * __useAuditLogsQuery__
 *
 * To run a query within a React component, call `useAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditLogsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      adSystem: // value for 'adSystem'
 *      type: // value for 'type'
 *      userEmail: // value for 'userEmail'
 *   },
 * });
 */
export function useAuditLogsQuery(baseOptions: Apollo.QueryHookOptions<AuditLogsQueryT, AuditLogsQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditLogsQueryT, AuditLogsQueryVariablesT>(AuditLogsDocumentT, options);
      }
export function useAuditLogsLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<AuditLogsQueryT, AuditLogsQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditLogsQueryT, AuditLogsQueryVariablesT>(AuditLogsDocumentT, options);
        }
export type AuditLogsQueryHookResult = ReturnType<typeof useAuditLogsQuery>;
export type AuditLogsLazyQueryTHookResult = ReturnType<typeof useAuditLogsLazyQueryT>;
export type AuditLogsQueryResultT = Apollo.QueryResult<AuditLogsQueryT, AuditLogsQueryVariablesT>;
export const CampaignOptimizationsDocumentT = gql`
    query CampaignOptimizations($dateTo: ISO8601Date!, $dateFrom: ISO8601Date, $limit: Int!, $page: Int!, $adSystem: AdSystem = GOOGLE_ADS) {
  organization {
    id
    campaignOptimizations(
      dateTo: $dateTo
      dateFrom: $dateFrom
      limit: $limit
      page: $page
      adSystem: $adSystem
    ) {
      id
      createdAt
      rule
      type
    }
  }
}
    `;

/**
 * __useCampaignOptimizationsQuery__
 *
 * To run a query within a React component, call `useCampaignOptimizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignOptimizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignOptimizationsQuery({
 *   variables: {
 *      dateTo: // value for 'dateTo'
 *      dateFrom: // value for 'dateFrom'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      adSystem: // value for 'adSystem'
 *   },
 * });
 */
export function useCampaignOptimizationsQuery(baseOptions: Apollo.QueryHookOptions<CampaignOptimizationsQueryT, CampaignOptimizationsQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignOptimizationsQueryT, CampaignOptimizationsQueryVariablesT>(CampaignOptimizationsDocumentT, options);
      }
export function useCampaignOptimizationsLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<CampaignOptimizationsQueryT, CampaignOptimizationsQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignOptimizationsQueryT, CampaignOptimizationsQueryVariablesT>(CampaignOptimizationsDocumentT, options);
        }
export type CampaignOptimizationsQueryHookResult = ReturnType<typeof useCampaignOptimizationsQuery>;
export type CampaignOptimizationsLazyQueryTHookResult = ReturnType<typeof useCampaignOptimizationsLazyQueryT>;
export type CampaignOptimizationsQueryResultT = Apollo.QueryResult<CampaignOptimizationsQueryT, CampaignOptimizationsQueryVariablesT>;
export const CreditTransactionsDocumentT = gql`
    query CreditTransactions($dateFrom: ISO8601Date, $dateTo: ISO8601Date!, $page: Int!, $limit: Int!, $adSystem: AdSystem, $kinds: [CreditTransactionKind!]) {
  organization {
    id
    creditTransactions(
      dateFrom: $dateFrom
      dateTo: $dateTo
      page: $page
      limit: $limit
      adSystem: $adSystem
      kinds: $kinds
    ) {
      id
      createdAt
      kind
      adSystem
      spend {
        ...Money
      }
      credit {
        ...Money
      }
      usedSpend {
        ...Money
      }
      usedCredit {
        ...Money
      }
    }
    creditTransactionsCount(
      dateFrom: $dateFrom
      dateTo: $dateTo
      adSystem: $adSystem
      kinds: $kinds
    )
  }
}
    ${MoneyFragmentDocT}`;

/**
 * __useCreditTransactionsQuery__
 *
 * To run a query within a React component, call `useCreditTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditTransactionsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      adSystem: // value for 'adSystem'
 *      kinds: // value for 'kinds'
 *   },
 * });
 */
export function useCreditTransactionsQuery(baseOptions: Apollo.QueryHookOptions<CreditTransactionsQueryT, CreditTransactionsQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreditTransactionsQueryT, CreditTransactionsQueryVariablesT>(CreditTransactionsDocumentT, options);
      }
export function useCreditTransactionsLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<CreditTransactionsQueryT, CreditTransactionsQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreditTransactionsQueryT, CreditTransactionsQueryVariablesT>(CreditTransactionsDocumentT, options);
        }
export type CreditTransactionsQueryHookResult = ReturnType<typeof useCreditTransactionsQuery>;
export type CreditTransactionsLazyQueryTHookResult = ReturnType<typeof useCreditTransactionsLazyQueryT>;
export type CreditTransactionsQueryResultT = Apollo.QueryResult<CreditTransactionsQueryT, CreditTransactionsQueryVariablesT>;
export const CreditsDocumentT = gql`
    query Credits {
  organization {
    id
    pendingCreditWithdrawal
    ...OrganizationCredits
    googleAdsSetting {
      id
      monthlyBudget {
        ...Money
      }
    }
    metaAdsSetting {
      id
      monthlyBudget {
        ...Money
      }
    }
  }
}
    ${OrganizationCreditsFragmentDocT}
${MoneyFragmentDocT}`;

/**
 * __useCreditsQuery__
 *
 * To run a query within a React component, call `useCreditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreditsQuery(baseOptions?: Apollo.QueryHookOptions<CreditsQueryT, CreditsQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreditsQueryT, CreditsQueryVariablesT>(CreditsDocumentT, options);
      }
export function useCreditsLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<CreditsQueryT, CreditsQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreditsQueryT, CreditsQueryVariablesT>(CreditsDocumentT, options);
        }
export type CreditsQueryHookResult = ReturnType<typeof useCreditsQuery>;
export type CreditsLazyQueryTHookResult = ReturnType<typeof useCreditsLazyQueryT>;
export type CreditsQueryResultT = Apollo.QueryResult<CreditsQueryT, CreditsQueryVariablesT>;
export const FacebookPageInfoDocumentT = gql`
    query FacebookPageInfo {
  user {
    id
    email
  }
  organization {
    id
    metaAdsSetting {
      id
      pageId
      pageClaimApproved
      pageClaimRequestedAt
      pageClaimFailureReason
    }
  }
}
    `;

/**
 * __useFacebookPageInfoQuery__
 *
 * To run a query within a React component, call `useFacebookPageInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacebookPageInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacebookPageInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useFacebookPageInfoQuery(baseOptions?: Apollo.QueryHookOptions<FacebookPageInfoQueryT, FacebookPageInfoQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FacebookPageInfoQueryT, FacebookPageInfoQueryVariablesT>(FacebookPageInfoDocumentT, options);
      }
export function useFacebookPageInfoLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<FacebookPageInfoQueryT, FacebookPageInfoQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FacebookPageInfoQueryT, FacebookPageInfoQueryVariablesT>(FacebookPageInfoDocumentT, options);
        }
export type FacebookPageInfoQueryHookResult = ReturnType<typeof useFacebookPageInfoQuery>;
export type FacebookPageInfoLazyQueryTHookResult = ReturnType<typeof useFacebookPageInfoLazyQueryT>;
export type FacebookPageInfoQueryResultT = Apollo.QueryResult<FacebookPageInfoQueryT, FacebookPageInfoQueryVariablesT>;
export const GmcIssuesDocumentT = gql`
    query GmcIssues {
  organization {
    id
    validInStockProductsCount
    gmcIssues {
      id
      name
      count
      severity
    }
  }
}
    `;

/**
 * __useGmcIssuesQuery__
 *
 * To run a query within a React component, call `useGmcIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGmcIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGmcIssuesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGmcIssuesQuery(baseOptions?: Apollo.QueryHookOptions<GmcIssuesQueryT, GmcIssuesQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GmcIssuesQueryT, GmcIssuesQueryVariablesT>(GmcIssuesDocumentT, options);
      }
export function useGmcIssuesLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<GmcIssuesQueryT, GmcIssuesQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GmcIssuesQueryT, GmcIssuesQueryVariablesT>(GmcIssuesDocumentT, options);
        }
export type GmcIssuesQueryHookResult = ReturnType<typeof useGmcIssuesQuery>;
export type GmcIssuesLazyQueryTHookResult = ReturnType<typeof useGmcIssuesLazyQueryT>;
export type GmcIssuesQueryResultT = Apollo.QueryResult<GmcIssuesQueryT, GmcIssuesQueryVariablesT>;
export const ImageSuggestionsDocumentT = gql`
    query ImageSuggestions($kind: ImageSuggestionKind, $limit: Int) {
  organization {
    id
    imageSuggestions(kind: $kind, limit: $limit) {
      ...ImageSuggestion
    }
  }
}
    ${ImageSuggestionFragmentDocT}`;

/**
 * __useImageSuggestionsQuery__
 *
 * To run a query within a React component, call `useImageSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImageSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImageSuggestionsQuery({
 *   variables: {
 *      kind: // value for 'kind'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useImageSuggestionsQuery(baseOptions?: Apollo.QueryHookOptions<ImageSuggestionsQueryT, ImageSuggestionsQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImageSuggestionsQueryT, ImageSuggestionsQueryVariablesT>(ImageSuggestionsDocumentT, options);
      }
export function useImageSuggestionsLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<ImageSuggestionsQueryT, ImageSuggestionsQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImageSuggestionsQueryT, ImageSuggestionsQueryVariablesT>(ImageSuggestionsDocumentT, options);
        }
export type ImageSuggestionsQueryHookResult = ReturnType<typeof useImageSuggestionsQuery>;
export type ImageSuggestionsLazyQueryTHookResult = ReturnType<typeof useImageSuggestionsLazyQueryT>;
export type ImageSuggestionsQueryResultT = Apollo.QueryResult<ImageSuggestionsQueryT, ImageSuggestionsQueryVariablesT>;
export const LastImageSuggestionRequestsDocumentT = gql`
    query LastImageSuggestionRequests {
  organization {
    id
    lastImageSuggestionRequests(limit: 1) {
      id
      inProgress
      canFetchMore
    }
  }
}
    `;

/**
 * __useLastImageSuggestionRequestsQuery__
 *
 * To run a query within a React component, call `useLastImageSuggestionRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastImageSuggestionRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastImageSuggestionRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLastImageSuggestionRequestsQuery(baseOptions?: Apollo.QueryHookOptions<LastImageSuggestionRequestsQueryT, LastImageSuggestionRequestsQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LastImageSuggestionRequestsQueryT, LastImageSuggestionRequestsQueryVariablesT>(LastImageSuggestionRequestsDocumentT, options);
      }
export function useLastImageSuggestionRequestsLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<LastImageSuggestionRequestsQueryT, LastImageSuggestionRequestsQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LastImageSuggestionRequestsQueryT, LastImageSuggestionRequestsQueryVariablesT>(LastImageSuggestionRequestsDocumentT, options);
        }
export type LastImageSuggestionRequestsQueryHookResult = ReturnType<typeof useLastImageSuggestionRequestsQuery>;
export type LastImageSuggestionRequestsLazyQueryTHookResult = ReturnType<typeof useLastImageSuggestionRequestsLazyQueryT>;
export type LastImageSuggestionRequestsQueryResultT = Apollo.QueryResult<LastImageSuggestionRequestsQueryT, LastImageSuggestionRequestsQueryVariablesT>;
export const LastSuggestionRequestDocumentT = gql`
    query LastSuggestionRequest {
  organization {
    id
    category
    lastSuggestionRequestsShortHeadline: lastSuggestionRequests(
      kind: SHORT_HEADLINE
      limit: 1
    ) {
      ...LastSuggestionRequest
    }
    lastSuggestionRequestsLongHeadline: lastSuggestionRequests(
      kind: LONG_HEADLINE
      limit: 1
    ) {
      ...LastSuggestionRequest
    }
    lastSuggestionRequestsShortDescription: lastSuggestionRequests(
      kind: SHORT_DESCRIPTION
      limit: 1
    ) {
      ...LastSuggestionRequest
    }
    lastSuggestionRequestsLongDescription: lastSuggestionRequests(
      kind: LONG_DESCRIPTION
      limit: 1
    ) {
      ...LastSuggestionRequest
    }
  }
}
    ${LastSuggestionRequestFragmentDocT}`;

/**
 * __useLastSuggestionRequestQuery__
 *
 * To run a query within a React component, call `useLastSuggestionRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastSuggestionRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastSuggestionRequestQuery({
 *   variables: {
 *   },
 * });
 */
export function useLastSuggestionRequestQuery(baseOptions?: Apollo.QueryHookOptions<LastSuggestionRequestQueryT, LastSuggestionRequestQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LastSuggestionRequestQueryT, LastSuggestionRequestQueryVariablesT>(LastSuggestionRequestDocumentT, options);
      }
export function useLastSuggestionRequestLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<LastSuggestionRequestQueryT, LastSuggestionRequestQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LastSuggestionRequestQueryT, LastSuggestionRequestQueryVariablesT>(LastSuggestionRequestDocumentT, options);
        }
export type LastSuggestionRequestQueryHookResult = ReturnType<typeof useLastSuggestionRequestQuery>;
export type LastSuggestionRequestLazyQueryTHookResult = ReturnType<typeof useLastSuggestionRequestLazyQueryT>;
export type LastSuggestionRequestQueryResultT = Apollo.QueryResult<LastSuggestionRequestQueryT, LastSuggestionRequestQueryVariablesT>;
export const LaunchRunwayDocumentT = gql`
    query LaunchRunway($adSystem: AdSystem!) {
  organization {
    id
    remainingCreditDays(launching: [$adSystem])
    runningAdSystems(launching: [$adSystem])
  }
}
    `;

/**
 * __useLaunchRunwayQuery__
 *
 * To run a query within a React component, call `useLaunchRunwayQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaunchRunwayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaunchRunwayQuery({
 *   variables: {
 *      adSystem: // value for 'adSystem'
 *   },
 * });
 */
export function useLaunchRunwayQuery(baseOptions: Apollo.QueryHookOptions<LaunchRunwayQueryT, LaunchRunwayQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LaunchRunwayQueryT, LaunchRunwayQueryVariablesT>(LaunchRunwayDocumentT, options);
      }
export function useLaunchRunwayLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<LaunchRunwayQueryT, LaunchRunwayQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LaunchRunwayQueryT, LaunchRunwayQueryVariablesT>(LaunchRunwayDocumentT, options);
        }
export type LaunchRunwayQueryHookResult = ReturnType<typeof useLaunchRunwayQuery>;
export type LaunchRunwayLazyQueryTHookResult = ReturnType<typeof useLaunchRunwayLazyQueryT>;
export type LaunchRunwayQueryResultT = Apollo.QueryResult<LaunchRunwayQueryT, LaunchRunwayQueryVariablesT>;
export const MonthSummaryStatsDocumentT = gql`
    query MonthSummaryStats($thisMonthDateFrom: ISO8601Date, $thisMonthDateTo: ISO8601Date, $lastMonthDateFrom: ISO8601Date, $lastMonthDateTo: ISO8601Date, $adSystem: AdSystem = GOOGLE_ADS) {
  organization {
    id
    summaryStats(adSystem: $adSystem) {
      id
      ...SummaryStats
    }
    thisMonthStats: summaryStats(
      dateFrom: $thisMonthDateFrom
      dateTo: $thisMonthDateTo
      adSystem: $adSystem
    ) {
      id
      ...SummaryStats
    }
    lastMonthStats: summaryStats(
      dateFrom: $lastMonthDateFrom
      dateTo: $lastMonthDateTo
      adSystem: $adSystem
    ) {
      id
      ...SummaryStats
    }
  }
}
    ${SummaryStatsFragmentDocT}`;

/**
 * __useMonthSummaryStatsQuery__
 *
 * To run a query within a React component, call `useMonthSummaryStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonthSummaryStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonthSummaryStatsQuery({
 *   variables: {
 *      thisMonthDateFrom: // value for 'thisMonthDateFrom'
 *      thisMonthDateTo: // value for 'thisMonthDateTo'
 *      lastMonthDateFrom: // value for 'lastMonthDateFrom'
 *      lastMonthDateTo: // value for 'lastMonthDateTo'
 *      adSystem: // value for 'adSystem'
 *   },
 * });
 */
export function useMonthSummaryStatsQuery(baseOptions?: Apollo.QueryHookOptions<MonthSummaryStatsQueryT, MonthSummaryStatsQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MonthSummaryStatsQueryT, MonthSummaryStatsQueryVariablesT>(MonthSummaryStatsDocumentT, options);
      }
export function useMonthSummaryStatsLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<MonthSummaryStatsQueryT, MonthSummaryStatsQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MonthSummaryStatsQueryT, MonthSummaryStatsQueryVariablesT>(MonthSummaryStatsDocumentT, options);
        }
export type MonthSummaryStatsQueryHookResult = ReturnType<typeof useMonthSummaryStatsQuery>;
export type MonthSummaryStatsLazyQueryTHookResult = ReturnType<typeof useMonthSummaryStatsLazyQueryT>;
export type MonthSummaryStatsQueryResultT = Apollo.QueryResult<MonthSummaryStatsQueryT, MonthSummaryStatsQueryVariablesT>;
export const OrganizationDocumentT = gql`
    query Organization {
  env
  organization {
    id
    shoptetUrl
    notReadySteps
    wizardStep
    productsCount
    productsCountState
    outOfStockProductsCount
    selectableProductsCount
    categoriesCount
    productFlagsCount
    productsCountToSynchronize
    missingShippingStatus
    googleShoppingSuspended
    archivedAt
    organizationDesign {
      id
      color1
      overrideColor1
      finalColor1
      color2
      color3
      color4
      logo
    }
  }
}
    `;

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationQueryT, OrganizationQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationQueryT, OrganizationQueryVariablesT>(OrganizationDocumentT, options);
      }
export function useOrganizationLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationQueryT, OrganizationQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationQueryT, OrganizationQueryVariablesT>(OrganizationDocumentT, options);
        }
export type OrganizationQueryHookResult = ReturnType<typeof useOrganizationQuery>;
export type OrganizationLazyQueryTHookResult = ReturnType<typeof useOrganizationLazyQueryT>;
export type OrganizationQueryResultT = Apollo.QueryResult<OrganizationQueryT, OrganizationQueryVariablesT>;
export const OrganizationCampaignStateDocumentT = gql`
    query OrganizationCampaignState {
  env
  organization {
    id
    enabledFeatureFlags
    notReadySteps
    productsCountState
    shoptetId
    googleAdsSetting {
      id
      wizardStep
    }
    metaAdsSetting {
      id
      wizardStep
    }
  }
}
    `;

/**
 * __useOrganizationCampaignStateQuery__
 *
 * To run a query within a React component, call `useOrganizationCampaignStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationCampaignStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationCampaignStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationCampaignStateQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationCampaignStateQueryT, OrganizationCampaignStateQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationCampaignStateQueryT, OrganizationCampaignStateQueryVariablesT>(OrganizationCampaignStateDocumentT, options);
      }
export function useOrganizationCampaignStateLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationCampaignStateQueryT, OrganizationCampaignStateQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationCampaignStateQueryT, OrganizationCampaignStateQueryVariablesT>(OrganizationCampaignStateDocumentT, options);
        }
export type OrganizationCampaignStateQueryHookResult = ReturnType<typeof useOrganizationCampaignStateQuery>;
export type OrganizationCampaignStateLazyQueryTHookResult = ReturnType<typeof useOrganizationCampaignStateLazyQueryT>;
export type OrganizationCampaignStateQueryResultT = Apollo.QueryResult<OrganizationCampaignStateQueryT, OrganizationCampaignStateQueryVariablesT>;
export const OrganizationCategoriesDocumentT = gql`
    query OrganizationCategories {
  organization {
    id
    categories {
      id
      parentGuid
      guid
      name
      selected
      excluded
    }
  }
}
    `;

/**
 * __useOrganizationCategoriesQuery__
 *
 * To run a query within a React component, call `useOrganizationCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationCategoriesQueryT, OrganizationCategoriesQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationCategoriesQueryT, OrganizationCategoriesQueryVariablesT>(OrganizationCategoriesDocumentT, options);
      }
export function useOrganizationCategoriesLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationCategoriesQueryT, OrganizationCategoriesQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationCategoriesQueryT, OrganizationCategoriesQueryVariablesT>(OrganizationCategoriesDocumentT, options);
        }
export type OrganizationCategoriesQueryHookResult = ReturnType<typeof useOrganizationCategoriesQuery>;
export type OrganizationCategoriesLazyQueryTHookResult = ReturnType<typeof useOrganizationCategoriesLazyQueryT>;
export type OrganizationCategoriesQueryResultT = Apollo.QueryResult<OrganizationCategoriesQueryT, OrganizationCategoriesQueryVariablesT>;
export const OrganizationDataDocumentT = gql`
    query OrganizationData {
  organization {
    id
    shoptetUrl
    shoptetEshopName
    organizationDesign {
      id
      color1
      color2
      color3
      color4
      logo
    }
    selectedProducts {
      ...Product
    }
  }
}
    ${ProductFragmentDocT}`;

/**
 * __useOrganizationDataQuery__
 *
 * To run a query within a React component, call `useOrganizationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationDataQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationDataQueryT, OrganizationDataQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationDataQueryT, OrganizationDataQueryVariablesT>(OrganizationDataDocumentT, options);
      }
export function useOrganizationDataLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationDataQueryT, OrganizationDataQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationDataQueryT, OrganizationDataQueryVariablesT>(OrganizationDataDocumentT, options);
        }
export type OrganizationDataQueryHookResult = ReturnType<typeof useOrganizationDataQuery>;
export type OrganizationDataLazyQueryTHookResult = ReturnType<typeof useOrganizationDataLazyQueryT>;
export type OrganizationDataQueryResultT = Apollo.QueryResult<OrganizationDataQueryT, OrganizationDataQueryVariablesT>;
export const OrganizationEnabledFeatureFlagsDocumentT = gql`
    query OrganizationEnabledFeatureFlags {
  organization {
    id
    enabledFeatureFlags
  }
}
    `;

/**
 * __useOrganizationEnabledFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useOrganizationEnabledFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationEnabledFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationEnabledFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationEnabledFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationEnabledFeatureFlagsQueryT, OrganizationEnabledFeatureFlagsQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationEnabledFeatureFlagsQueryT, OrganizationEnabledFeatureFlagsQueryVariablesT>(OrganizationEnabledFeatureFlagsDocumentT, options);
      }
export function useOrganizationEnabledFeatureFlagsLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationEnabledFeatureFlagsQueryT, OrganizationEnabledFeatureFlagsQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationEnabledFeatureFlagsQueryT, OrganizationEnabledFeatureFlagsQueryVariablesT>(OrganizationEnabledFeatureFlagsDocumentT, options);
        }
export type OrganizationEnabledFeatureFlagsQueryHookResult = ReturnType<typeof useOrganizationEnabledFeatureFlagsQuery>;
export type OrganizationEnabledFeatureFlagsLazyQueryTHookResult = ReturnType<typeof useOrganizationEnabledFeatureFlagsLazyQueryT>;
export type OrganizationEnabledFeatureFlagsQueryResultT = Apollo.QueryResult<OrganizationEnabledFeatureFlagsQueryT, OrganizationEnabledFeatureFlagsQueryVariablesT>;
export const OrganizationMonthlyBudgetDocumentT = gql`
    query OrganizationMonthlyBudget {
  organization {
    id
    creditBalance {
      ...Money
    }
    googleAdsSetting {
      id
      state
      monthlyBudget {
        ...Money
      }
    }
    metaAdsSetting {
      id
      state
      monthlyBudget {
        ...Money
      }
    }
    monthlyBudget {
      ...Money
    }
    recommendedMonthlyBudget {
      ...Money
    }
  }
}
    ${MoneyFragmentDocT}`;

/**
 * __useOrganizationMonthlyBudgetQuery__
 *
 * To run a query within a React component, call `useOrganizationMonthlyBudgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationMonthlyBudgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationMonthlyBudgetQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationMonthlyBudgetQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationMonthlyBudgetQueryT, OrganizationMonthlyBudgetQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationMonthlyBudgetQueryT, OrganizationMonthlyBudgetQueryVariablesT>(OrganizationMonthlyBudgetDocumentT, options);
      }
export function useOrganizationMonthlyBudgetLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationMonthlyBudgetQueryT, OrganizationMonthlyBudgetQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationMonthlyBudgetQueryT, OrganizationMonthlyBudgetQueryVariablesT>(OrganizationMonthlyBudgetDocumentT, options);
        }
export type OrganizationMonthlyBudgetQueryHookResult = ReturnType<typeof useOrganizationMonthlyBudgetQuery>;
export type OrganizationMonthlyBudgetLazyQueryTHookResult = ReturnType<typeof useOrganizationMonthlyBudgetLazyQueryT>;
export type OrganizationMonthlyBudgetQueryResultT = Apollo.QueryResult<OrganizationMonthlyBudgetQueryT, OrganizationMonthlyBudgetQueryVariablesT>;
export const OrganizationPaymentsDocumentT = gql`
    query OrganizationPayments($limit: Int!, $page: Int!, $startCampaignFor: AdSystem) {
  organization {
    id
    payments(limit: $limit, page: $page, startCampaignFor: $startCampaignFor) {
      id
      state
      startCampaignFor
    }
  }
}
    `;

/**
 * __useOrganizationPaymentsQuery__
 *
 * To run a query within a React component, call `useOrganizationPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationPaymentsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      startCampaignFor: // value for 'startCampaignFor'
 *   },
 * });
 */
export function useOrganizationPaymentsQuery(baseOptions: Apollo.QueryHookOptions<OrganizationPaymentsQueryT, OrganizationPaymentsQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationPaymentsQueryT, OrganizationPaymentsQueryVariablesT>(OrganizationPaymentsDocumentT, options);
      }
export function useOrganizationPaymentsLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationPaymentsQueryT, OrganizationPaymentsQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationPaymentsQueryT, OrganizationPaymentsQueryVariablesT>(OrganizationPaymentsDocumentT, options);
        }
export type OrganizationPaymentsQueryHookResult = ReturnType<typeof useOrganizationPaymentsQuery>;
export type OrganizationPaymentsLazyQueryTHookResult = ReturnType<typeof useOrganizationPaymentsLazyQueryT>;
export type OrganizationPaymentsQueryResultT = Apollo.QueryResult<OrganizationPaymentsQueryT, OrganizationPaymentsQueryVariablesT>;
export const OrganizationPaymentsByAdSystemDocumentT = gql`
    query OrganizationPaymentsByAdSystem($startCampaignFor: AdSystem!, $limit: Int!, $page: Int!) {
  organization {
    id
    payments(startCampaignFor: $startCampaignFor, limit: $limit, page: $page) {
      id
      state
      startCampaignFor
    }
  }
}
    `;

/**
 * __useOrganizationPaymentsByAdSystemQuery__
 *
 * To run a query within a React component, call `useOrganizationPaymentsByAdSystemQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationPaymentsByAdSystemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationPaymentsByAdSystemQuery({
 *   variables: {
 *      startCampaignFor: // value for 'startCampaignFor'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useOrganizationPaymentsByAdSystemQuery(baseOptions: Apollo.QueryHookOptions<OrganizationPaymentsByAdSystemQueryT, OrganizationPaymentsByAdSystemQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationPaymentsByAdSystemQueryT, OrganizationPaymentsByAdSystemQueryVariablesT>(OrganizationPaymentsByAdSystemDocumentT, options);
      }
export function useOrganizationPaymentsByAdSystemLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationPaymentsByAdSystemQueryT, OrganizationPaymentsByAdSystemQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationPaymentsByAdSystemQueryT, OrganizationPaymentsByAdSystemQueryVariablesT>(OrganizationPaymentsByAdSystemDocumentT, options);
        }
export type OrganizationPaymentsByAdSystemQueryHookResult = ReturnType<typeof useOrganizationPaymentsByAdSystemQuery>;
export type OrganizationPaymentsByAdSystemLazyQueryTHookResult = ReturnType<typeof useOrganizationPaymentsByAdSystemLazyQueryT>;
export type OrganizationPaymentsByAdSystemQueryResultT = Apollo.QueryResult<OrganizationPaymentsByAdSystemQueryT, OrganizationPaymentsByAdSystemQueryVariablesT>;
export const OrganizationProductsCountDocumentT = gql`
    query OrganizationProductsCount {
  organization {
    id
    notReadySteps
    productsCount
    categoriesCount
    productFlagsCount
    productsCountToSynchronize
  }
}
    `;

/**
 * __useOrganizationProductsCountQuery__
 *
 * To run a query within a React component, call `useOrganizationProductsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationProductsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationProductsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationProductsCountQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationProductsCountQueryT, OrganizationProductsCountQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationProductsCountQueryT, OrganizationProductsCountQueryVariablesT>(OrganizationProductsCountDocumentT, options);
      }
export function useOrganizationProductsCountLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationProductsCountQueryT, OrganizationProductsCountQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationProductsCountQueryT, OrganizationProductsCountQueryVariablesT>(OrganizationProductsCountDocumentT, options);
        }
export type OrganizationProductsCountQueryHookResult = ReturnType<typeof useOrganizationProductsCountQuery>;
export type OrganizationProductsCountLazyQueryTHookResult = ReturnType<typeof useOrganizationProductsCountLazyQueryT>;
export type OrganizationProductsCountQueryResultT = Apollo.QueryResult<OrganizationProductsCountQueryT, OrganizationProductsCountQueryVariablesT>;
export const OrganizationPropertiesDocumentT = gql`
    query OrganizationProperties {
  organization {
    id
    properties
  }
}
    `;

/**
 * __useOrganizationPropertiesQuery__
 *
 * To run a query within a React component, call `useOrganizationPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationPropertiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationPropertiesQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationPropertiesQueryT, OrganizationPropertiesQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationPropertiesQueryT, OrganizationPropertiesQueryVariablesT>(OrganizationPropertiesDocumentT, options);
      }
export function useOrganizationPropertiesLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationPropertiesQueryT, OrganizationPropertiesQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationPropertiesQueryT, OrganizationPropertiesQueryVariablesT>(OrganizationPropertiesDocumentT, options);
        }
export type OrganizationPropertiesQueryHookResult = ReturnType<typeof useOrganizationPropertiesQuery>;
export type OrganizationPropertiesLazyQueryTHookResult = ReturnType<typeof useOrganizationPropertiesLazyQueryT>;
export type OrganizationPropertiesQueryResultT = Apollo.QueryResult<OrganizationPropertiesQueryT, OrganizationPropertiesQueryVariablesT>;
export const OrganizationSettingsDocumentT = gql`
    query OrganizationSettings {
  organization {
    id
    biddingScheme
    audienceSignals
    extendedConversions
    state
    consultationRequestedAt
    properties
  }
  user {
    id
    email
  }
}
    `;

/**
 * __useOrganizationSettingsQuery__
 *
 * To run a query within a React component, call `useOrganizationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationSettingsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationSettingsQueryT, OrganizationSettingsQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationSettingsQueryT, OrganizationSettingsQueryVariablesT>(OrganizationSettingsDocumentT, options);
      }
export function useOrganizationSettingsLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationSettingsQueryT, OrganizationSettingsQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationSettingsQueryT, OrganizationSettingsQueryVariablesT>(OrganizationSettingsDocumentT, options);
        }
export type OrganizationSettingsQueryHookResult = ReturnType<typeof useOrganizationSettingsQuery>;
export type OrganizationSettingsLazyQueryTHookResult = ReturnType<typeof useOrganizationSettingsLazyQueryT>;
export type OrganizationSettingsQueryResultT = Apollo.QueryResult<OrganizationSettingsQueryT, OrganizationSettingsQueryVariablesT>;
export const OrganizationStateDocumentT = gql`
    query OrganizationState($dateTo: ISO8601Date!) {
  organization {
    id
    state
    creditBalance {
      ...Money
    }
    usedCredits {
      ...Money
    }
    showLearningBanner
    summaryStats {
      id
      impressions
    }
    campaignOptimizations(dateTo: $dateTo, limit: 1, page: 1) {
      id
    }
  }
}
    ${MoneyFragmentDocT}`;

/**
 * __useOrganizationStateQuery__
 *
 * To run a query within a React component, call `useOrganizationStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationStateQuery({
 *   variables: {
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useOrganizationStateQuery(baseOptions: Apollo.QueryHookOptions<OrganizationStateQueryT, OrganizationStateQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationStateQueryT, OrganizationStateQueryVariablesT>(OrganizationStateDocumentT, options);
      }
export function useOrganizationStateLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationStateQueryT, OrganizationStateQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationStateQueryT, OrganizationStateQueryVariablesT>(OrganizationStateDocumentT, options);
        }
export type OrganizationStateQueryHookResult = ReturnType<typeof useOrganizationStateQuery>;
export type OrganizationStateLazyQueryTHookResult = ReturnType<typeof useOrganizationStateLazyQueryT>;
export type OrganizationStateQueryResultT = Apollo.QueryResult<OrganizationStateQueryT, OrganizationStateQueryVariablesT>;
export const OrganizationValidateImagesDocumentT = gql`
    query OrganizationValidateImages {
  organization {
    id
    validateImages {
      ...ValidationResult
    }
    validateDraftImages {
      ...ValidationResult
    }
  }
}
    ${ValidationResultFragmentDocT}`;

/**
 * __useOrganizationValidateImagesQuery__
 *
 * To run a query within a React component, call `useOrganizationValidateImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationValidateImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationValidateImagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationValidateImagesQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationValidateImagesQueryT, OrganizationValidateImagesQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationValidateImagesQueryT, OrganizationValidateImagesQueryVariablesT>(OrganizationValidateImagesDocumentT, options);
      }
export function useOrganizationValidateImagesLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationValidateImagesQueryT, OrganizationValidateImagesQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationValidateImagesQueryT, OrganizationValidateImagesQueryVariablesT>(OrganizationValidateImagesDocumentT, options);
        }
export type OrganizationValidateImagesQueryHookResult = ReturnType<typeof useOrganizationValidateImagesQuery>;
export type OrganizationValidateImagesLazyQueryTHookResult = ReturnType<typeof useOrganizationValidateImagesLazyQueryT>;
export type OrganizationValidateImagesQueryResultT = Apollo.QueryResult<OrganizationValidateImagesQueryT, OrganizationValidateImagesQueryVariablesT>;
export const OrganizationValidateTextsDocumentT = gql`
    query OrganizationValidateTexts {
  organization {
    id
    validateTexts {
      ...ValidationResult
    }
    validateDraftTexts {
      ...ValidationResult
    }
  }
}
    ${ValidationResultFragmentDocT}`;

/**
 * __useOrganizationValidateTextsQuery__
 *
 * To run a query within a React component, call `useOrganizationValidateTextsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationValidateTextsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationValidateTextsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationValidateTextsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationValidateTextsQueryT, OrganizationValidateTextsQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationValidateTextsQueryT, OrganizationValidateTextsQueryVariablesT>(OrganizationValidateTextsDocumentT, options);
      }
export function useOrganizationValidateTextsLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationValidateTextsQueryT, OrganizationValidateTextsQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationValidateTextsQueryT, OrganizationValidateTextsQueryVariablesT>(OrganizationValidateTextsDocumentT, options);
        }
export type OrganizationValidateTextsQueryHookResult = ReturnType<typeof useOrganizationValidateTextsQuery>;
export type OrganizationValidateTextsLazyQueryTHookResult = ReturnType<typeof useOrganizationValidateTextsLazyQueryT>;
export type OrganizationValidateTextsQueryResultT = Apollo.QueryResult<OrganizationValidateTextsQueryT, OrganizationValidateTextsQueryVariablesT>;
export const OrganizationWizardStepsDocumentT = gql`
    query OrganizationWizardSteps {
  organization {
    id
    googleAdsSetting {
      id
      wizardStep
    }
    metaAdsSetting {
      id
      wizardStep
    }
  }
}
    `;

/**
 * __useOrganizationWizardStepsQuery__
 *
 * To run a query within a React component, call `useOrganizationWizardStepsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationWizardStepsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationWizardStepsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationWizardStepsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationWizardStepsQueryT, OrganizationWizardStepsQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationWizardStepsQueryT, OrganizationWizardStepsQueryVariablesT>(OrganizationWizardStepsDocumentT, options);
      }
export function useOrganizationWizardStepsLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationWizardStepsQueryT, OrganizationWizardStepsQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationWizardStepsQueryT, OrganizationWizardStepsQueryVariablesT>(OrganizationWizardStepsDocumentT, options);
        }
export type OrganizationWizardStepsQueryHookResult = ReturnType<typeof useOrganizationWizardStepsQuery>;
export type OrganizationWizardStepsLazyQueryTHookResult = ReturnType<typeof useOrganizationWizardStepsLazyQueryT>;
export type OrganizationWizardStepsQueryResultT = Apollo.QueryResult<OrganizationWizardStepsQueryT, OrganizationWizardStepsQueryVariablesT>;
export const PerformanceStatsDocumentT = gql`
    query PerformanceStats($dateFrom: ISO8601Date, $dateTo: ISO8601Date!, $adSystem: AdSystem = GOOGLE_ADS) {
  organization {
    id
    performanceStats(dateFrom: $dateFrom, dateTo: $dateTo, adSystem: $adSystem) {
      id
      date
      clicks
      impressions
      ctr
      conversionValue {
        ...Money
      }
      conversions
      credit {
        ...Money
      }
      averageConversionValue {
        ...Money
      }
      pno
      unoptimizedClicks
      unoptimizedConversionValue {
        ...Money
      }
      unoptimizedConversions
      unoptimizedImpressions
    }
  }
}
    ${MoneyFragmentDocT}`;

/**
 * __usePerformanceStatsQuery__
 *
 * To run a query within a React component, call `usePerformanceStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerformanceStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerformanceStatsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      adSystem: // value for 'adSystem'
 *   },
 * });
 */
export function usePerformanceStatsQuery(baseOptions: Apollo.QueryHookOptions<PerformanceStatsQueryT, PerformanceStatsQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PerformanceStatsQueryT, PerformanceStatsQueryVariablesT>(PerformanceStatsDocumentT, options);
      }
export function usePerformanceStatsLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<PerformanceStatsQueryT, PerformanceStatsQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PerformanceStatsQueryT, PerformanceStatsQueryVariablesT>(PerformanceStatsDocumentT, options);
        }
export type PerformanceStatsQueryHookResult = ReturnType<typeof usePerformanceStatsQuery>;
export type PerformanceStatsLazyQueryTHookResult = ReturnType<typeof usePerformanceStatsLazyQueryT>;
export type PerformanceStatsQueryResultT = Apollo.QueryResult<PerformanceStatsQueryT, PerformanceStatsQueryVariablesT>;
export const ProductExclusionDocumentT = gql`
    query ProductExclusion($adSystem: AdSystem!) {
  organization {
    id
    productsCount
    selectableProductsCount(adSystem: $adSystem)
    bannedProductsCount(adSystem: $adSystem)
    outOfStockProductsCount
    excludedProductsCount(adSystem: $adSystem)
    excludedProductFlagsProductsCount(adSystem: $adSystem)
    excludedCategoriesProductsCount(adSystem: $adSystem)
    productFlags {
      id
      name
      guid
      excludedGoogleAds
      excludedMetaAds
      productsCount
    }
    categories {
      id
      parentGuid
      guid
      name
      path
      selected
      excludedGoogleAds
      excludedMetaAds
    }
  }
}
    `;

/**
 * __useProductExclusionQuery__
 *
 * To run a query within a React component, call `useProductExclusionQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductExclusionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductExclusionQuery({
 *   variables: {
 *      adSystem: // value for 'adSystem'
 *   },
 * });
 */
export function useProductExclusionQuery(baseOptions: Apollo.QueryHookOptions<ProductExclusionQueryT, ProductExclusionQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductExclusionQueryT, ProductExclusionQueryVariablesT>(ProductExclusionDocumentT, options);
      }
export function useProductExclusionLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<ProductExclusionQueryT, ProductExclusionQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductExclusionQueryT, ProductExclusionQueryVariablesT>(ProductExclusionDocumentT, options);
        }
export type ProductExclusionQueryHookResult = ReturnType<typeof useProductExclusionQuery>;
export type ProductExclusionLazyQueryTHookResult = ReturnType<typeof useProductExclusionLazyQueryT>;
export type ProductExclusionQueryResultT = Apollo.QueryResult<ProductExclusionQueryT, ProductExclusionQueryVariablesT>;
export const ProductsDocumentT = gql`
    query Products($gmcIssueId: ID, $page: Int!, $limit: Int!) {
  organization {
    id
    products(gmcIssueId: $gmcIssueId, page: $page, limit: $limit) {
      id
      imageUrl
      name
      price {
        ...Money
      }
      shoptetProductDetailUrl
    }
  }
}
    ${MoneyFragmentDocT}`;

/**
 * __useProductsQuery__
 *
 * To run a query within a React component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQuery({
 *   variables: {
 *      gmcIssueId: // value for 'gmcIssueId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useProductsQuery(baseOptions: Apollo.QueryHookOptions<ProductsQueryT, ProductsQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsQueryT, ProductsQueryVariablesT>(ProductsDocumentT, options);
      }
export function useProductsLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<ProductsQueryT, ProductsQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsQueryT, ProductsQueryVariablesT>(ProductsDocumentT, options);
        }
export type ProductsQueryHookResult = ReturnType<typeof useProductsQuery>;
export type ProductsLazyQueryTHookResult = ReturnType<typeof useProductsLazyQueryT>;
export type ProductsQueryResultT = Apollo.QueryResult<ProductsQueryT, ProductsQueryVariablesT>;
export const StopCampaignQuestionnaireStatusDocumentT = gql`
    query StopCampaignQuestionnaireStatus {
  organization {
    id
    properties
    shoptetId
  }
  user {
    id
    email
  }
}
    `;

/**
 * __useStopCampaignQuestionnaireStatusQuery__
 *
 * To run a query within a React component, call `useStopCampaignQuestionnaireStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useStopCampaignQuestionnaireStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStopCampaignQuestionnaireStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useStopCampaignQuestionnaireStatusQuery(baseOptions?: Apollo.QueryHookOptions<StopCampaignQuestionnaireStatusQueryT, StopCampaignQuestionnaireStatusQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StopCampaignQuestionnaireStatusQueryT, StopCampaignQuestionnaireStatusQueryVariablesT>(StopCampaignQuestionnaireStatusDocumentT, options);
      }
export function useStopCampaignQuestionnaireStatusLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<StopCampaignQuestionnaireStatusQueryT, StopCampaignQuestionnaireStatusQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StopCampaignQuestionnaireStatusQueryT, StopCampaignQuestionnaireStatusQueryVariablesT>(StopCampaignQuestionnaireStatusDocumentT, options);
        }
export type StopCampaignQuestionnaireStatusQueryHookResult = ReturnType<typeof useStopCampaignQuestionnaireStatusQuery>;
export type StopCampaignQuestionnaireStatusLazyQueryTHookResult = ReturnType<typeof useStopCampaignQuestionnaireStatusLazyQueryT>;
export type StopCampaignQuestionnaireStatusQueryResultT = Apollo.QueryResult<StopCampaignQuestionnaireStatusQueryT, StopCampaignQuestionnaireStatusQueryVariablesT>;
export const SummaryStatsDocumentT = gql`
    query SummaryStats {
  organization {
    id
    summaryStats {
      id
      ...SummaryStats
    }
  }
}
    ${SummaryStatsFragmentDocT}`;

/**
 * __useSummaryStatsQuery__
 *
 * To run a query within a React component, call `useSummaryStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummaryStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummaryStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSummaryStatsQuery(baseOptions?: Apollo.QueryHookOptions<SummaryStatsQueryT, SummaryStatsQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummaryStatsQueryT, SummaryStatsQueryVariablesT>(SummaryStatsDocumentT, options);
      }
export function useSummaryStatsLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<SummaryStatsQueryT, SummaryStatsQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummaryStatsQueryT, SummaryStatsQueryVariablesT>(SummaryStatsDocumentT, options);
        }
export type SummaryStatsQueryHookResult = ReturnType<typeof useSummaryStatsQuery>;
export type SummaryStatsLazyQueryTHookResult = ReturnType<typeof useSummaryStatsLazyQueryT>;
export type SummaryStatsQueryResultT = Apollo.QueryResult<SummaryStatsQueryT, SummaryStatsQueryVariablesT>;
export const TextSuggestionsDocumentT = gql`
    query TextSuggestions($kind: SuggestionKind!, $limit: Int) {
  organization {
    id
    textSuggestions(kind: $kind, limit: $limit) {
      id
      content
      kind
      assetLineCount
      disapprovedAt
    }
  }
}
    `;

/**
 * __useTextSuggestionsQuery__
 *
 * To run a query within a React component, call `useTextSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTextSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTextSuggestionsQuery({
 *   variables: {
 *      kind: // value for 'kind'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTextSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<TextSuggestionsQueryT, TextSuggestionsQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TextSuggestionsQueryT, TextSuggestionsQueryVariablesT>(TextSuggestionsDocumentT, options);
      }
export function useTextSuggestionsLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<TextSuggestionsQueryT, TextSuggestionsQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TextSuggestionsQueryT, TextSuggestionsQueryVariablesT>(TextSuggestionsDocumentT, options);
        }
export type TextSuggestionsQueryHookResult = ReturnType<typeof useTextSuggestionsQuery>;
export type TextSuggestionsLazyQueryTHookResult = ReturnType<typeof useTextSuggestionsLazyQueryT>;
export type TextSuggestionsQueryResultT = Apollo.QueryResult<TextSuggestionsQueryT, TextSuggestionsQueryVariablesT>;
export const UnoptimizedPerformanceStatsDocumentT = gql`
    query UnoptimizedPerformanceStats($dateFrom: ISO8601Date, $dateTo: ISO8601Date!, $adSystem: AdSystem = GOOGLE_ADS) {
  organization {
    id
    performanceStats(dateFrom: $dateFrom, dateTo: $dateTo, adSystem: $adSystem) {
      id
      date
      unoptimizedClicks
      unoptimizedConversionValue {
        ...Money
      }
      unoptimizedConversions
      unoptimizedImpressions
    }
  }
}
    ${MoneyFragmentDocT}`;

/**
 * __useUnoptimizedPerformanceStatsQuery__
 *
 * To run a query within a React component, call `useUnoptimizedPerformanceStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnoptimizedPerformanceStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnoptimizedPerformanceStatsQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      adSystem: // value for 'adSystem'
 *   },
 * });
 */
export function useUnoptimizedPerformanceStatsQuery(baseOptions: Apollo.QueryHookOptions<UnoptimizedPerformanceStatsQueryT, UnoptimizedPerformanceStatsQueryVariablesT>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnoptimizedPerformanceStatsQueryT, UnoptimizedPerformanceStatsQueryVariablesT>(UnoptimizedPerformanceStatsDocumentT, options);
      }
export function useUnoptimizedPerformanceStatsLazyQueryT(baseOptions?: Apollo.LazyQueryHookOptions<UnoptimizedPerformanceStatsQueryT, UnoptimizedPerformanceStatsQueryVariablesT>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnoptimizedPerformanceStatsQueryT, UnoptimizedPerformanceStatsQueryVariablesT>(UnoptimizedPerformanceStatsDocumentT, options);
        }
export type UnoptimizedPerformanceStatsQueryHookResult = ReturnType<typeof useUnoptimizedPerformanceStatsQuery>;
export type UnoptimizedPerformanceStatsLazyQueryTHookResult = ReturnType<typeof useUnoptimizedPerformanceStatsLazyQueryT>;
export type UnoptimizedPerformanceStatsQueryResultT = Apollo.QueryResult<UnoptimizedPerformanceStatsQueryT, UnoptimizedPerformanceStatsQueryVariablesT>;